/* resources/assets/js/node_modules/skeets.modal/modal.js */
/*
* Created by Skeets 2017-12-04
* Recreated by Skeets 2020-01-25, added promptInput() and ShowAlert() to make it modal.js instead of confirm.js
* */

function showAlert(obj, title)
{
  if (typeof obj !== "object") {
    obj = {msg: obj};
  }
  if (typeof title !== "undefined" && title !== null && title.length > 0) {
    obj.title = title;
  }
  obj = modalJs.prepareObj(obj, {title: "Info", msg: "", noCancel: true, yes: "Ok"});
  modalJs.appendDialog(obj);
  modalJs.releaseBindings(obj);
  modalJs.elements.$modal.modal("show");
}

function onConfirm(obj)
{
  obj = modalJs.prepareObj(obj);

  if (typeof obj.skip !== "undefined" && obj.skip === true) {
    obj.yesCallback(obj.yesParams);
    obj.yesHiddenCallback(obj.yesParams);
    return true;
  }

  modalJs.appendDialog(obj);
  modalJs.bindings(obj);
  modalJs.elements.$modal.modal("show");
}

function promptInput(vars, obj)
{
  obj           = modalJs.prepareObj(obj, {msg: "", title: "Set value", yes: "Go"});
  var inputHtml = modalJs.prepareInputHtml(vars);
  obj.msg += inputHtml;
  modalJs.appendDialog(obj);
  modalJs.bindings(obj);
  modalJs.elements.$modal.on('shown.bs.modal', function() {
    var $firstInput = modalJs.elements.$modal.find("input:first");
    if ($firstInput.length) {
      $firstInput.focus();
      $firstInput[0].select();
    }

    modalJs.elements.$modal.off('shown.bs.modal');
  });
  modalJs.elements.$modal.modal("show");
  if (typeof conditionalJsAuto !== "undefined") {
    conditionalJsAuto(modalJs.elements.$body);
  }
  var $bootstrapTooltips = modalJs.elements.$body.find("[data-toggle='tooltip']");
  if ($bootstrapTooltips.length) {
    $bootstrapTooltips.tooltip();
  }

}

var modalJs = {
  dialogAppended  : false,
  cancelBtnClass  : "btn-secondary",
  modalClass      : "",
  class           : "",
  elements        : {
    $modal           : null,
    $dialog          : null,
    $content         : null,
    $header          : null,
    $body            : null,
    $footer          : null,
    $title           : null,
    $cancel          : null,
    $ok              : null,
    $elementPreserver: null
  },
  config          : function(options) {
    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        modalJs[option] = options[option];
      }
    }
  },
  adjustTimer     : function($button) {
    var $timerEle    = $button.find(".modalJs-timer");
    var currentTimer = $button.data("timer") - 1;
    $button.data("timer", currentTimer);
    $timerEle.html("(" + currentTimer + ")");
    if (currentTimer > 0) {

      clearTimeout($button.data("timeout"));
      var thisTimeout = setTimeout(function() {
        modalJs.adjustTimer($button);
      }, 1000);
      $button.data("timeout", thisTimeout);
    }
    else {
      $timerEle.remove();
      $button.removeClass("disabled").prop("disabled", false);
    }
  },
  appendDialog    : function(obj) {
    if (modalJs.dialogAppended) {
      modalJs.elements.$title.html(obj.title);
      modalJs.elements.$body.html(obj.msg);
      modalJs.renderFooter(modalJs.elements.$footer, obj);
      modalJs.startTimer(modalJs.elements.$ok, obj.timer);
      modalJs.elements.$modal.on('hidden.bs.modal', function() {
        modalJs.elements.$body.html("");
      });
      return true;
    }
    var elements      = {};
    elements.$form    = $("<form/>", {id: "modal-js-form"});
    elements.$modal   = $("<div/>", {
      class: "modal fade " + modalJs.class,
      role : "dialog",
      id   : "confirm-js-dialog"
    });
    elements.$dialog  = $("<div/>", {class: "modal-dialog", role: "document"});
    elements.$content = $("<div/>", {class: "modal-content " + modalJs.modalClass});
    elements.$header  = $("<div/>", {class: "modal-header"});
    elements.$body    = $("<div/>", {class: "modal-body"});
    elements.$footer  = $("<div/>", {class: "modal-footer"});
    elements.$title   = $("<h5/>", {class: "modal-title"});


    elements.$title.append([obj.icon, obj.title]);
    elements.$body.append(obj.msg);


    elements.$header.append(elements.$title);
    elements.$content.append([elements.$header, elements.$body, elements.$footer]);
    elements.$dialog.append(elements.$content);
    elements.$modal.append(elements.$dialog);
    elements.$form.append(elements.$modal);


    modalJs.elements = elements;
    modalJs.renderFooter(elements.$footer, obj);

    modalJs.startTimer(elements.$ok, obj.timer);

    $("body").append(elements.$form);
    modalJs.elements.$modal.on('hidden.bs.modal', function() {
      modalJs.elements.$body.html("");
    });
    modalJs.dialogAppended = true;
  },
  renderFooter    : function($footer, obj) {
    $footer.html("");
    var $cancel = $("<button/>", {type: "button", class: "btn " + modalJs.cancelBtnClass, "data-dismiss": "modal"});
    var $ok     = $("<button/>", {type: "submit", class: "btn btn-" + obj.yesType});

    $cancel.html(obj.no);
    $ok.html(obj.yes);
    if (typeof obj.customFooter !== "undefined" && obj.customFooter !== null) {
      $footer.html(obj.customFooter);
      if ($footer.find(".modalJs-cancel").length) {
        modalJs.elements.$cancel = $footer.find(".modalJs-cancel");
      }
      else {
        modalJs.elements.$cancel = $cancel;
      }
      if ($footer.find(".modalJs-submit").length) {
        modalJs.elements.$ok = $footer.find(".modalJs-submit");
      }
      else {
        modalJs.elements.$ok = $ok;
      }
    }
    else {
      $footer.append([$cancel, $ok]);
      modalJs.elements.$cancel = $cancel;
      modalJs.elements.$ok     = $ok;
      modalJs.elements.$ok.attr("class", "btn btn-" + obj.yesType);
    }

    if (obj.noCancel) {
      modalJs.elements.$cancel.hide();
    }
    else {
      modalJs.elements.$cancel.show();
    }
  },
  setDefaults     : function(obj, overrideDefaults) {
    var defaults = {
      title            : "Are you sure?",
      icon             : "",
      msg              : "Are you sure?",
      yes              : "Yes",
      no               : "Cancel",
      hideOnSubmit     : true,
      beforeInput      : "",
      afterInput       : "",
      customFooter     : null,
      onHidden         : false,
      yesCallback      : function() {
      },
      yesHiddenCallback: function() {
      },
      yesParams        : [],
      yesType          : "success",
      noCallback       : function() {
      },
      noHiddenCallback : function() {
      },
      noParams         : [],
      noCancel         : false,
      timer            : 0

    };

    for (var overrideProperty in overrideDefaults) {
      if (overrideDefaults.hasOwnProperty(overrideProperty)) {
        if (!obj.hasOwnProperty(overrideProperty)) {
          obj[overrideProperty] = overrideDefaults[overrideProperty];
        }
      }
    }
    for (var property in defaults) {
      if (defaults.hasOwnProperty(property)) {
        if (!obj.hasOwnProperty(property)) {
          obj[property] = defaults[property];
        }
      }
    }

    return obj;
  },
  setAliases      : function(obj) {
    var aliases = {msg: ["body"], yesCallback: ["callback"], yes: ["go"], no: ["cancel"]};

    for (var aliasedField in aliases) {
      if (aliases.hasOwnProperty(aliasedField)) {
        aliases[aliasedField].forEach(function(alias) {
          if (obj.hasOwnProperty(alias)) {
            obj[aliasedField] = obj[alias];
          }
        });
      }
    }
    return obj;
  },
  releaseBindings : function() {
    modalJs.elements.$form.off().on("submit", function(e) {
      e.preventDefault();
      modalJs.elements.$modal.modal("hide");
    });
    modalJs.elements.$cancel.off();
    modalJs.elements.$modal.off();
  },
  bindings        : function(obj) {
    var $modal = modalJs.elements.$modal;

    modalJs.elements.$form.off().on("submit", function(e) {
      e.preventDefault();
      var data     = {};
      var formData = new FormData(this);

      formData.forEach(function(value, property) {
        data[property] = value;
      });


      for (var attrName in obj.yesParams) {
        if (obj.yesParams.hasOwnProperty(attrName)) {
          data[attrName] = obj.yesParams[attrName];
        }
      }

      if (obj.onHidden) {
        $modal.on('hidden.bs.modal', function() {
          obj.yesCallback(data);
          $modal.off('hidden.bs.modal');
        });
      }
      else {
        obj.yesCallback(data);
      }
      $modal.on('hidden.bs.modal', function() {
        obj.yesHiddenCallback(window, data);
        $modal.off('hidden.bs.modal');
      });
      if (obj.hideOnSubmit) {
        $modal.modal("hide");
      }
    });

    modalJs.elements.$cancel.off().on("click", function() {
      if (obj.onHidden) {
        $modal.on('hidden.bs.modal', function(e) {
          obj.noCallback(obj.noParams);
          $modal.off('hidden.bs.modal');
        });
      }
      else {
        obj.noCallback(obj.noParams);
      }
      $modal.on('hidden.bs.modal', function(e) {
        obj.noHiddenCallback(window, obj.noParams);
        $modal.off('hidden.bs.modal');
      });
      $modal.modal("hide");
    });
  },
  inputBuilders   : {
    text     : function(options, name, id) {
      var labelDivAttr;
      if (typeof options.labelWidth !== "undefined" && options.labelWidth !== null) {
        labelDivAttr = " style='width: " + options.labelWidth + "px;' ";
      }
      var output = "";
      output += "<div class='row mb-3'>";
      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        output += "<div class='col-auto d-flex align-items-center'" + labelDivAttr + ">";
        output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
        output += "</div>";
      }
      output += "<div class='col'>";
      output +=
        "<input " +
        options.attr +
        " value='" +
        modalJs.escapeHtml(options.default) +
        "'" +
        " type='" +
        options.inputType +
        "' id='" +
        id +
        "' class='form-control " +
        options.class +
        "' name='" +
        name +
        "'";
      if (typeof options.placeholder !== "undefined" && options.placeholder !== null && options.placeholder.length > 0) {
        output += " placeholder='" + options.placeholder + "'";
      }
      output += ">";
      output += "</div>";
      output += "</div>";
      return output;
    }, hidden: function(options, name, id) {
      var output = "";
      output +=
        "<input " +
        options.attr +
        " value='" +
        modalJs.escapeHtml(options.default) +
        "'" +
        " type='hidden' id='" +
        id +
        "' class='form-control " +
        options.class +
        "' name='" +
        name +
        "'";
      output += ">";
      return output;
    },
    textarea : function(options, name, id) {
      var output = "";
      output += "<div class='row'>";
      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        output += "<div class='col' >";
        output += "<label for='" + id + "'>" + options.label + "</label>";
        output += "</div>";
      }
      output += "</div>";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      output += "<textarea " + options.attr + " id='" + id + "' class='form-control " + options.class + "' name='" + name + "'";
      if (typeof options.placeholder !== "undefined" && options.placeholder !== null && options.placeholder.length > 0) {
        output += " placeholder='" + options.placeholder + "'";
      }
      output += ">";
      output += modalJs.escapeHtml(options.default)
                + "</textarea>";
      output += "</div>";
      output += "</div>";
      return output;
    },
    select   : function(options, name, id) {
      var labelDivAttr;
      if (typeof options.labelWidth !== "undefined" && options.labelWidth !== null) {
        labelDivAttr = " style='width: " + options.labelWidth + "px;' ";
      }
      if (typeof options.selectOptions === "undefined" || options.selectOptions === null) {
        if (typeof options.radioOptions !== "undefined" && options.radioOptions !== null) {
          options.selectOptions = options.radioOptions;
        }
      }
      var selected = "";
      var output   = "";
      output += "<div class='row mb-3'>";
      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        output += "<div class='col-auto d-flex align-items-center'" + labelDivAttr + ">";
        output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
        output += "</div>";
      }
      output += "<div class='col'>";
      output +=
        "<select " + options.attr + " id='" + id + "' class='form-control " + options.class + "' name='" + name + "'>";
      for (var value in options.selectOptions) {
        selected = "";
        if (value === options.default) {
          selected = " selected ";
        }
        if (options.selectOptions.hasOwnProperty(value)) {
          output += "<option " + selected + " value='" + value + "'>" + options.selectOptions[value] + "</option>";
        }
      }
      output += "</select>";
      output += "</div>";
      output += "</div>";
      return output;
    },
    radio    : function(options, name, id) {
      if (typeof options.radioOptions === "undefined" || options.radioOptions === null) {
        if (typeof options.selectOptions !== "undefined" && options.selectOptions !== null) {
          options.radioOptions = options.selectOptions;
        }
      }
      var output = "";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      // Took out the card, I don't think it's needed?
      // output += "<div class='card'>";

      if (typeof options.hideLabel === "undefined" || options.hideLabel !== true) {
        // output += "<div class='card-header'>";
        output += "<label class='mb-0' for='" + id + "'>" + options.label + "</label>";
        // output += "</div>";
      }
      // output += "<div class='card-body'>";
      for (var value in options.radioOptions) {
        if (options.radioOptions.hasOwnProperty(value)) {
          var checked = "";
          if (value === options.default) {
            checked = " checked ";
          }
          output += "<label  " + options.attr + "  class='d-block " + options.class + "' >" +
                    "<input" + checked + " type='radio' name='" + name + "' value='" + value + "'>&nbsp;" + options.radioOptions[value] +
                    "</label>";
        }
      }
      output += "</div></div>";
      // output += "</div></div>";
      return output;
    },
    checkbox : function(options, name, id) {
      var output  = "";
      output += "<div class='row mb-3'>";
      output += "<div class='col'>";
      var checked = "";
      if (typeof options.checked !== "undefined" && (options.checked === true || options.checked === "true" || options.checked === "yes")) {
        checked = " checked ";
      }
      var value = "";
      if (typeof options.default !== "undefined" && options.default !== null && options.length > 0) {
        value = " value='" + modalJs.escapeHtml(options.default) + "'";
      }
      if (typeof options.value !== "undefined" && options.value !== null && options.length > 0) {
        value = " value='" + modalJs.escapeHtml(options.value) + "'";
      }
      output += "<label " + options.attr + "  class='" + options.class + "' >" +
                "<input" + checked + " type='checkbox' name='" + name + "'" + value + ">&nbsp;" + options.label +
                "</label>";
      output += "</div>";
      output += "</div>";
      return output;
    },
  },
  prepareInputHtml: function(vars, allowDuplicates) {
    var id;
    if (typeof allowDuplicates === "undefined" || allowDuplicates === null) {
      allowDuplicates = true;
    }
    if (typeof vars !== "object") {
      var tempVar   = vars;
      vars          = {};
      vars[tempVar] = tempVar;
    }

    var inputs  = "";
    var countId = 0;
    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        id                    = "prompt-js-input-id-" + countId;
        vars[prop].element_id = id;
        countId++;
      }
    }

    countId = 0;

    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        if (!allowDuplicates && modalJs.dialogAppended && modalJs.elements.$body.find("[name='" + prop + "']").length) {
          continue;
        }
        if (typeof vars[prop] !== "object") {
          vars[prop] = {"label": vars[prop]};
        }
        if (typeof vars[prop].attr === "undefined" || vars[prop].attr === null) {
          vars[prop].attr = "";
        }
        if (typeof vars[prop].class === "undefined" || vars[prop].class === null) {
          vars[prop].class = "";
        }
        id = vars[prop].element_id;
        if (typeof vars[prop].inputType === "undefined") {
          vars[prop].inputType = "text";
        }

        if (typeof vars[prop].showWhenField !== "undefined" && vars[prop].showWhenField !== null
            && typeof vars[prop].showWhenValue !== "undefined" && vars[prop].showWhenValue !== null) {
          var thisId = modalJs.getIdForVar(vars, vars[prop].showWhenField);
          inputs += "<div class='conditional' data-conditional-target='#" + modalJs.escapeHtml(thisId) + "'" +
                    " data-conditional-value='" + modalJs.escapeHtml(vars[prop].showWhenValue) + "'>";
        }
        else {
          inputs += "<div>";
        }


        if (typeof vars[prop].beforeInput !== "undefined" && vars[prop].beforeInput !== null) {
          inputs += vars[prop].beforeInput;
        }
        switch (vars[prop].inputType) {
          case "text":
          default:
            inputs += modalJs.inputBuilders.text(vars[prop], prop, id);
            break;
          case "textarea":
            inputs += modalJs.inputBuilders.textarea(vars[prop], prop, id);
            break;
          case "select":
            inputs += modalJs.inputBuilders.select(vars[prop], prop, id);
            break;
          case "radio":
            inputs += modalJs.inputBuilders.radio(vars[prop], prop, id);
            break;
          case "checkbox":
            inputs += modalJs.inputBuilders.checkbox(vars[prop], prop, id);
            break;
          case "hidden":
            inputs += modalJs.inputBuilders.hidden(vars[prop], prop, id);
            break;
        }
        if (typeof vars[prop].afterInput !== "undefined" && vars[prop].afterInput !== null) {
          inputs += vars[prop].afterInput;
        }
        inputs += "</div>";

        countId++;
      }
    }
    return inputs;
  },
  prepareObj      : function(obj, overrideDefaults) {
    if (typeof obj !== "object") {
      obj = {};
    }

    obj = modalJs.setDefaults(obj, overrideDefaults);
    obj = modalJs.setAliases(obj);
    return obj;
  },
  addInputs       : function(vars, allowDuplicates) {
    if (!modalJs.dialogAppended) {
      throw ("addInputs called before dialog was appended.");
    }
    if (typeof allowDuplicates === "undefined" || allowDuplicates === null) {
      allowDuplicates = false;
    }

    var inputHtml = modalJs.prepareInputHtml(vars, allowDuplicates);
    modalJs.elements.$body.append(inputHtml);


    if (typeof conditionalJsAuto !== "undefined") {
      conditionalJsAuto(modalJs.elements.$body);
    }
    var $bootstrapTooltips = modalJs.elements.$body.find("[data-toggle='tooltip']");
    if ($bootstrapTooltips.length) {
      $bootstrapTooltips.tooltip();
    }

  },


  startTimer: function($button, timer) {
    if (timer > 0) {
      $button.addClass("disabled").prop("disabled", true).append(" <span class='modalJs-timer'>(" + timer + ")</span>").data("timer", timer);
      clearTimeout($button.data("timerTimeout"));
      var thisTimeout = setTimeout(function() {
        modalJs.adjustTimer($button);
      }, 1000);

      $button.data("timeout", thisTimeout);
    }
    else {
      $button.removeClass("disabled").prop("disabled", false);
    }
  },

  escapeHtml : function(text) {
    if (typeof text !== "string") {
      try {
        text = text.toString();
      }
      catch (err) {
        return "";
      }
    }
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  },
  getIdForVar: function(vars, fieldName) {
    for (var prop in vars) {
      if (vars.hasOwnProperty(prop)) {
        return vars[prop].element_id;
      }
    }
    return "";
  }
};

/* resources/assets/js/node_modules/skeets.toast/toast.js */
/*
* options:
message
type
title
time
icon
forceIcon (icon is auto-set if the type changes, to override, set this to true)
data
closeButton (true|false) defaults to `true`. Set to false to remove close button.

These options available in new toast(); and toastobj.set();
* */
var toast = function(options) {

  if (!(this instanceof toast)) {
    return new toast(options);
  }

  this.$container = $("#toaster-notifications-container");

  var that = this;
  if (!this.$container.length) {
    this.$container = $("<div/>", {
      id: "toaster-notifications-container"
    });
    $("body").append(this.$container);
  }
  // options is required...
  if (typeof options === 'undefined') {
    return false;
  }

  if (typeof options !== "object") {
    options = {message: options};
  }

  // message is required on creation of toast. (but NOT on changing of toast)
  if (typeof options.message === 'undefined') {
    return false;
  }

  this.iconDefault = {info: "info-circle", danger: "times", warning: "exclamation-triangle", success: "check"};

  this.removeToastInnerMethod = function($shell) {
    $shell.removeClass("toast-active");
    var moveDownBy = $shell.height();

    // Setting pointer-events to none is important so we don't block parts of the page from user input while the div is in the process of hiding.
    $shell.css({opacity: 0, "pointer-events": "none"});
    $shell.find(".toaster-notification").css({"pointer-events": "none"});

    $shell.nextAll(".toaster-notification-shell").each(function() {

      var oldTop = parseInt($(this).prop("style").top);
      $(this).css("top", oldTop + moveDownBy + 25);

    });

    // Not ideal.... but it sure is simple.
    // I tried to make this smart and bind it to the css animation finish event. DO NOT TRY TO DO THAT. it's a nightmare and doens't work.
    // If you ignore that warning and try anyways.... make sure you test 1 second toasts, because I bet they won't work. :P
    setTimeout(function() {
      $shell.remove();
    }, 1000);
  };

  this.calculateFromTop = function($except) {
    var fromTop                 = 0;
    var $mostRecentNotification = $(".toast-active").not($except).not("[data-moving='yes']").last();
    if ($mostRecentNotification.length) {
      if ($mostRecentNotification.attr("data-moving") === "yes") {
        fromTop =
          parseInt($mostRecentNotification.prop('style').top) +
          500 +
          (($mostRecentNotification.height() * -1) - 25);
      }
      else {
        fromTop = parseInt($mostRecentNotification.prop('style').top);
      }

    }
    return fromTop;
  };


  this.set = function(options) {

    this.setOptions(options);
    if (this.message !== null && typeof this.message === "string" && this.message.substring(0, 5) === "<html") {
      this.type = "danger";
    }

    if (this.pastType !== this.type && this.pastIcon === this.icon && !this.forceIcon) {
      this.icon = this.iconDefault[this.type];
    }

    var timeoutToClear = this.timeout;
    var $title         = "";

    var append = true;
    var $shell;

    if (this.shell !== null) {
      $shell = this.shell;
      append = false;
    }
    else {
      $shell = $("<div/>", {
        class: 'toaster-notification-shell toast-active'
      });
    }

    var $notification = $("<div/>", {
      class: 'toaster-notification card-body card card-body bg-' + this.type + '-with-text text-bg-' + this.type
    });
    if (this.title !== "") {
      $title = $("<span/>", {
        html: "<strong>" + this.title + "</strong><br><br>"
      });
    }

    if (this.icon === "loader") {
      this.icon = "circle-o-notch fa-spin fa-fw";
    }
    var $icon;
    if (this.icon !== "none") {
      $icon = "<i class='notificationTypeIcon fa fa-" + this.icon + "'></i> ";
    }
    else {
      $icon = "";
    }

    var $message    = $("<span></span>").addClass('message').html(this.message);
    var $close_icon = $("<div>×</div>").addClass('close-toaster-notification').addClass('cursor-pointer');

    if (this.closeButton === false) {
      $close_icon = "";
    }

    $notification.on("click", ".close-toaster-notification", function() {
      that.close();
    });

    var $content = $("<span/>");


    $content.append([$title, $message]);

    $shell.html("");
    $shell.append($notification.append([$icon, $content, $close_icon]));

    if (append) {


      $shell.css({top: -500 + this.calculateFromTop(), opacity: "0", position: "absolute", "transition-duration": "1s"})
            .attr("data-moving", "yes");

      this.$container.append($shell);
      setTimeout(function() {
        $shell.css({top: (($shell.height() * -1) - 25) + that.calculateFromTop($shell), opacity: 1}).attr("data-moving", "no");
      });


    }
    clearTimeout(timeoutToClear);
    if (this.time > -1) {
      this.timeout = setTimeout(function() {


        that.removeToastInnerMethod($shell);


      }, this.time);
    }
    this.shell    = $shell;
    this.pastIcon = this.icon;
    this.pastType = this.type;


  };


  this.close = function() {
    if (this.shell !== null) {
      clearTimeout(this.timeout);
      that.removeToastInnerMethod(this.shell);
    }
  };

  this.remove = function() {
    this.close();
  };

  this.setOptions = function(options) {
    // options is required...
    if (typeof options === 'undefined') {
      return false;
    }

    if (typeof options !== "object" || $.isArray(options)) {
      options = {message: options};
    }

    if ($.isArray(options.message)) {
      var temp        = options.message;
      options.message = temp[0];
      options.type    = temp[1];

    }


    options.message     = typeof options.message !== 'undefined' ? options.message : this.message || "";
    options.type        = options.type || this.type || 'info';
    options.title       = typeof options.title !== 'undefined' ? options.title : this.title || "";
    options.time        = typeof options.time !== 'undefined' ? options.time : this.time || 3500;
    options.icon        = typeof options.icon !== 'undefined' ? options.icon : this.icon || this.iconDefault[options.type];
    options.data        = typeof options.data !== 'undefined' ? options.data : this.data || false;
    options.closeButton = typeof options.data !== 'closeButton' ? options.closeButton : this.closeButton || false;


    if (options.icon === "default") {
      options.icon = this.iconDefault[options.type];
    }

    if (options.icon === "") {
      options.icon = "none";
    }

    for (var property in options) {
      if (options.hasOwnProperty(property)) {
        this[property] = options[property];
      }
    }

  };

  this.pastType = null;
  this.pastIcon = null;
  this.timeout  = null;
  this.shell    = null;
  this.set(options);

};

/* resources/assets/js/node_modules/overflow-fade/overflowFade.js */
var overflowFade = {
  showMore       : function(moreButton) {
    var wrapper                                                             = moreButton.closest('.overflow-fade-wrapper');
    wrapper.getElementsByClassName('overflow-fade-inner-elem')[0].classList = 'overflow-fade-inner-elem';
    moreButton.style                                                        = 'display: none;';
    wrapper.getElementsByClassName('overflow-fade-show-less')[0].style      = 'display: inline;';
  },
  showLess       : function(lessButton) {
    var wrapper                                                             = lessButton.closest('.overflow-fade-wrapper');
    var origHeight                                                          = wrapper.offsetHeight;
    wrapper.getElementsByClassName('overflow-fade-inner-elem')[0].classList = 'overflow-fade-inner-elem overflow-fade-content';
    lessButton.style                                                        = 'display: none;';
    wrapper.getElementsByClassName('overflow-fade-show-more')[0].style      = 'display: inline;';
    overflowFade.getScrollParent(lessButton).scrollBy(0, wrapper.offsetHeight - origHeight);
  },
  init           : function(elem) {
    var wrapper       = document.createElement('div');
    wrapper.classList = "overflow-fade-wrapper";
    elem.parentNode.insertBefore(wrapper, elem);


    wrapper.innerHTML = '<div class="overflow-fade-wrapper">' +
                        '<div class="overflow-fade-inner-elem overflow-fade-content">' +
                        '</div>' +
                        '<div class="overflow-fade-button-wrapper">' +
                        '<button onclick="overflowFade.showMore(this)" class="btn btn-info overflow-fade-show-more" style="display: inline;">' +
                        'Show more...' +
                        '</button>' +
                        '</div>' +
                        '<a href="javascript:void(0);" class="overflow-fade-show-less" style="display: none;" onclick="overflowFade.showLess(this)">' +
                        'Show less...' +
                        '</a>' +
                        '</div>';

    wrapper.getElementsByClassName("overflow-fade-content")[0].appendChild(elem);

  },
  getScrollParent: function(node) {
    if (node == null) {
      return null;
    }

    if (node.scrollHeight > node.clientHeight) {
      return node;
    }
    else {
      return overflowFade.getScrollParent(node.parentNode);
    }
  }
};

/* resources/assets/js/node_modules/skeets.iframe-resize/iframe-resize.js */
function iFrameResize($iFrame, options)
{
  if ($iFrame instanceof HTMLElement) {
    $iFrame = $($iFrame);
  }
  options          = options || {};
  var loaded       = $iFrame.data("iframe-resize-loaded") || options.loaded || false;
  var attemptCount = $iFrame.data("iframe-resize-attempt") || 0;
  var bound        = $iFrame.data("iframe-resize-bound");
  var timeout      = $iFrame.data("iframe-resize-timeout");

  if (options.rebind) {
    bound = false;
  }

  options.direction = options.direction || $iFrame.data("iframe-resize-expand-direction") || "down";
  options.container = options.container || $iFrame.data("iframe-resize-scroller") || false;
  options.minHeight = options.minHeight || $iFrame.data("iframe-min-height") || 300;


  if (typeof $iFrame.data("iframe-resize-expand-direction") === "undefined") {
    $iFrame.data("iframe-resize-expand-direction", options.direction);
  }

  if (typeof $iFrame.data("iframe-resize-scroller") === "undefined" && options.container !== false) {
    $iFrame.data("iframe-resize-scroller", options.container);
  }

  if (typeof timeout !== "undefined") {
    clearTimeout(timeout);
  }

  if (loaded) {
    $iFrame.data("iframe-resize-loaded", true);
  }
  var oldHeight;
  if (typeof bound === "undefined" || !bound) {
    $iFrame.data("iframe-resize-bound", true);
    oldHeight = options.minHeight;
    $iFrame.height(oldHeight);
    $iFrame.on("load", function() {
      iFrameResize($iFrame, {loaded: true});
    });
  }
  else {
    oldHeight = parseInt($iFrame.height());
  }

  var $html = $iFrame.contents().find("html");
  var $body = $html.find("body");
  if (!$body.length) {
    $body = $html;
  }
  $body.css({"height": "auto", "overflow-y": "hidden"});
  $html.css({"height": "auto", "overflow-y": "hidden"});


  var htmlScrollHeight = 0;
  var bodyScrollHeight = 0;
  var htmlHeight       = 0;
  var bodyHeight       = 0;
  if ($html.length) {
    htmlScrollHeight = parseInt($html[0].scrollHeight);
    htmlHeight       = parseInt($html.height());
  }
  if ($body.length) {
    bodyScrollHeight = parseInt($body[0].scrollHeight);
    bodyHeight       = parseInt($body.height());
  }


  var newHeight = Math.max(htmlScrollHeight, bodyScrollHeight, htmlHeight, bodyHeight);
  if (!isNaN(oldHeight) && !isNaN(newHeight)) {
    if (options.container !== false && options.direction === "up") {
      var scroller = $iFrame.closest(options.container);
      if (scroller.length) {
        var newScroll = scroller.scrollTop() + parseInt(newHeight) - parseInt(oldHeight);
      }
    }

    $iFrame.height(newHeight);


    if (typeof scroller !== "undefined" && scroller.length && options.direction === "up") {
      scroller.scrollTop(newScroll);
    }
  }

  if (loaded) {
    return true;
  }
  attemptCount++;

  // try to adjust size of iframe for 2 seconds. (give up after that, it's taking too long to load)
  if (attemptCount > 20) {
    return true;
  }

  $iFrame.data("iframe-resize-attempt", attemptCount);

  timeout = setTimeout(function() {
    iFrameResize($iFrame);
  }, 100);
  $iFrame.data("iframe-resize-timeout", timeout);
}

/* resources/assets/js/node_modules/skeets.iframe-dom/iframe-dom.js */
var iFrameDom = {
  replace: function($targetElement, content, options) {
    iFrameDom.include($targetElement, content, options, "replace");
  },
  append : function($targetElement, content, options) {
    iFrameDom.include($targetElement, content, options, "append");
  },
  prepend: function($targetElement, content, options) {
    iFrameDom.include($targetElement, content, options, "prepend");
  },
  include: function($targetElement, content, options, mode) {
    var $iframe                   = null;
    var $viewOnWhiteBackgroundDiv = "";
    var $beforeIframe             = "";
    if (options.viewOriginalOption === true) {
      $viewOnWhiteBackgroundDiv = $("<a href='javascript:void(0)'>View original</a>");
      $beforeIframe             = $("<div class='alert alert-warning'></div>");
      $beforeIframe.html("The background and text colors have been modified to fit your theme. ");
      $beforeIframe.append($viewOnWhiteBackgroundDiv);
      $beforeIframe.append("<br>");
    }
    else {
      $beforeIframe = "";
    }
    $iframe = $("<iframe style='width: 100%; border: none;'></iframe>");
    switch (mode) {
      case "append":
        $targetElement.append($beforeIframe);
        $targetElement.append($iframe);
        break;
      default:
      case "replace":
        $targetElement.html($beforeIframe);
        $targetElement.append($iframe);
        break;
      case "prepend":
        $targetElement.prepend($iframe);
        $targetElement.prepend($beforeIframe);
        break;
    }

    $divToChange = $iframe.contents().find("body");
    $iframe.on("load", function(e) {
      iFrameDom.iFrameOnLoadMethod($iframe, content, options);
    });
    if (options.viewOriginalOption === true) {
      $viewOnWhiteBackgroundDiv.click(function() {
        $(this).parent().remove();
        $iframe.css("background", "white");
        var $divToChange   = $iframe.contents().find("body");
        var originalStyles = $divToChange.data("originalStyles");
        var styleName;
        for (styleName in originalStyles) {
          if (originalStyles.hasOwnProperty(styleName)) {
            $divToChange.css(styleName, originalStyles[styleName]);
          }
        }

      });
    }
    // adding a "src" breaks ie + edge... about:blank is apparently a "different domain". :P
    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {
      // must give a 'src' or chrome doesn't fire the 'onload' event....
      $iframe.attr("src", "about:blank");
    }
  },
  /*
  * iFrameOnLoadMethod
  * */
  iFrameOnLoadMethod: function($iframe, content, options) {
    var iFrameDocument = ($iframe[0].contentWindow || $iframe[0].contentDocument);
    if (iFrameDocument.location.href === "about:blank") {
      var $divToChange = $iframe.contents().find("body");
      $divToChange.html(content);
    }
    var styleName;
    var originalStyles = {};
    if (typeof options !== "undefined") {
      if (typeof options.style === "object" && options.style !== null) {
        for (styleName in options.style) {
          if (options.style.hasOwnProperty(styleName)) {
            originalStyles[styleName] = $divToChange.css(styleName);
            $divToChange.css(styleName, options.style[styleName]);
          }
        }
      }
    }
    if (typeof $divToChange !==
        "undefined" &&
        (typeof $divToChange.data("originalStyles") === "undefined" || $divToChange.data("originalStyles").length < 1)) {
      $divToChange.data("originalStyles", originalStyles);
    }

    if (typeof iFrameResize === "function") {
      if (typeof options !== "undefined" && typeof options.resizeOptions !== "undefined") {
        iFrameResize($iframe, options.resizeOptions);
      }
      else {
        iFrameResize($iframe);
      }

    }
    else {
      console.log("iFrameResize function not found. Install 'skeets.iframe-resize' through npm.");
    }
  }
};

/* resources/assets/js/app/message_localization.js */
// Message text is supplied by the current CP locale, including for AJAX-loaded views.
var messageDisplay = {
    data: function () {
        return typeof blade_layout !== 'undefined' && blade_layout.message_display
            ? blade_layout.message_display : {};
    },
    status: function (status, fallback) {
        var statuses = messageDisplay.data().statuses || {};
        return statuses[status] || {label: fallback};
    },
    countries: function (root) {
        if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return;
        try {
            var locale = document.documentElement.lang;
            if (!Intl.DisplayNames.supportedLocalesOf([locale]).length) return;
            var names = new Intl.DisplayNames([locale], {type: 'region', fallback: 'none'});
            $(root).find('.message-country-name[data-country-code], .localized-country-options option[data-country-code]').each(function () {
                var code = this.getAttribute('data-country-code');
                if (!/^[a-z]{2}$/i.test(code)) return;
                var name = names.of(code.toUpperCase());
                if (name) $(this).text(name);
            });
        } catch (error) {
            // Retain the server-provided country name when display-name support is unavailable.
        }
    }
};

// Keep the iframe helper's original style-restoration handler while translating its notice.
if (typeof iFrameDom !== 'undefined' && typeof iFrameDom.include === 'function') {
    (function () {
        var include = iFrameDom.include;
        iFrameDom.include = function ($target, content, options, mode) {
            var result = include.apply(this, arguments);
            var labels = messageDisplay.data();
            if (options && options.viewOriginalOption === true && labels.theme_notice && labels.view_original) {
                var $frame = mode === 'prepend' ? $target.children('iframe').first() : $target.children('iframe').last();
                var $notice = $frame.prev('.alert-warning');
                var $link = $notice.children('a').first().detach();
                if ($link.length) {
                    $notice.empty().text(labels.theme_notice + ' ').append($link.text(labels.view_original)).append('<br>');
                }
            }
            return result;
        };
    })();
}
$(function () { messageDisplay.countries(document); });
$(document).ajaxComplete(function () { messageDisplay.countries(document); });

/* resources/assets/js/app/bootstrap_customizations.js */
$('.smart-date-picker').datetimepicker({
  useCurrent: false,
  icons     : {
    time    : "fa fa-clock",
    date    : "fa fa-calendar",
    up      : "fa fa-arrow-up",
    down    : "fa fa-arrow-down",
    next    : "fa fa-angle-right",
    previous: "fa fa-angle-left"
  }
});
$('.smart-date-picker-min-tomorrow').datetimepicker({
  minDate: new Date(new Date().getTime() + 60 * 60 * 24 * 1000), useCurrent: false,
  icons  : {
    time    : "fa fa-clock",
    date    : "fa fa-calendar",
    up      : "fa fa-arrow-up",
    down    : "fa fa-arrow-down",
    next    : "fa fa-angle-right",
    previous: "fa fa-angle-left"
  }
});
var dateNow = new Date();
$('.smart-time-picker').datetimepicker({
  useCurrent: false,
  icons     : {
    time    : "fa fa-clock",
    date    : "fa fa-calendar",
    up      : "fa fa-arrow-up",
    down    : "fa fa-arrow-down",
    next    : "fa fa-angle-right",
    previous: "fa fa-angle-left"
  },
  format    : 'LT',
  stepping  : 30,

  defaultDate: moment(dateNow).hours(12).minutes(0).seconds(0).milliseconds(0)
});

var $appLayout = $('#app-layout');

$appLayout.on('click', '[data-toggle=custom-collapse-open]', function(e) {
  var $toggle = $(e.target).closest('[data-toggle=custom-collapse-open]');
  if ($toggle.length) {
    var attr = $toggle.data('parent');


    if (typeof attr !== typeof undefined && attr !== false && attr !== '') {
      var $parent   = $(attr);
      var $siblings = $parent.find(':not([data-target="' +
                                   $toggle.data('target') +
                                   '"])[data-parent="' +
                                   attr +
                                   '"][data-toggle="custom-collapse-open"]');
      if ($siblings.length) {
        var $collapse_targets = $siblings.map(function() {
          return $(this).data('target');
        });
        $collapse_targets     = $($collapse_targets.toArray().join());
        $collapse_targets.collapse('hide');
      }
      $siblings.removeClass('custom-active-accordion');
    }
    $($toggle.data('target')).collapse('show');
    $toggle.addClass('custom-active-accordion');
  }
});
$appLayout.on('click', '[data-toggle=custom-collapse-close]', function(e) {
  var $toggle = $(e.target).closest('[data-toggle=custom-collapse-close]');
  if ($toggle.length) {
    $($toggle.data('target')).collapse('hide');
  }
});
if (!('ontouchstart' in window)) {
  // On desktop we use hover to activate drop-downs on mobile we use click/tap
  // Even on desktop, allow click to expand on narrow displays.
  $("body").on("click", 'ul.navbar-nav .dropdown-toggle:not(.sm-window-size)', function(e) {
    if (e.stopPropagation) {
      e.stopPropagation()
    }
  });
}

// $.fn.dropdown.Constructor.Default.boundary = "none";
// $.fn.dropdown.Constructor.Default.flip     = false;

var $dropHover = $('.drop-hover');


$dropHover.mouseenter(function() {
  var lastTimeout = $(this).data("timeout") || null;
  if (lastTimeout !== null) {
    clearTimeout(lastTimeout);
  }
  if (!$(".dropdown-menu", this).hasClass("show")) {
    $('.dropdown-toggle', this).dropdown('toggle');
  }
});

$dropHover.mouseleave(function() {
  var lastTimeout = $(this).data("timeout") || null;
  if (lastTimeout !== null) {
    clearTimeout(lastTimeout);
  }

  var that        = this;
  var thisTimeout = setTimeout(function() {
    if ($(".dropdown-menu", that).hasClass("show")) {
      $('.dropdown-toggle', that).dropdown('toggle');
    }
  }, 250);
  $(this).data("timeout", thisTimeout);

});


$dropHover.on("show.bs.dropdown", function() {
  var $toggle = $(this).find(".dropdown-toggle");
  if ($(this).data("fixed_bindings") !== "yes") {
    $(this).data("fixed_bindings", "yes");
    $(this).find("a").off("click");
    $toggle.off("click");
    $toggle.click(function(e) {
      e.stopPropagation();
    });
  }
});


$(document).ready(function() {
  $dropHover.find('.dropdown-toggle').on('touchstart', function(e) {
    $(this).dropdown("toggle");
    e.preventDefault();
    //Do touch stuff
  });
  $('[data-toggle="tooltip"]').tooltip({boundary: 'window'});
});

/* resources/assets/js/app/global.js */
// Public pages provide translated display strings; shared control-panel scripts keep their English fallback.
function publicText(text) {
  return window.publicTranslations && Object.prototype.hasOwnProperty.call(window.publicTranslations, text)
    ? window.publicTranslations[text] : text;
}

var siteGlobals = {
  csrfToken : false,    // a global STRING to store the session csrf token value
  consoleLog: false,    // a local global BOOLEAN to store whether or not consoleLog is
                        // available
  $window           : null,     // a local global to store jQuery access to the window object
  $document         : null,     // a local global to store jQuery access to the document object
  $html             : null,     // a local global to store jQuery access to the root html element
  $head             : null,     // a local global to store jQuery access to the body element
  $body             : null,     // a local global to store jQuery access to the body element
  $site_page_content: null,     // a local global to store jQuery access to the '#sh-page-content'
  // element
  $js_construction_zone: null,     // a local global to store jQuery access to the
                                   // '#js-construction-zone' element
  $toaster_notifications_container: null,     // a local global to store jQuery access to the
                                              // '#toaster-notifications-container' element
  values: null,     // a local global array of arrays to store safe values loaded from the
                    // server
  endOfPageScroll: null,     // a local global INTEGER to store the scrollTop that ends at the
                             // bottom of the page
  url     : null,     // a local global to store the current browser url
  base_url: null,     // a local global that contains the protocol and hostname (ie.
                      // 'http://sub.example.com/' or 'https://sub.example.com/')
  $css_modal_checkboxes: null,     // a local global to store jQuery access to '.css-modal-checkbox'
                                   // elements

  millisecondsToSeconds: function(time) {
    return parseFloat(time) / 1000.0;
  },
  secondsToMinutes     : function(time) {
    return parseFloat(time) / 60.0;
  },
  minutesToHours       : function(time) {
    return parseFloat(time) / 60.0;
  },
  secondsToMilliseconds: function(time) {
    return parseFloat(time) * 1000.0;
  },
  minutesToSeconds     : function(time) {
    return parseFloat(time) * 60.0;
  },
  hoursToMinutes       : function(time) {
    return parseFloat(time) * 60.0;
  },
  syncInputs           : function($inputElements) {
    $inputElements.on("keyup search", function() {
      if ($(this).data("skip-update")) {
        return true;
      }
      $inputElements.not($(this)).val($(this).val()).each(function() {
        $(this).data("skip-update", true).keyup().data("skip-update", false);
      });
      return true;
    });
  },

  // bootstrapOnlyHoverActivateHandler: function(e)
  // {
  //  if(e.stopPropagation){ e.stopPropagation()};
  // },

  scrollToKb: function(kbId) {
    if (typeof kbId !== "undefined" && $("#kb-article-" + kbId).length) {
      $("#kb-side-bar").animate({
        scrollTop: $("#kb-article-" + kbId).offset().top - 100
      }, 500);
    }
  },


  pulseElement: function(element, color) {
    if (typeof color !== 'string') {
      color = 'orange';
    }
    var classToAdd = "pulse-orange";
    switch (color) {
      case 'blue':
        classToAdd = "pulse-blue";
        break;
      case 'orange':
      default:
        break;
    }
    var returnValues        = siteGlobals.variableElementTest(element);
    returnValues['success'] = false;
    element                 = returnValues['element'];

    //only if element is valid should we attempt to pulse it.
    if (returnValues['errors'].length === 0) {
      $(element).addClass(classToAdd);
      setTimeout(function() {
        $(element).removeClass(classToAdd)
      }, 1300);
    }
  },

  escapeHtml: function(textToEscape) {
    return $('<div/>').text(textToEscape).html();
  },

  singleRun: function(methodName, params) {

    if (typeof this.methods !== "object") {
      this.methods = {};
    }

    if (typeof this.methods[methodName] === "undefined" || this.methods[methodName] === null) {
      this.methods[methodName] = [params];
      return true;
    }


    if (siteGlobals.arrayContainsObject(this.methods[methodName], params)) {
      return false;
    }

    this.methods[methodName].push(params);
    return true;
  },

  arrayContainsObject: function(array, obj) {

    if (typeof array === "undefined") {
      return false;
    }
    var x = array.length;
    while (x--) {


      if (JSON.stringify(array[x]) === JSON.stringify(obj)) {
        return true;
      }
      // console.log("start");
      // console.log(JSON.stringify(array[x]));
      // console.log(JSON.stringify(obj));
    }
    return false;
  },

  /**
   * @call        => siteGlobals.isVisible(element);
   *
   * @date        => July 29, 2016
   *
   * @description =>  Returns true if css neither opacity or visibility settings of the element in question or
   *                  any of it's parents prevent the element from being seen. If this element or any parents
   *                  have an opacity of 0 or visibility is not set to visible then this function will return
   *                  false.
   *
   * @param        element (DOM ELEMENT)  --element to scroll user view to
   *
   * @return       boolean isVisible (BOOLEAN)  --true if element is visible otherwise false
   */
  isVisible: function(element) {
    var isVisible         = true;
    var tempValues        = siteGlobals.variableElementTest(element);
    tempValues['success'] = false;
    element               = tempValues['element'];
    var i                 = 0;

    if (parseInt(tempValues['errors'].length) === 0) {
      var $element = $(element);
      while (parseInt($element.length) === 1) {
        if (i > 0) {
          var overflow = String($element.css('overflow'));
          if (overflow === 'visible' || overflow === 'initial' || overflow === 'inherit') {
            $element = $element.parent();
            if ($element.get(0) === siteGlobals.$body.get(0)) {
              $element = [];
            }
            i++;
            continue;
          }
        }
        var opacity    = parseFloat($element.css('opacity'));
        var visibility = String($element.css('visibility'));
        var display    = String($element.css('display'));
        //noinspection JSValidateTypes
        var height     = parseInt($element.outerHeight(true));
        //noinspection JSValidateTypes
        var width      = parseInt($element.outerWidth(true));
        if (opacity === 0 ||
            opacity === '0' ||
            visibility === 'hidden' ||
            visibility === 'collapse' ||
            display === 'none' ||
            height === 0 ||
            width === 0) {
          isVisible = false;
          break;
        }
        else {
          if ($element.get(0) === siteGlobals.$body.get(0)) {
            $element = [];
          }
          else {
            $element = $element.parent();
          }
        }
        i++;
      }
    }
    else if (siteGlobals.consoleLog) {
      console.log(tempValues['errors']);
    }
    if (siteGlobals.consoleLog && tempValues['warnings'].length > 0) {
      console.log(tempValues['warnings']);
    }
    return isVisible;
  },

  /**
   * @call        => siteGlobals.variableElementTest(element);
   *
   * @date        => July 25, 2016
   *
   * @description => Completes a battery of tests to confirm or convert element into an element if at all possible
   *   and return results
   *
   * @param        element (DOM ELEMENT)  --variable that is hopefully a DOM ELEMENT or some sort of reference to
   *   one
   *
   * @return       Array returnValues (associative array)  -- group of named arrays and the final result of
   *   `element`
   *                      ['element']  (DOM ELEMENT if possible)  -- returning the final result of the element
   *                      ['errors']  (ARRAY of STRINGs)  -- list of errors that have occurred (hopefully empty)
   *                      ['warnings']  (ARRAY of STRINGs)  -- list of warnings that have occurred (hopefully
   *   empty,
   *   but not too bad if it isn't)
   */
  variableElementTest: function(element) {
    var returnValues         = [];
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    if (typeof element === "undefined") {
      returnValues['errors'].push('SH_ERROR: Element was left "undefined" but is required.');
    }
    else if (typeof element === "string") {
      var $temp = $(element);
      if ($temp.length > 0) {
        element = $temp.get(0);
      }
      else {
        returnValues['errors'].push('SH_ERROR: Element was typeof "string" and an attempt to convert to DOM Element failed.');
      }
    }
    else if (typeof element === "object") {
      if (element instanceof jQuery) {
        switch (element.length) {
          case 0:
            returnValues['errors'].push('SH_ERROR: Element was instanceof jQuery but had no valid DOM elements in its selection');
            break;
          case 1:
            element = element.get(0);
            break;
          default:
            element = element.get(0);
            returnValues['warnings'].push('SH_WARNING: Element was instanceof jQuery and had more than one DOM element the first in the array was used.');
            break;
        }
      }
      else if (!(element instanceof Element)) {
        returnValues['errors'].push('SH_ERROR: Element was an unknown object and was not converted to a DOM Element');
      }
    }
    else {
      returnValues['errors'].push('SH_ERROR: Element was an unknown type and was not converted to a DOM Element');
    }
    returnValues['element'] = element;
    return returnValues;
  },


  /**
   * @call        => siteGlobals.scrollToElement();
   *
   * @date        => June 17, 2016
   *
   * @description => Using Translate to animate the scroll this should be an optimized clean way to animate the
   *   scroll.
   *
   * @param        element (DOM ELEMENT)  --element to scroll user view to
   */
  scrollToElement: function(element, view) {
    history.scrollRestoration = "manual";
    var nav_compact_size      = 50;
    var nav_size              = 90;
    if (siteGlobals.$body.hasClass('cp')) {
      nav_compact_size = 0;
      nav_size         = 0;
    }
    var returnValues        = siteGlobals.variableElementTest(element);
    returnValues['success'] = false;
    element                 = returnValues['element'];
    var viewTest            = siteGlobals.variableElementTest(view);
    if (viewTest['errors'].length > 0) {
      if (siteGlobals.$body.hasClass('cp')) {
        view = $("#sh-cp-content").get(0);
      }
      else {
        view = false;
      }
    }
    //only if element is valid should we attempt to scroll to it.
    if (returnValues['errors'].length === 0) {
      var y = parseFloat($(element).offset().top);

      if (view !== false) {
        y -= parseFloat($(view).offset().top);
      }

      if (y > siteGlobals.$window.height()) {
        y -= nav_compact_size; // 50 is the height of the navbar at compact size in pixels.
      }
      else {
        y -= nav_size; // 90 is the height of the navbar at full size in pixels.
      }

      y = Math.ceil(y); // Don't want to end up between pixels.

      y -= 20; // Just to give some breathing room above the element we are scrolling to

      siteGlobals.scrollToX(y);
      returnValues['success'] = true;
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },


  /**
   * @call        => siteGlobals.scrollToX();
   *
   * @date        => June 17, 2016
   *
   * @description => Using Translate to animate the scroll this should be an optimized clean way to animate the
   *   scroll.
   *
   * @param        y (INTEGER)  --position to scroll user view to
   */
  scrollToX: function(y) {
    var $scrollable_content = siteGlobals.$site_page_content;
    if (y < 0) // don't attempt to scroll past the top of the page
    {
      y = 0;
    }
    if (siteGlobals.$body.hasClass('cp')) {
      $scrollable_content = $('#cp-main-scroll-element');
      $scrollable_content.animate({scrollTop: y}, 750);
      return;

    }
    siteGlobals.setPageScrollValues();
    if (y > siteGlobals.endOfPageScroll) // don't attempt to scroll past the bottom of the page
    {
      y = siteGlobals.endOfPageScroll;
    }
    var speed = 750;
    // how long the animation should take in milliseconds
    // This is a relatively short amount of time because the longer this animation goes the more likely a user is
    // to
    // attempt to scroll mid animation causing a choppy experience... As this finishes in less than a second
    // currently the user shouldn't notice any problems.
    var currentPosition = siteGlobals.$window.scrollTop();
    if (siteGlobals.$body.hasClass('cp')) {
      currentPosition = siteGlobals.$site_page_content.scrollTop();
    }
    // get the distance we want to animate our scroll over
    var distanceToTarget = -1 * (currentPosition - y);

    // move the page the amount we want to scroll (make the distance to target 0)
    $scrollable_content.css('transform', 'translateY(' + distanceToTarget + 'px)');

    // Instantly (read simultaneously completed with line above) we move our scroll position back to our current
    // position by using our old currentPosition and the distanceToTarget.
    // This line makes it seem like nothing has happened yet.
    if (siteGlobals.$body.hasClass('cp')) {
      siteGlobals.$site_page_content.scrollTop(distanceToTarget + currentPosition);
    }
    else {
      siteGlobals.$window.scrollTop(distanceToTarget + currentPosition);
    }
    // now we set the css transition that will allow our next move to take time rather than happen instantly
    $scrollable_content.css('transition', 'transform ' + speed + 'ms ease');
    setTimeout(
      function() {
        // after a short break for the css code to be applied to the DOM model we
        $scrollable_content.css('transform', 'translateY(0px)');
        setTimeout(
          function() {
            // after the animation is done we need to remove the transition so as to avoid problems if the
            // scroll to top button is clicked again. Removing the transform entirely just ensures that the page
            // is treated normally again.
            $scrollable_content.css('transition', '')
                               .css('transform', '');
          },
          (speed + 100) // This will wait until the animation ends to reset the transition css
          // (100ms extra just ensures that the animation is complete)
        )
      },
      100 // This will wait for the css to complete its update so the transition css is ready
      // Without this pause the page jumps immediately to the top without any animation
    )

  },

  /**
   * @call        => siteGlobals.animateAdd( element, parent );
   *
   * @date        => July 22, 2016
   *
   * @description => Takes a presumably associated input field and validation errors list and creates and displays
   *   the
   *   errors in an unordered list
   *
   * @param        element (DOM ELEMENT)  -- The element to add via animation
   * @param        parent (DOM ELEMENT) -- The element to add the `element` variable to
   * @param        after (BOOLEAN)  -- If true the `element` is added via '.after()' else it is added '.append()'
   *   to the `parent` element
   *
   * @param         prepend(BOOLEAN)  -- If true the `element` is added via '.prepend()' else it is added
   *   '.append()' to the `parent` element
   * @param        wrapped_content (BOOLEAN) -- If true adds a class to handle content being added to a
   *   wrapped space. Meaning the element should be inline-block and vertical-align top
   */
  animateAdd: function(element, parent, after, prepend, wrapped_content) {
    var speed = 500; // ms for the animation to complete and the delete to happen (must be at least
    // 150)
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];

    tempValues               = siteGlobals.variableElementTest(parent);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    parent                   = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {

      /** @type jQuery Object */
      var $element   = $(element);
      var $container = $("<div></div>").addClass('animate-add-container').append($element);
      if (typeof wrapped_content !== 'undefined' && wrapped_content) {
        $container.addClass('animate-inline');
      }
      siteGlobals.$js_construction_zone.append($container);
      //noinspection JSValidateTypes
      var height   = (-1 * $container.outerHeight(true)) + 'px';
      var stepTime = (speed - 150) / 2;
      $container.css('margin-bottom', height)
                .css('opacity', '0')
                .css('transition', 'margin, opacity')
                .css('transition-duration', stepTime + 'ms');
      if (typeof after !== 'undefined' && after) {
        $(parent).after($container);
      }
      else if (typeof prepend !== 'undefined' && prepend) {
        $(parent).prepend($container);
      }
      else {
        $(parent).append($container);
      }
      setTimeout(function() {
        $container.css('margin-bottom', '');
        setTimeout(function() {
          $container.css('opacity', '');
          setTimeout(function() {
            $element.insertBefore($container);
            $container.remove()
          }, stepTime + 50);
        }, stepTime + 50);
      }, 50);
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },

  /**
   * @call        => siteGlobals.animatexxxxRemove( element );
   *
   * @date        => June 22, 2016
   *
   * @description => Receives an element that will be removed from the DOM and use some fancy magic to make it go
   *   away visually-quietly.
   *
   * @param        element -- The element to remove via animation
   *
   */
  animateRemove: function(element) {
    var speed = 500; // ms for the animation to complete and the delete to happen (must be at least
    // 100)
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];
    element.id               = "element-being-removed";

    if (parseInt(returnValues['errors'].length) === 0) {
      var $element = $(element);

      var stepTime = ((speed - 100) / 2);
      $element.css('transition', 'margin, opacity')
              .css('transition-duration', stepTime + 'ms')
              .css('overflow', 'hidden');
      setTimeout(function() {
          $element.css('opacity', '0');
          setTimeout(function() {
              //noinspection JSValidateTypes
              $element.css('margin-bottom', (-1 * $element.outerHeight()) + "px");
              setTimeout(function() {
                  $element.remove();

                },
                stepTime + 50
              );
            },
            stepTime + 50
          );
        },
        50 // wait for css transition to be parsed and ready to use
      );

    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },


  instantHideVertical: function(element) {

    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {
      var $element = $(element);
      $element.css({
        'transition'    : 'all 0s ease 0s',
        'opacity'       : '0',
        'margin-bottom' : (-1 * $element.outerHeight()) + "px",
        'overflow'      : 'hidden',
        'pointer-events': 'none'
      });
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },

  animateHideVertical: function(element) {
    var speed = 1000; // ms for the animation to complete and the delete to happen (must be at least
                      // 100)
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {
      var $element = $(element);

      var stepTime = ((speed - 100) / 2);
      $element.css({
        'transition'         : 'margin, opacity',
        'transition-duration': stepTime + 'ms',
        'overflow'           : 'hidden',
        'pointer-events'     : 'none'
      });
      setTimeout(function() {
          $element.css('opacity', '0');
          setTimeout(function() {
              //noinspection JSValidateTypes
              $element.css('margin-bottom', (-1 * $element.outerHeight()) + "px");
            },
            stepTime + 50
          );
        },
        50 // wait for css transition to be parsed and ready to use
      );
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },
  animateShowVertical: function(element) {
    var speed = 1000; // ms for the animation to complete and the delete to happen (must be at least
                      // 100)
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {
      var $element = $(element);

      var stepTime = ((speed - 100) / 2);
      $element.css({
        'transition'         : 'margin, opacity',
        'transition-duration': stepTime + 'ms',
        'overflow'           : 'hidden',
        'pointer-events'     : 'auto'
      });
      setTimeout(function() {
          //noinspection JSValidateTypes
          $element.css('margin-bottom', "0px");
          setTimeout(function() {
              $element.css('opacity', '1');
            },
            stepTime + 50
          );
        },
        50 // wait for css transition to be parsed and ready to use
      );
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },
  /**
   * @call        => siteGlobals.animateShow( element );
   *
   * @date        => August 8, 2017
   *
   * @ description: an animation that shows a hidden element (see animateHide directly below) from the users view
   *
   * @param        element (DOM ELEMENT)  -- The element to show via animation
   */
  animateShow: function(element) {
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];
    element                  = $(element);
    var elementHTML          = element.clone().removeAttr('style');

    var parent = element.parent();


    if (!parent.hasClass('animateShowDiv')) {
      element.wrap("<div class='animateShowDiv'></div>");
      parent = element.parent();
    }

    element.remove();
    siteGlobals.animateAdd(elementHTML, parent);
    return returnValues;
  },
  /**
   * @call        => siteGlobals.animatexxxxxRemove( element );
   *
   * @date        => August 8, 2017
   *
   * @description => hides the given element from the users view
   *
   * @param        element -- The element to remove via animation
   *
   */
  animateHide: function(element) {
    var speed = 1000; // ms for the animation to complete and the delete to happen (must be at least
                      // 100)
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(element);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    element                  = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {
      var $element = $(element);

      var stepTime = ((speed - 100) / 2);
      $element.css('transition', 'margin, opacity')
              .css('transition-duration', stepTime + 'ms')
              .css('overflow', 'hidden');
      setTimeout(function() {
          $element.css('opacity', '0');
          setTimeout(function() {
              //noinspection JSValidateTypes
              $element.css('margin-bottom', (-1 * $element.outerHeight()) + "px");

            },
            stepTime + 50
          );
        },
        50 // wait for css transition to be parsed and ready to use
      );

    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },
  /**
   * @call        => siteGlobals.displayValidationErrors( input, errors );
   *
   * @date        => June 20, 2016
   *
   * @description => Takes a presumably associated input field and validation errors list and creates and displays
   *   the errors in an unordered list
   *
   * @param        input
   * @param        errors
   * @param        overrideType
   * @param        icon
   */
  displayValidationErrors: function(input, errors, overrideType, icon) {
    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(input);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    input                    = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {
      input = $(input);

      if (errors.length > 0) {
        var displayTarget = input.parent();
        var after         = input;
        var next          = input.next("label");
        if (displayTarget.hasClassStartingWith("col-")) {
          if (siteGlobals.$window.width() < 768 && displayTarget.hasClass('col-24')) {
            after = displayTarget;
          }
          else {
            displayTarget = displayTarget.parent();
            if (displayTarget.hasClass('row')) {
              after = displayTarget;
            }
          }
        }
        else if (displayTarget.hasClass('form-group')) {
          after = displayTarget;
        }
        else if (String(input.attr("type")) === "checkbox") {
          var formGroup = input.closest('.form-group');
          if (parseInt(formGroup.length) === 1) {
            after = formGroup;
          }
        }
        else if (parseInt(next.length) === 1) {
          after = next;
        }
        after = $(after);
        next  = after.next('.animate-add-container');
        if (next.length > 0) {
          while (next.next('.animate-add-container').length > 0) {
            next = next.next('.animate-add-container');
          }
          after = $(next);
        }
        var container_id   = input.attr('name') + '-errors';
        var move_left      = (after.hasClassStartingWith("col-") || after.hasClass('pull-left'));
        var errorContainer = siteGlobals.createErrorList(errors, container_id, move_left, overrideType, icon);

        // important... only add the error container if it's not already there! (no need to add it twice!)
        if (!after.parent().find("#" + container_id).length) {
          siteGlobals.animateAdd(errorContainer, after, true);
        }
      }
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },
  clearValidationErrors  : function(input) {
    var $container = $("#" + input.attr('name') + '-errors');
    if ($container.length > 0) {
      siteGlobals.animateRemove($container.get(0));
    }
  },
  createErrorList        : function(errors, container_id, move_left, type, icon) {
    if (typeof type === "undefined") {
      type = "danger";
    }
    if (typeof icon === "undefined") {
      icon = "exclamation-triangle";
    }
    if (typeof errors === 'undefined') {
      errors = [];
    }
    if (typeof move_left === 'undefined') {
      move_left = false;
    }
    var $errorContainer = $("#" + container_id);


    if ($errorContainer.length) {
      $errorContainer.html("");
    }
    else {
      $errorContainer = $("<div></div>");

      if (typeof errors === 'undefined') {
        errors = [];
      }


      if (typeof container_id !== 'undefined') {
        $errorContainer.attr('id', container_id);
      }
      if (move_left) {
        $errorContainer.addClass('pull-left').addClass('margin-horizontal');
      }
    }

    $errorContainer.removeClass("alert-danger").removeClass("alert-success").removeClass("alert-primary").removeClass("alert-info").addClass('alert')
                   .addClass('alert-' + type);

    var errorCount = errors.length;

    if (errorCount < 2) {
      $errorContainer.append("<i class='fa fa-" + icon + "'></i> " + errors[0]);
    }
    else {
      var $innerWrapper = $("<ul class='mb-0'></ul>");
      for (var i = 0; i < errorCount; i++) {
        var li = $("<li></li>").html(errors[i]);
        $innerWrapper.append(li);
      }
      $errorContainer.append($innerWrapper);
    }


    return $errorContainer;
  },


  bootstrapConfirm: function(title, message, buttonText, callback, timer, skipConfirm, afterClose, alwaysAfterClose, buttonType) {
    //noinspection JSJQueryEfficiency
    var $bootstrapConfirm = $("#bootstrapConfirmDialog");

    if (typeof skipConfirm === "undefined" || skipConfirm !== true) {
      skipConfirm = false;
    }
    if (typeof alwaysAfterClose === "undefined" || alwaysAfterClose !== true) {
      alwaysAfterClose = false;
    }
    if (typeof buttonType === "undefined") {
      buttonType = "success";
    }
    if (typeof callback !== "function") {
      callback = function() {

      };
    }
    if (typeof afterClose !== "function") {
      afterClose = function() {

      };
    }


    if (skipConfirm) {
      callback();
      afterClose();
      $bootstrapConfirm.off('hidden.bs.modal');

      return true;
    }


    if (!$bootstrapConfirm.length) {
      var confirmDialogHtml = "<div id='bootstrapConfirmDialog' class='modal fade sh-modal' data-backdrop='static' role='dialog'>" +
                              "<div class='modal-dialog'>" +
                              "<div class='modal-content'>" +
                              "<div class='modal-header'>" +
                              "<h4 id='bootstrapConfirmTitle' class='modal-title'></h4>" +
                              "<button type='button' class='close' data-dismiss='modal'>&times;</button>" +
                              "</div>" +
                              "<div id='bootstrapConfirmBody' class='modal-body'>" +
                              "" +
                              "</div>" +
                              "<div class='modal-footer'>" +
                              "<button type='button' class='btn btn-cancel btn-flat' data-dismiss='modal'>Cancel</button>" +
                              "<button type='button' class='btn btn-" +
                              buttonType +
                              "' data-dismiss='modal' id='bootstrapConfirmButton' style='white-space: nowrap'></button>" +
                              "</div>" +
                              "</div>" +
                              "</div>" +
                              "</div>";

      $("#app-layout").append(confirmDialogHtml);


      //noinspection JSJQueryEfficiency
      $bootstrapConfirm = $("#bootstrapConfirmDialog");
    }

    var $title  = $("#bootstrapConfirmTitle", $bootstrapConfirm);
    var $body   = $("#bootstrapConfirmBody", $bootstrapConfirm);
    var $button = $("#bootstrapConfirmButton", $bootstrapConfirm);


    $title.html(title);
    $body.html(message);
    $button.html(buttonText);

    if (typeof timer !== "undefined") {
      if (timer > 0) {
        $button.data("timer", timer);
        $button.append(" <span id='bootstrapConfirmDialogTimer'>(" + timer + ")</span>");
        $button.addClass("disabled");
        clearTimeout($button.data("timeout"));
        var thisTimeout = setTimeout(function() {
          siteGlobals.adjustBootstrapConfirmTimer($button);
        }, 1000);

        $button.data("timeout", thisTimeout);

      }
      else {
        $button.removeClass("disabled");
      }
    }

    $button.off();
    $button.click(function() {
      $bootstrapConfirm.modal("hide");
      callback();
      if (!alwaysAfterClose) {
        $bootstrapConfirm.on('hidden.bs.modal', function() {
          afterClose();
          $bootstrapConfirm.off('hidden.bs.modal');
        });
      }

    });
    $bootstrapConfirm.modal("show");

    if (alwaysAfterClose) {

      $bootstrapConfirm.off('hidden.bs.modal');
      $bootstrapConfirm.on('hidden.bs.modal', function() {
        afterClose();
        $bootstrapConfirm.off('hidden.bs.modal');
      });
    }

  },

  adjustBootstrapConfirmTimer: function($button) {

    var $timerEle    = $("#bootstrapConfirmDialogTimer");
    var currentTimer = $button.data("timer") - 1;
    $button.data("timer", currentTimer);
    $timerEle.html("(" + currentTimer + ")");
    if (currentTimer > 0) {

      clearTimeout($button.data("timeout"));
      var thisTimeout = setTimeout(function() {
        siteGlobals.adjustBootstrapConfirmTimer($button);
      }, 1000);
      $button.data("timeout", thisTimeout);
    }
    else {
      $timerEle.html("");
      $button.removeClass("disabled");
    }
  },
  shadeBackground            : function($ele, percent) {

    var color = $ele.css("background-color");

    var origColor = color;

    color      = color.substring(4);
    color      = color.slice(0, -1);
    var colors = color.split(",");

    var r = parseInt(colors[0]);
    var g = parseInt(colors[1]);
    var b = parseInt(colors[2]);

    var reverse = false;

    if (percent < 0) {
      r       = 255 - r;
      g       = 255 - g;
      b       = 255 - b;
      reverse = true;
      percent = percent * -1;
    }

    r -= parseInt(r * (percent / 100));
    g -= parseInt(g * (percent / 100));
    b -= parseInt(b * (percent / 100));

    r = (r < 0) ? 0 : r;
    g = (g < 0) ? 0 : g;
    b = (b < 0) ? 0 : b;

    if (reverse) {
      r = 255 - r;
      g = 255 - g;
      b = 255 - b;
    }

    var output = "rgb(" + r + ", " + g + ", " + b + ")";

    $ele.data("origbg", origColor);
    $ele.css("background-color", output);

  },

  /**
   * @call        => siteGlobals.ajaxForm();
   *
   * @date        => June 17, 2016
   *
   * @description => Handles setting up the csrf token for laravel, gathers all form inputs into a data variable,
   *                  and passes results from call back to function
   *
   * @param        form
   * @param        callback
   * @param        errorCallback
   * @param        extraData
   * @param        controller
   */
  ajaxForm: function(form, callback, errorCallback, extraData, controller) {
    controller = controller || false;

    var returnValues         = {};
    returnValues['success']  = false;
    returnValues['errors']   = [];
    returnValues['warnings'] = [];

    var tempValues           = siteGlobals.variableElementTest(form);
    returnValues['errors']   = returnValues['errors'].concat(tempValues['errors']);
    returnValues['warnings'] = returnValues['warnings'].concat(tempValues['warnings']);
    form                     = tempValues['element'];

    if (parseInt(returnValues['errors'].length) === 0) {
      var $form     = $(form).closest('form');
      var $inputs   = $form.find('input:not([type="button"]):not([type="reset"]):not([type="submit"])[name]:not([name=""]), select[name]:not([name=""]), textarea[name]:not([name=""])');
      var $files    = $inputs.filter('[type="file"]');
      var has_files = false;
      $files.each(function() {
        if (String($(this).val()) !== '') {
          has_files = true;
          return false;//break;
        }
      });
      var data;
      if (has_files) {
        data = new FormData();
        $inputs.each(function() {
          var $this = $(this);
          if ($this.attr("type") !== "radio" && $this.attr("type") !== "checkbox") {
            data.append($this.attr('name'), $this.val());
          }
          else if ($this.is(':checked')) {
            data.append($this.attr('name'), $this.val());
          }
        });
        $files.each(function() {
          $.each(
            this.files,
            function(i, file) {
              data.append("file_" + i, file);
            }
          );
        });
      }
      else {
        data = {};

        $inputs.each(function() {
          var $this = $(this);
          if ($this.attr("type") !== "radio" && $this.attr("type") !== "checkbox") {
            data[$this.attr('name')] = $this.val();
          }
          else if ($this.is(':checked')) {
            data[$this.attr('name')] = $this.val();
          }
        });
      }
      for (var dataProp in extraData) {
        // While looping over the properties of the extra data given to send with the form be certain that property
        // is actually an intentional property and that it is not already included in the form data. If either of
        // these statements is incorrect then ignore that property.
        if (extraData.hasOwnProperty(dataProp) && !data.hasOwnProperty(dataProp)) {
          data[dataProp] = extraData[dataProp];
        }
      }
      var defaultController = true;
      if (!controller) {
        var url    = $form.attr('action');
        controller = url.replace(/^.*\/\/[^\/]+/, '');
        var index  = controller.indexOf('/ajax');
        if (index !== -1) {
          controller = controller.slice(0, index);
        }
        controller = controller.replace(/^\//, '');
      }
      else {
        defaultController = false;
      }


      var storeReturn = siteGlobals.ajaxStore(controller, callback, data, errorCallback, defaultController, has_files);
      for (var returnProp in storeReturn) {
        if (storeReturn.hasOwnProperty(returnProp)) {
          returnValues['ajaxStore-' + returnProp] = storeReturn[returnProp];
        }
      }
      if (returnValues['ajaxStore-success']) {
        returnValues['success'] = true;
      }
    }
    else if (siteGlobals.consoleLog) {
      console.log(returnValues['errors']);
    }
    if (siteGlobals.consoleLog && returnValues['warnings'].length > 0) {
      console.log(returnValues['warnings']);
    }
    return returnValues;
  },

  /**
   * @call        => siteGlobals.ajaxStore();
   *
   * @date        => June 17, 2016
   *
   * @description => Handles setting up the csrf token for laravel and passes results from call back to function
   *
   * @param        controller
   * @param        callback
   * @param        data
   * @param        errorCallback
   * @param        defaultController
   * @param        has_files
   */
  ajaxStore: function(controller, callback, data, errorCallback, defaultController, has_files) {
    var returnValues        = {};
    returnValues['success'] = false;
    returnValues['errors']  = [];

    controller    = controller || false;
    data          = data || {};
    callback      = callback || function(response) {
      if (siteGlobals.consoleLog) {
        console.log(response);
      }
      return true;
    };
    errorCallback = errorCallback || function(response) {
      if (siteGlobals.consoleLog) {
        console.log(response);
      }
      return false;
    };

    if (!controller) {
      returnValues['errors'].push('SH_ERROR: Controller was left "undefined" but is required.');
    }
    if (typeof controller !== "string") {
      returnValues['errors'].push('SH_ERROR: typeof controller != "string"');
    }
    if (typeof data !== "object") {
      returnValues['errors'].push('SH_ERROR: typeof data != "object"');
    }
    if (typeof callback !== "function") {
      returnValues['errors'].push('SH_ERROR: typeof callback != "function"');
    }
    if (typeof errorCallback !== "function") {
      returnValues['errors'].push('SH_ERROR: typeof errorCallback != "function"');
    }
    if (!siteGlobals.csrfToken) {
      returnValues['errors'].push('SH_ERROR: CSRF Token is not set.');
    }

    if (defaultController) {
      controller = controller + '/ajax-store';
    }
    else {
      if (controller.toLowerCase().indexOf('update') !== -1 || controller.toLowerCase().indexOf('edit') !== -1) {
        data['_method'] = 'PATCH';
      }
    }
    //only if all parameters pass checks and the csrf token is set should we load
    {
      if (parseInt(returnValues['errors'].length) === 0) {
        var ajax_url = '/' + controller;
        if (controller.indexOf('http') !== -1) {
          ajax_url = controller;
        }
        if (has_files) {
          $.ajax({
            url        : ajax_url,
            method     : "POST",
            cache      : false,
            contentType: false,
            processData: false,
            data       : data,
            async      : true,
            beforeSend : function(xhr) {
              return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
            },
            success    : function(response) {
              callback.call(siteGlobals, response);
            },
            error      : function(response) {
              if (parseInt(response.status) === 419) {
                response.responseText = jQuery.parseJSON(response.responseText);
              }
              if (parseInt(response.status) === 422) {
                response.responseText = jQuery.parseJSON(response.responseText);
              }
              errorCallback.call(siteGlobals, response);
            }
          });
          returnValues['success'] = true;
        }
        else {
          $.ajax({
            url       : ajax_url,
            method    : "POST",
            data      : data,
            async     : true,
            beforeSend: function(xhr) {
              return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
            },
            success   : function(response) {
              callback.call(siteGlobals, response);
            },
            error     : function(response) {
              if (parseInt(response.status) === 419) {
                response.responseText = jQuery.parseJSON(response.responseText);
              }
              if (parseInt(response.status) === 422) {
                response.responseText = jQuery.parseJSON(response.responseText);
              }
              errorCallback.call(siteGlobals, response);
            }
          });
          returnValues['success'] = true;
        }
      }
      else {
        if (siteGlobals.consoleLog) {
          console.log(returnValues['errors']);
        }
      }
    }
    return returnValues;
  },

  /**
   * @call        => siteGlobals.ajaxLoad();
   *
   * @date        => June 15, 2016
   *
   * @description => Handles setting up the csrf token for laravel and passes results from call back to function
   *
   * @param        controller
   * @param        callback
   * @param        data
   * @param        errorCallback
   */
  ajaxLoad: function(controller, callback, data, errorCallback) {
    var returnValues        = {};
    returnValues['success'] = false;
    returnValues['errors']  = [];

    controller    = controller || false;
    data          = data || {};
    callback      = callback || function(response) {
      if (siteGlobals.consoleLog) {
        console.log(response);
      }
      return true;
    };
    errorCallback = errorCallback || function(response) {
      if (siteGlobals.consoleLog) {
        console.log(response);
      }
      return false;
    };

    if (!controller) {
      returnValues['errors'].push('SH_ERROR: Controller was left "undefined" but is required.');
    }
    if (typeof controller !== "string") {
      returnValues['errors'].push('SH_ERROR: typeof controller != "string"');
    }
    if (typeof data !== "object") {
      returnValues['errors'].push('SH_ERROR: typeof data != "object"');
    }
    if (typeof callback !== "function") {
      returnValues['errors'].push('SH_ERROR: typeof callback != "function"');
    }
    if (typeof errorCallback !== "function") {
      returnValues['errors'].push('SH_ERROR: typeof errorCallback != "function"');
    }
    if (!siteGlobals.csrfToken) {
      returnValues['errors'].push('SH_ERROR: CSRF Token is not set.');
    }

    //only if all parameters pass checks and the csrf token is set should we load
    if (parseInt(returnValues['errors'].length) === 0) {
      $.ajax({
        url       : '/' + controller + '/ajax-load',
        type      : "POST",
        data      : data,
        beforeSend: function(xhr) {
          return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
        },
        success   : function(response) {
          callback.call(siteGlobals, response);
        },
        error     : function(response) {
          errorCallback.call(siteGlobals, response);
        }
      });
      returnValues['success'] = true;
    }
    else {
      if (siteGlobals.consoleLog) {
        console.log(returnValues['errors']);
      }
    }
    return returnValues;
  },

  resizeTextarea: function(textarea) {
    $(textarea).css("height", "5px");
    $(textarea).css("height", parseInt(textarea.scrollHeight) + "px");
    $(textarea).css("overflow", "hidden");
  },

  clearForm: function($form) {
    //get inputs
    var $inputs = $form.find('input:not([type="button"]):not([type="reset"]):not([type="submit"]), select, textarea');
    //clear all inputs
    $inputs.val('').prop('checked', false).filter('select').find('option:first-child').prop('selected', true);
    $inputs.find('[selected]').prop('selected', true);
    $inputs.filter('select.selectpicker').selectpicker('render').selectpicker('refresh');
    $inputs.filter('[checked]').prop('checked', true);
    $inputs.filter('[value]').each(function() {
      var $this = $(this);
      $this.val($this.attr('value'));
    });
  },

  setForm: function($form, value_object) {
    //get inputs
    var $inputs = $form.find('input:not([type="button"]):not([type="reset"]):not([type="submit"]), select, textarea');
    //loop over values and id_or_name pairs
    for (var id_or_name in value_object) {
      //make sure this id_or_name is not a property from javascript prototype objects
      if (!value_object.hasOwnProperty(id_or_name)) {
        continue;
      }
      //check if the id_or_name was an id
      var $input = $inputs.filter('#' + id_or_name);
      if ($input.length < 1) {
        //check if the id_or_name was an name
        $input = $inputs.filter('[name=' + id_or_name + ']');
        if ($input.length < 1) {
          //neither skip it...
          console.log('warning: field not found:  "' + id_or_name + '"');
          continue;
        }
      }
      // get the value for this id_or_name
      var value = value_object[id_or_name];
      //check what kind of input we are setting
      //select and textarea elements don't have a type but that's fine the default catches them and works just fine
      switch ($input.attr('type')) {
        //--------------------------
        case 'checkbox':
          if ($input.val() === value) {
            $input.attr('checked', true);
          }
          else {
            $input.attr('checked', false);
          }
          break;
        //--------------------------
        case 'radio':
          $input.filter('[value=' + value + ']').attr('checked', true);
          break;
        //--------------------------
        default:
          $input.val(value);
          break;
      }
      if ($input.is('select.selectpicker')) {
        $input.selectpicker('render').selectpicker('refresh');
      }
    }
  },

  setPageScrollValues: function() {
    var bodyHeight    = siteGlobals.$body.height() - siteGlobals.$window.height();
    var contentHeight = $("#sh-cp-content").height() - siteGlobals.$window.height();

    //never go below 0
    siteGlobals.endOfPageScroll = Math.max(0, bodyHeight, contentHeight);
  },

  /**
   * @call        => siteGlobals.reInitiate();
   *
   * @date        => June 15, 2016
   *
   * @description => Re-initializes values, jQuery access, and event handlers that may need to be updated.
   *                  This should be called if the window re-sizes or if the document height changes for any reason.
   *
   */
  reInitiate: function() {
    siteGlobals.setPageScrollValues();

    // Remove all elements with the 'rm-if-js' class these elements are necessary if javascript is not available.
    $('.rm-if-js')
      .remove();

    // All of the elements with 'js-enable' are essentially non-existent until the class is removed via javascript
    // These elements are only helpful if javascript is available so otherwise they are hidden.
    $('.js-enable')
      .removeClass('js-enable');

    $('[data-toggle="popover"]').popover({
      html   : true,
      trigger: "focus"
    });
  },

  anchorScroll: function(hash_id, force) {
    if (hash_id === "#") {
      return;
    }
    force = force || false;
    if (!force && hash_id === "#order-form") {
      return;
    }
    var $test_element = $(hash_id);
    if ($test_element.length < 1) {
      $test_element = $('[name="' + hash_id.substring(1) + '"]');
    }
    if ($test_element.length > 0) {
      var $scrollable_content = siteGlobals.$document;
      if (siteGlobals.$body.hasClass('cp')) {
        // $scrollable_content = $('#sh-cp-content');
        $scrollable_content = $('#cp-main-scroll-element');
      }
      $scrollable_content.each(function() {
        $(this).data("remember_scroll", $(this).scrollTop());
      });
      window.location.hash = hash_id;
      $scrollable_content.each(function() {
        $(this).scrollTop($(this).data("remember_scroll"));
      });
      siteGlobals.scrollToElement($test_element);
    }
  },

  /**
   * @call        => siteGlobals.initiate();
   *
   * @date        => June 15, 2016
   *
   * @description => Initializes starting values, saves jQuery access to local globals, and sets event handlers.
   *
   */
  initiate: function() {
    siteGlobals.values              = [];
    siteGlobals.values['csrf_life'] = blade_layout['csrf_life'];

    // Remove class 'no-js' from body so that css alterations can be made.
    $('#app-layout').removeClass('no-js');

    // Remove all elements with the 'rm-if-js' class these elements are necessary if javascript is not available.
    $('.rm-if-js').remove();

    // All the elements with 'js-enable' are essentially non-existent until the class is removed via javascript
    // These elements are only helpful if javascript is available so otherwise they are hidden.
    $('.js-enable').removeClass('js-enable');

    siteGlobals.$window                          = $(window);
    siteGlobals.$document                        = $(document);
    siteGlobals.$html                            = $('html');
    siteGlobals.$head                            = $('head');
    siteGlobals.$body                            = $('body');
    siteGlobals.$site_page_content               = $('#sh-page-content');
    siteGlobals.$js_construction_zone            = $('#js-construction-zone');
    siteGlobals.$toaster_notifications_container = $('#toaster-notifications-container');

    // siteGlobals.delayAddExtraIcons();

    siteGlobals.endOfPageScroll = siteGlobals.$body.height() - siteGlobals.$window.height();

    siteGlobals.url      = window.location.href;
    siteGlobals.url      = siteGlobals.url.split('?')[0];
    siteGlobals.base_url = window.location.protocol + '//' + window.location.hostname + '/';

    if (window.console) {
      if (typeof window.console.log === 'function') {
        siteGlobals.consoleLog = true;
      }
    }
    siteGlobals.csrfToken = $('meta[name="csrf-token"]').attr('content');

    /*****************************************************************************/
    // On Page Anchor Smoothness
    /*****************************************************************************/
    siteGlobals.$window.on('hashchange', function(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (e.stopPropagation) {
        e.stopPropagation();
      }

      return false;// stop the page jump
    });

    siteGlobals.$document.on('hashchange', function(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (e.stopPropagation) {
        e.stopPropagation();
      }

      return false;// stop the page jump
    });

    siteGlobals.$site_page_content.find('[href^="#"]:not([data-toggle]):not(.normal)').click(function(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      var hash_id = $(e.target).closest('[href^="#"]');
      if (hash_id.length > 0) {
        hash_id = hash_id.attr('href');
        siteGlobals.anchorScroll(hash_id);
      }
      return false;// stop the page jump
    });

    if (location.hash) {               // do the test straight away
      history.scrollRestoration = "manual";
      siteGlobals.$window.scrollTop(0);         // execute it straight away
      setTimeout(function() {
        siteGlobals.$window.scrollTop(0);     // run it a bit later also for browser compatibility
        siteGlobals.anchorScroll(location.hash, true);
        if (location.hash === "#order-form") {
          focusElementPreventScroll($("#full_name"));
          // hmmm, something is stealing the focus after this. Seems nearly impossible to determine what though, so just try again in half a
          // second...
          setTimeout(function() {
            focusElementPreventScroll($("#full_name"));
          }, 500);
        }
      }, 1);
    }
    /*****************************************************************************/
    /*****************************************************************************/

    /*****************************************************************************/
    // Bootstrap Modal Initialization Fix
    /*****************************************************************************/
    siteGlobals.$body.on('shown.bs.modal', '.modal', function(e) {
      var $modal = $(e.target).closest('.modal');
      if ($modal.hasClass("data-grid-settings-modal")) {
        return true;
      }
      if ($modal.hasClass("sh-notification-modal")) {
        return true;
      }

      if ($modal.length > 0) {
        $modal.find('input:not([type="hidden"]):visible, select:visible, textarea:visible, button:visible:not([data-dismiss=modal])')
              .eq(0)
              .focus();

      }
    });

    /*****************************************************************************/
    /*****************************************************************************/

    /*****************************************************************************/
    // Popover adjustments and initialization
    /*****************************************************************************/
    Popper.Defaults.placement = "bottom";

    $('[data-toggle="popover"]').popover({
      html   : true,
      trigger: 'focus'
    });
    /*****************************************************************************/
    /*****************************************************************************/

    /*****************************************************************************/
    // CSS Modal Event that stops scrolling on body when the modal is open
    /*****************************************************************************/
    siteGlobals.$css_modal_checkboxes = $('input.css-modal-checkbox');
    if (siteGlobals.$css_modal_checkboxes.is(':checked')) {
      if (!siteGlobals.$body.hasClass('modal-open')) {
        siteGlobals.$body.addClass('modal-open');
      }
    }
    siteGlobals.$css_modal_checkboxes.on('input change blur keyup', function() {
      if (siteGlobals.$css_modal_checkboxes.is(':checked')) {
        if (!siteGlobals.$body.hasClass('modal-open')) {
          siteGlobals.$body.addClass('modal-open');
        }
        return true;
      }
      if (siteGlobals.$body.hasClass('modal-open')) {
        siteGlobals.$body.removeClass('modal-open');
      }
      return true;
    });

  }
};

siteGlobals.initiate();

$("html").scrollTop(0);

function serializedArrayToObject(array)
{
  var output = {};
  array.forEach(function(element) {
    if (typeof output[element.name] === "undefined") {
      output[element.name] = element.value;
    }
    else {
      if (typeof output[element.name] === "object") {
        output[element.name].push(element.value);
      }
      else {
        output[element.name] = [output[element.name], element.value];
      }

    }

  });

  return output;
}

$(function() {
  $("[data-toggle=collapse]").each(function() {
    if (($(this).attr("data-target") === "#" || $(this).attr("data-target") === "javascript:void(0);" ||
         !$($(this).attr("data-target")).hasClass("show")) &&
        ($(this).attr("href") === "#" || $(this).attr("href") === "javascript:void(0);" ||
         !$($(this).attr("href")).hasClass("show"))) {
      $(this).addClass("collapsed");
    }
  });
});

$("#approved-sender-convert-legacy-record-btn").click(function() {
  var sender = $("#approved-sender-settings-header").text();
  $("#approved-sender-add-new-button").click();
  $("#sender-address").val(sender);
});


var $kbSideBar = $(".kb-side-bar-scroll-wrapper");
$kbSideBar.find("a").off();
$kbSideBar.find("a").click(function(e) {

  var href = $(this).attr("href");

  if (typeof href === "undefined" || href.length < 1) {
    return true;
  }
  if (href.charAt(0) !== "#") {
    return true;
  }
  var topBarHeight = $("#cp-top-bar").height() + $(".kb-side-bar-fixed-header").height() + 20;

  e.preventDefault();
  $kbSideBar.scrollTop($(href).offset().top - topBarHeight);
  return false;
});

modalJs.class = "sh-modal";


$(".link-submit-form").click(function() {
  $(this).closest("form").submit();
});

$(".link-post").click(function() {
  var $form = $("<form>");
  $form.attr("METHOD", "POST").attr("action", $(this).attr("data-url"));
  var $csrfField = $("<input>");
  $csrfField.attr("name", "_token");
  $csrfField.attr("type", "hidden");
  $csrfField.attr("value", $('meta[name="csrf-token"]').attr('content'));
  $form.html($csrfField);
  $("body").append($form);
  $form.submit();

});

function jsFormatMoney(money)
{
  return parseFloat(money).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
}

$(document).ready(function() {
  $("#start-free-trial-button-wrapper-pre-js").remove();
  $("#start-free-trial-button-wrapper").show();
  $(".enable-on-ready").prop("disabled", false);
});

//https://stackoverflow.com/a/6234804/4901390
function escapeHtml(unsafe)
{
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

$("body").on("click", "#dismiss-adblocker-warning", function() {
  $.ajax({
    url        : "/dismiss-adblock-warning",
    method     : "POST",
    cache      : false,
    contentType: false,
    processData: false,
    async      : true,
    beforeSend : function(xhr) {
      return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
    },
    success    : function(response) {
      window.adblockerWarningToast.set({time: 0});
    },
    error      : function(response) {
      // do nothing...
    }
  });
});

var tawkWrapped = false;

function wrapTawkWidget()
{
  var $tawkWidget = $(".widget-visible");
  if ($tawkWidget.length > 0) {
    var $wrapper = $("<div>");
    $wrapper.addClass("tawk-widget-wrapper");
    $tawkWidget.wrap($wrapper);
    tawkWrapped = true;
  }
  else {
    // try again in a second, up to 10 times
    if (typeof wrapTawkWidget.counter === "undefined") {
      wrapTawkWidget.counter = 0;
    }
    wrapTawkWidget.counter++;
    if (wrapTawkWidget.counter < 40) {
      setTimeout(wrapTawkWidget, 250);
    }
  }

}


wrapTawkWidget();

/* resources/assets/js/app/kb_sidebar.js */
$("#kb-side-bar-hide-button").click(function () {
    $('#kb-side-bar').hide();
    $('.show-kb-side-bar').css({display: "inline-block"});
    $("#cp-main-scroll-element").show();
    dataGridHelper.stickyHeaderResizeFix();
});


$(".show-kb-side-bar").click(function () {
    $("#cp-main-scroll-element").hide();
    $('#kb-side-bar').show();
    $('.show-kb-side-bar').hide();
    siteGlobals.scrollToKb();
    dataGridHelper.stickyHeaderResizeFix();
});

function openKbSideBarIfDesktop(closeOnResize) {
    closeOnResize = closeOnResize || false;
    if ($(window).width() > 1000) {
        $(".show-kb-side-bar:first").click();
        var closeOnResizeCallback = function () {
            if ($(window).width() <= 1000) {
                $("#kb-side-bar-hide-button").click();
                $(window).off("resize", closeOnResizeCallback);
            }
        };
        if (closeOnResize) {
            $(window).resize(closeOnResizeCallback);
        }
    }
}

$(".kb-link").click(function (e) {
    var kbId = parseInt($(this).attr("data-kb"));
    if (kbId < 1) {
        return true;
    }
    var $article = $("#kb-article-" + kbId);
    if (!$article.length) {
        return true;
    }

    e.preventDefault();
    $("#cp-main-scroll-element").hide();
    $('#kb-side-bar').show();
    $('.show-kb-side-bar').hide();
    siteGlobals.scrollToKb(kbId);
});

/* resources/assets/js/app/slick_start.js */


var slickStart =
      {

        $prev_arrow: $('<button></button>')
          .attr('type', 'button')
          .addClass('slick-prev')
          .append($('<div></div>')
            .addClass('slider-prev fa fa-chevron-circle-left fa-2x fa-fw')),
        // local global to store jQuery access to a freshly created .slick-prev element

        $next_arrow: $('<button></button>')
          .attr('type', 'button')
          .addClass('slick-next')
          .append($('<div></div>')
            .addClass('slider-next fa fa-chevron-circle-right fa-2x fa-fw')),
        // local global to store jQuery access to a freshly created .slick-next element


        slickTestimonialsBasicHorizontal: function() {
          var $testimonials = $("#testimonials-basic-horizontal-slider");
          if ($testimonials.length > 0) {
            $testimonials.slick({
              prevArrow    : slickStart.$prev_arrow.html(),
              nextArrow    : slickStart.$next_arrow.html(),
              arrows       : false,
              accessibility: false,
              draggable    : false,
              pauseOnHover : true,
              pauseOnFocus : false,
              touchMove    : false,
              slidesToShow : 1,
              autoplay     : true,
              autoplaySpeed: 9000
            });
          }
        },
        slickOrder                      : function() {
          var $order = $("#order-slider");
          if ($order.length > 0) {
            $order.slick({
              prevArrow    : slickStart.$prev_arrow.html(),
              nextArrow    : slickStart.$next_arrow.html(),
              arrows       : false,
              accessibility: false,
              infinite     : false,
              draggable    : false,
              swipe        : false,
              touchMove    : false,
              speed        : 300,
              slidesToShow : 1
            });
          }
        },

        slickTour: function() {
          var $tour = $("#tour");
          if ($tour.length > 0) {
            $tour.slick({
              prevArrow   : slickStart.$prev_arrow.html(),
              nextArrow   : slickStart.$next_arrow.html(),
              infinite    : false,
              dots        : true,
              slidesToShow: 1,
              responsive  : [
                {
                  breakpoint: 992,
                  settings  : {
                    arrows: false
                  }
                }
              ]
            });
          }
        },


        slickTestimonials: function() {
          var $testimonials = $("#testimonials");
          if ($testimonials.length > 0) {
            $testimonials.slick({
              prevArrow    : slickStart.$prev_arrow.html(),
              nextArrow    : slickStart.$next_arrow.html(),
              arrows       : false,
              accessibility: false,
              draggable    : false,
              pauseOnHover : false,
              pauseOnFocus : false,
              touchMove    : false,
              slidesToShow : 1,
              autoplay     : true,
              autoplaySpeed: 9000
            });
          }
        },

        initialize: function() {
          slickStart.slickOrder();
          slickStart.slickTestimonials();
          slickStart.slickTour();
          slickStart.slickTestimonialsBasicHorizontal();
          siteGlobals.reInitiate();
        }
      };
slickStart.initialize();

/* resources/assets/js/app/navbar.js */
var siteNavbar = {


  $navbar                  : null, // jQuery access to the #navbar element
  $scroll_to_top_button    : null, // jQuery access to the #scroll-to-top-button element
  $mobile_nav_button       : null, // jQuery access to the [data-target=#navbar-collapse] element
  $navbar_collapse         : null, // jQuery access to the #navbar-collapse element
  $window                  : null, // jQuery access to the global window object
  scroll_timeout           : null, // any pending scroll_timeout
  resize_timeout           : null, // any pending resize_timeout
  mobile_nav_button_timeout: null, // any pending mobile_nav_button_Timeout
  window_height            : null, // pixel measurement of window height (AKA 100vh)
  calc_height_for_cp_nav   : null, // pixel measurement that the nav min height when domain chooser is open

  /**
   * @call        => siteNavbar.compact();
   *
   * @date        => May 5, 2016
   *
   * @description => Adds the class 'compact' to the #navbar element which:
   *                    - removes the 20px padding from the top and bottom.
   *                    - changes the height from 90px to 50px
   *
   */
  compact: function() {
    siteNavbar.$navbar.addClass('compact');
  },

  /**
   * @call        => siteNavbar.expand();
   *
   * @date        => May 5, 2016
   *
   * @description => Removes the class 'compact' from the #navbar element which:
   *                    - re-adds the 20px padding to the top and bottom.
   *                    - changes the height from 50px to 90px
   *
   */
  expand: function() {
    siteNavbar.$navbar.removeClass('compact');
  },

  /**
   * @call        => siteNavbar.scrolledEnoughToCompact();
   *
   * @date        => May 5, 2016
   *
   * @description => Tests current scroll position to see if the user has scrolled one full screen height down.
   *
   * @return      boolean
   *                    Returns true if the user has scrolled far enough for the compact function to be needed
   *                    Returns false if the user has not scrolled far enough for the compact function to be needed
   *
   */
  scrolledEnoughToCompact: function() {
    return (siteNavbar.window_height < siteNavbar.$window.scrollTop());
  },

  compactOnScrollPages: [
    '',
    'reseller-program',
    'beta/reseller-program',
    'beta/',
    'msp',
    'experimental-front-page',
    'experimental-reseller',
    'outbound-delivery',
    'microsoft-365',
    'm365',
    'enterprise'
  ],

  /**
   * @call        => siteNavbar.pageShouldCompactOnScroll();
   *
   * @description => Determines if the current page should start with the tall transparent homepage nav
   *                 and compact it once the user scrolls down.
   *
   * @return      boolean
   */
  pageShouldCompactOnScroll: function() {
    var page = window.location.pathname.replace(/^\/+/, '');

    if (page === '' && window.location.hash.length > 0) {
      return true;
    }

    return siteNavbar.compactOnScrollPages.indexOf(page) !== -1;
  },

  /**
   * @call        => siteNavbar.mobileNavIsOpen();
   *
   * @description => Tests current scroll position to see if the user has scrolled one full screen height down.
   *
   * @return      boolean
   *                    Returns false if the mobile nav menu is open
   *                    Otherwise returns true
   *
   */
  mobileNavIsOpen: function() {
    return siteNavbar.$navbar_collapse.attr('aria-expanded') == "true";
  },

  /**
   * @call        => siteNavbar.scrollHandler();
   *
   * @date        => May 6, 2016
   *
   * @description => If the scroll position permits the navbar to be compact it is done so if not it is made to be
   *                 expanded.
   *
   *
   */
  scrollHandler: function() {
    if (siteNavbar.scrolledEnoughToCompact() || siteNavbar.mobileNavIsOpen()) {
      siteNavbar.compact();
    }
    else {
      siteNavbar.expand();
    }
    siteNavbar.scroll_timeout = null
  },

  /**
   * @call        => siteNavbar.resizeHandler();
   *
   * @description => update the siteNavbar.window_height with the current value
   *
   *
   */
  resizeHandler: function() {
    siteNavbar.window_height = siteNavbar.$window.height();
    if (siteNavbar.$cp_nav_bar.length > 0 && !('ontouchstart' in window)) {
      if (window.innerWidth < 992) {
        siteNavbar.$cp_nav_bar.find('.dropdown-toggle:not(.sm-window-size)')
          // .attr('href', 'javascript:void(0)')
          // .unbind('click',siteGlobals.bootstrapOnlyHoverActivateHandler)
                  .addClass('sm-window-size');
      }

      else {
        siteNavbar.$cp_nav_bar.find('.dropdown-toggle.sm-window-size')
                  .removeClass('sm-window-size');
        // .click(siteGlobals.bootstrapOnlyHoverActivateHandler);
        // .each(function()
        // {
        //   $(this).attr('href', $(this).attr('data-href'));
        // });
      }
    }
  },
  ignoreClick  : function(e) {
    if (e.stopPropagation) {
      e.stopPropagation()
    }
  },

  /**
   * @call        => siteNavbar.checkAndSetNavLinkStatus();
   *
   * @date        => August 30, 2016
   *
   * @description => Checks if elements on page exist and links to them instead of new pages if at all possible.
   *
   */
  checkAndSetNavLinkStatus: function() {
    // var $triple_feature_highlight = siteGlobals.$site_page_content.find(".features.stripe");
    // var $highlighted_features = siteGlobals.$site_page_content.find("#highlighted-features");
    var $order_form   = siteGlobals.$site_page_content.find("#order-stripe");
    var $order_form_b = siteGlobals.$site_page_content.find("#order-form");

    if ($order_form.length > 0) {
      $('#free-trial-nav-link').click(function(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        siteGlobals.scrollToElement($order_form_b);
      });
      $('[href="#order-stripe"]').click(function(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        siteGlobals.scrollToElement($order_form);
        focusElementPreventScroll($("#full_name"));
      });
      $('[href="#order-form"]').click(function(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        siteGlobals.scrollToElement($order_form_b);
        focusElementPreventScroll($("#full_name"));
      });
    }
  },


  /**
   * @call        => siteNavbar.initiateNavbarSettingsAndEvents();
   *
   * @date        => May 5, 2016
   *    @edit        => May 30, 2016
   *                    De-bounce and small optimizations
   *
   * @description => Initializes starting values, saves jQuery access to local globals, and sets event handlers.
   *
   */
  initiateNavbarSettingsAndEvents: function() {


    siteNavbar.$navbar               = $("#navbar");
    siteNavbar.$scroll_to_top_button = $("#scroll-to-top-button");
    siteNavbar.$domainChooser        = $("#domainChooserSelect");
    siteNavbar.$accountChooser       = $("#accountChooserSelect");
    siteNavbar.$mobile_nav_button    = siteNavbar.$navbar.find("[data-target='#navbar-collapse']");
    siteNavbar.$navbar_collapse      = $("#navbar-collapse");
    siteNavbar.$window               = $(window);
    siteNavbar.$cp_nav_bar           = $("#cp-nav-bar");


    if (siteNavbar.$cp_nav_bar.length > 0) {
      siteNavbar.$cp_nav_bar.find('.dropdown-toggle').each(function() {
        $(this).attr('data-href', $(this).attr('href'));
      });
    }
    siteNavbar.resizeHandler();
    if (siteNavbar.$domainChooser.length > 0) {
      setTimeout(function() {
        siteNavbar.$domainChooser.selectpicker({
          dropupAuto: false
        });
        siteNavbar.$domainChooser.selectpicker('setStyle', 'hugRight', 'add');
        var $selector = siteNavbar.$domainChooser.siblings('.bootstrap-select');


        var $menu = $selector.find('.dropdown-menu');
        setTimeout(function() {
          siteNavbar.$navbar_collapse.css('display', 'block');
          $menu.css('display', 'block');
          siteNavbar.calc_height_for_cp_nav =
            $menu.offset().top - siteNavbar.$navbar_collapse.offset().top + $menu.outerHeight() - 38;
          siteNavbar.$navbar_collapse.css('display', '');
          $menu.css('display', '');
        }, 0);

        $selector.on('mouseup', function(e) {
            if (window.innerWidth < 992) {
              var $menu   = $(e.target).closest('.bootstrap-select').find('.dropdown-menu');
              var $navbar = $('#navbar-collapse.cp');

              if (!$menu.is(':visible')) {
                $navbar.css('min-height', siteNavbar.calc_height_for_cp_nav);
                // siteGlobals.$window.resize(function(){});
              }
              else {
                $navbar.css('min-height', '');
              }
            }
          }
        );
      }, 0);
    }

    // Borrowed code from stack overflow here to de-bounce the scroll event
    // http://stackoverflow.com/a/15591162/4059832
    // de-bounced scroll handler
    // using a short timeout to wait until user has stopped scrolling to run any events
    if (siteNavbar.pageShouldCompactOnScroll()) {
      if (spicy) {
        siteNavbar.$window.scroll(
          function() {
            if (siteNavbar.scroll_timeout !== null) {
              // clear the timeout, if one is pending
              clearTimeout(parseInt(siteNavbar.scroll_timeout));
              siteNavbar.scroll_timeout = null;
            }
            siteNavbar.scroll_timeout =
              setTimeout(
                function() {
                  siteNavbar.scrollHandler();
                },
                50 // super short timeout
                // If this is longer the animation takes too long to play
                // This short time is still helping clean up the dozens of useless scroll events firing
              );
          }
        );
      }
    }
    // de-bounced resize handler
    // using a short timeout to wait until user has stopped altering screen size to run any events

    siteNavbar.$window.resize(
      function() {
        if (siteNavbar.resize_timeout != null) {
          // clear the timeout, if one is pending
          clearTimeout(siteNavbar.resize_timeout);
          siteNavbar.resize_timeout = null;
        }
        siteNavbar.resize_timeout =
          setTimeout(
            function() {
              siteNavbar.resizeHandler();
            },
            250
          );
      }
    );

    if (siteNavbar.$domainChooser.length > 0) {
      siteNavbar.$domainChooser.on('input change blur keyup',
        function() {
          $(this).closest("form").submit();
        }
      );
    }
    if (siteNavbar.$accountChooser.length > 0) {
      siteNavbar.$accountChooser.on('input change blur keyup',
        function() {
          $(this).closest("form").submit();
        }
      );
    }

    // click handler for #scroll-to-top-button

    siteNavbar.$scroll_to_top_button.click(
      function() {
        siteGlobals.scrollToX(0);
      }
    );

    siteNavbar.$mobile_nav_button.click(
      function() {
        if (siteNavbar.mobile_nav_button_timeout !== null) {
          // clear the timeout, if one is pending
          clearTimeout(parseInt(siteNavbar.mobile_nav_button_timeout));
          siteNavbar.mobile_nav_button_timeout = null;
        }
        siteNavbar.mobile_nav_button_timeout =
          setTimeout(
            function() {
              siteNavbar.scrollHandler();
            },
            50
          );
      }
    );


    siteNavbar.checkAndSetNavLinkStatus();

  }
};
siteNavbar.initiateNavbarSettingsAndEvents();

/* resources/assets/js/app/home_page_banner.js */
var homePageBanner = {
  /**
   * Container to handle all paper-world container functions and items and interactions with the page/window
   */
  view: {
    $paperWorld   : null, // local view global to store jQuery access to the '#hpb-paper-world' element
    $window       : null, // local view global to store jQuery access to the window global
    width         : null, // local view global to cache the homePageBanner.view.$paperWorld.width()
    height        : null, // local view global to cache the homePageBanner.view.$paperWorld.height()
    scrollPosition: null, // local view global for the current user's scroll position
    scale         : null, // local view global that is the scale to be used on element created for paper-world
    isMobile      : null, // local view global boolean for whether or not it is mobile
    resizeTimeout : null, // local view global variable to store a timeout if there is currently one
    initiated     : false, // local view global boolean for whether or not it has been initiated once before

    /**
     * @call        => homePageBanner.view.mobileAndTabletcheck();
     *
     * @date        => May 17, 2016
     *
     * @description => Function taken directly and unaltered from http://stackoverflow.com/a/11381730/4059832
     *                  Essentially this performs a huge regex check on a few browser global variables to
     *                  determine if the device or rather the browser is a mobile client
     *
     */
    mobileAndTabletcheck: function() {
      // Initially we were checking if the device was a tablet... this isn't used any more but the function might be
      // called still... var check = false; (function ( a ) { if (
      // /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge
      // |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm(
      // os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows
      // ce|xda|xiino|android|ipad|playbook|silk/i.test( a ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a
      // wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s
      // )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1
      // u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-|
      // |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt(
      // |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg(
      // g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-|
      // |o|v)|zz)|mt(50|p1|v
      // )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v
      // )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-|
      // )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( a.substr( 0, 4 ) ) ) { check = true } })( navigator.userAgent ||
      // navigator.vendor || window.opera ); return check;
      return false;
    },

    /**
     * @call        => homePageBanner.view.randNum();
     *
     * @date        => May 11, 2016
     *
     * @description => Simple random number generator parsed to only 2 decimal places for speed optimization
     *                  in browser renderings and after that numbers that small aren't too meaningful
     *                  in this context.
     *
     * @param        min (NUMBER) --minimum allowed output
     * @param        max (NUMBER) --maximum allowed output
     */
    randNum: function(min, max) {
      // if min is not passed in it is set to 0
      min = typeof min !== 'undefined' ? min : 0;
      // if max is not passed in it is set to 1
      max = typeof max !== 'undefined' ? max : 1;

      return parseFloat(Math.random() * (max - min) + min)
        .toFixed(2);
    },

    /**
     * @call        => homePageBanner.view.initiate();
     *
     * @date        => May 10, 2016
     *
     * @description => Initializes starting view values, saves jQuery access to local view globals, and sets view event
     *   handlers.
     *
     */
    initiate: function() {
      homePageBanner.view.isMobile    = homePageBanner.view.mobileAndTabletcheck();
      homePageBanner.view.$window     = $(window);
      homePageBanner.view.$paperWorld = $("#hpb-paper-world");
      homePageBanner.view.width       = homePageBanner.view.$paperWorld.width();
      homePageBanner.view.height      = homePageBanner.view.$paperWorld.height();
      if (!homePageBanner.view.isMobile) {
        homePageBanner.view.scrollPosition = homePageBanner.view.$window.scrollTop();
      }

      //scale is used to scale down elements such as the clouds for smaller devices
      homePageBanner.view.scale = Math.min(parseFloat(homePageBanner.view.width / 1500), 1.0).toFixed(2);
      homePageBanner.view.scale = Math.max(parseFloat(homePageBanner.view.scale), 0.4).toFixed(2);// prevent scaling
                                                                                                  // below 40%;
      if (!homePageBanner.view.initiated) {
        homePageBanner.view.$window.resize(function() {
          if (homePageBanner.view.resizeTimeout != null) {
            // clear the timeout, if one is pending
            clearTimeout(parseInt(homePageBanner.view.resizeTimeout));
            homePageBanner.view.resizeTimeout = null;
          }
          homePageBanner.view.resizeTimeout =
            setTimeout(
              function() {
                homePageBanner.initiate();
              },
              2000
            );
        });
      }

    }
  },

  /**
   * Container to handle all paper-world city functions and items
   */
  city: {
    $cityLevels       : null, // local city global to store jQuery access to the ".hpb-city-depth-level" elements
    numberOfCityLevels: null, // local city global to store the length of the homePageBanner.city.$cityLevels array
    cityScrollTimeout : null, // local city global for any pending cityScrollTimeout

    /**
     * @call        => homePageBanner.city.distributeCityLevels();
     *
     * @date        => May 12, 2016
     *
     * @description => Calculates and distributes the city levels at depths according to the current scroll position
     *                  Further description details can be found next to each line of the function.
     *
     */
    distributeCityLevels: function() {
      var $cityLevels = homePageBanner.city.$cityLevels;
      var ii          = homePageBanner.city.numberOfCityLevels;

      // baseLevel determines which city level depth gets the baseOffset amount set this to
      // 0 for the front most level
      var baseLevel = 0;
      // baseOffset becomes the offset percentage amount for the baseLevel city level depth
      // all other city level depths move in relation to this offset
      var baseOffset = -55;
      // maxSpread (could be called the initialSpread)
      // is the amount in percentage between the farthest back city level and the
      // closest to the front city level when the screen is scrolled to the top of the window
      var maxSpread = 115;
      // using the #paper-world height as our window gives us more flexibility
      // in the allowed heights of our homePageBanner
      var height         = homePageBanner.view.height;
      // the current scroll position gives us the idea of a moving camera[AKA perspective]
      var scrollPosition = homePageBanner.view.scrollPosition;

      //******************************
      // Begin Calculations

      // currentPerspective is the angle we are viewing the city as a whole at
      // this is a percentage based variable on the height of the banner and
      // the current scroll position
      // Math.max is used with 0.1 to ensure that the perspective does not get below  10%
      // Math.max is used with 1.0 to ensure that the perspective does not get above 100%
      //    This both avoids animating the city after the banner is out of view as well as
      //        preventing the depth levels to be too close to each other or
      //        spread out farther than our maxSpread amount
      var currentPerspective = Math.min(Math.max(((height - scrollPosition) / height), 0.1), 1.0);

      // This defines the current distance from the first level of the city to the last level
      // AKA the spread of all city levels
      var currentSpread = currentPerspective * maxSpread;

      // Based on how many levels of the city there are and how many
      var depthBetweenLevels = currentSpread / (ii - baseLevel);

      //loop through the ii city levels and set their individual positions
      $cityLevels.each(function(i) {
        // ii - i gets the current index of the city level and determines what level and
        // therefore how many depthBetweenLevels needs to be used
        var cityLevelOffset = baseOffset + currentSpread - depthBetweenLevels * (ii - i);

        // ******
        // hack fix for front city level as it has so many short buildings
        if (i == 0) {
          cityLevelOffset += 35;
        }
        // ******

        //shed off extra decimals to enhance rendering performance
        cityLevelOffset = parseFloat(cityLevelOffset)
          .toFixed(2);

        // 'this' is the current city level as defined by the jQuery .each() method
        $(this)
          .css('transform', 'translateY(' + cityLevelOffset * -1 + '%)');
      });
    },

    /**
     * @call        => homePageBanner.city.initiate();
     *
     * @date        => May 12, 2016
     *
     * @description => Initializes starting city values, saves jQuery access to local city globals,
     *                  and sets event handlers that relate to the paper-world sky. Currently if
     *                  it detects that the device is mobile then it will not have city
     *                  levels move on scroll.
     *
     */
    initiate: function() {
      //The $cityLevels array is initiated in reverse standard order for better code comprehension.
      //This is done so that the city level in front is the first in the array
      //and the city level in the back is at the end of the array.
      homePageBanner.city.$cityLevels        = $(homePageBanner.view.$paperWorld.find(".hpb-city-depth-level")
                                                               .get()
                                                               .reverse());
      homePageBanner.city.numberOfCityLevels = homePageBanner.city.$cityLevels.length;

      if (!homePageBanner.view.isMobile) {
        //update the scroll position on load / refresh / re-initiation
        homePageBanner.view.scrollPosition = homePageBanner.view.$window.scrollTop();

        if (!homePageBanner.view.initiated) {

          homePageBanner.view.$window.scroll(
            function() {
              if (homePageBanner.city.cityScrollTimeout != null) {
                // clear the timeout, if one is pending
                clearTimeout(parseInt(homePageBanner.city.cityScrollTimeout));
                homePageBanner.city.cityScrollTimeout = null;
              }
              homePageBanner.city.cityScrollTimeout =
                setTimeout(
                  function() {
                    homePageBanner.view.scrollPosition = homePageBanner.view.$window.scrollTop();
                    homePageBanner.city.distributeCityLevels();
                  },
                  50 // super short timeout
                  // If this is longer the animation takes too long to play
                  // This short time is still helping clean up the dozens of useless scroll events firing
                );

            }
          );
        }
      }

      homePageBanner.city.distributeCityLevels();

    }
  },

  /**
   * Container to handle all paper-world sky functions and items
   */
  sky: {
    $sky     : null, //local sky global to store jQuery access to the '#hpb-sky' element
    $clouds  : null, //local sky global to store jQuery access to the '.hpb-cloud' elements
    lastCloud: null, //local sky global to store the index of the last cloud cluster used

    //local sky global to store the pre-selected css variable options for acceptable cloud formations
    cloudAttrOptions: [
      [
        {left: 150, top: -5, scale: 0.85},
        {left: 0, top: 50, scale: 0.7},
        {left: 175, top: 200, scale: 0.45}
      ],
      [
        {left: 150, top: -5, scale: 0.85},
        {left: 0, top: 50, scale: 0.7}
      ],
      [
        {left: 0, top: 150, scale: 0.55},
        {left: 150, top: 200, scale: 1.0}
      ],
      [{left: 0, top: 10, scale: 0.75}],
      [
        {left: 0, top: 60, scale: 0.5}
      ],
      [{left: 0, top: 80, scale: 1.0}],
      [
        {left: 100, top: 180, scale: 0.65},
        {left: 0, top: 200, scale: 0.55}
      ],
      [
        {left: 200, top: 180, scale: 0.85},
        {left: 0, top: 10, scale: 0.55}
      ],
      [
        {left: 0, top: 50, scale: 0.9},
        {left: 100, top: 120, scale: 0.65}
      ]
    ],

    cloudOptions_ii: null, //local sky global to store the length of the homePageBanner.sky.cloudAttrOptions array

    /**
     * @call        => homePageBanner.sky.updateCloudSelection();
     *
     * @date        => May 14, 2016
     *
     * @description => Reruns the jQuery selection to find all clouds in the DOM tree. Doing this does two important
     *                  things for us. First is that this makes certain that all clouds are available for other
     *                  functions. Secondly it removes the saved reference to any clouds that have been
     *                  removed from the DOM tree, which should effectively remove the element from
     *                  RAM destroying it entirely.
     *
     */
    updateCloudSelection: function() {
      homePageBanner.sky.$clouds = homePageBanner.sky.$sky.find('.hpb-cloud');
    },

    /**
     * @call        => homePageBanner.sky.getCloudIndex();
     *
     * @date        => June 3, 2016
     *
     * @description => Finds a cloud cluster index that is valid and not the same as the last one used
     *
     * @return      number index (INTEGER) a valid index for use on the homePageBanner.sky.cloudAttrOptions array
     */
    getCloudIndex: function() {
      var index = 0;
      do {
        index = Math.floor(homePageBanner.view.randNum(0, homePageBanner.sky.cloudOptions_ii - 1));
        if (index >= homePageBanner.sky.cloudOptions_ii) {
          index = homePageBanner.sky.cloudOptions_ii - 1;
        }
      }while (homePageBanner.sky.lastCloud != null && index == homePageBanner.sky.lastCloud);

      return index;
    },


    /**
     * @call        => homePageBanner.sky.getCloudIndex();
     *
     * @date        => June 3, 2016
     *
     * @description => Finds a cloud cluster index that is valid and not the same as the last one used
     *
     * @return      number index (INTEGER) a valid index for use on the homePageBanner.sky.cloudAttrOptions array
     */
    getCloudIndex: function() {
      var index = 0;
      do {
        index = Math.floor(homePageBanner.view.randNum(0, homePageBanner.sky.cloudOptions_ii - 1));
        if (index >= homePageBanner.sky.cloudOptions_ii) {
          index = homePageBanner.sky.cloudOptions_ii - 1;
        }
      }while (homePageBanner.sky.lastCloud != null && index == homePageBanner.sky.lastCloud);

      return index;
    },


    /**
     * @call        => homePageBanner.sky.createCloudCluster();
     *
     * @date        => May 14, 2016
     *    @edit        => June 3, 2016
     *                    Move index finding algorithm to separate function
     *
     * @description => Selects a cloud cluster to use if the index is not already provided and then proceeds to create
     *                 that cluster of clouds as HTML elements in the null namespace URI before adding each to the
     *                 DOM tree on the page. After they are all created, homePageBanner.sky.$clouds is then
     *                 updated to have them in its selection.
     *
     * @param        index (INTEGER) -- refers to the index of the desired cloud cluster to create
     * @param        extraLeft (INTEGER) -- refers to how far from the left this cloud cluster should start
     */
    createCloudCluster: function(index, extraLeft) {
      if (homePageBanner.sky.$clouds.length > 0 && typeof extraLeft == 'undefined') {
        if (homePageBanner.sky.$clouds.last().offset()['left'] < -100 * homePageBanner.view.scale) {
          return 0;
        }
      }
      if (homePageBanner.sky.$clouds.length < 12) {
        // if index is not passed in get a valid index
        index     = typeof index !== 'undefined' ? index : homePageBanner.sky.getCloudIndex();
        // if extraLeft is not passed in it is set to 0
        extraLeft = typeof extraLeft !== 'undefined' ? extraLeft : -500;

        homePageBanner.sky.lastCloud = index;
        var topOffset                = homePageBanner.view.randNum(-10, 25);
        var selectedCloudOption      = homePageBanner.sky.cloudAttrOptions[index];
        var ii                       = homePageBanner.sky.cloudAttrOptions[index].length;
        for (var i = 0; i < ii; i++) {
          var cloudAttr      = selectedCloudOption[i];
          var scale          = parseFloat(cloudAttr['scale'] * homePageBanner.view.scale)
            .toFixed(2);
          var top            = 'calc(' + topOffset + '% + ' + cloudAttr['top'] * homePageBanner.view.scale + 'px)';
          var left           = extraLeft + cloudAttr['left'];
          var $newCloudImage = $('<div></div>')
            .addClass('hpb-cloud-img')
            .css('transform', 'scale(' + scale + ',' + scale + ')');
          var $newCloud      = $('<div></div>')
            .addClass('hpb-cloud')
            .addClass('hpb-stopped')
            .css('top', top)
            .css('left', left + 'px')
            .append($newCloudImage);
          homePageBanner.sky.$sky.append($newCloud);
        }

        homePageBanner.sky.updateCloudSelection();
      }

    },

    /**
     * @call        => homePageBanner.sky.moveClouds();
     *
     * @date        => May 13, 2016
     *    @edit        => May 15, 2016
     *                    Change from jQuery animate left to css translate add rotateY for optimization
     *
     * @description => Selects all clouds with .hpb-stopped class and simply adds
     *                 the following css:
     *                 'transform: translate(100000px, 0px) rotateY(0deg);'
     *                 The translate is done to send the clouds on
     *                 their way and the rotateY is done for
     *                 repaint optimization purposes. Then
     *                 we proceeds to remove the class.
     *
     */
    moveClouds: function() {
      homePageBanner.sky.$clouds.filter('.hpb-stopped')
                    .css('transform', "translate(10000px ,0px) rotateY(0deg)");
      homePageBanner.sky.$clouds.removeClass('hpb-stopped');
    },

    /**
     * @call        => homePageBanner.sky.destroyClouds();
     *
     * @date        => May 13, 2016
     *
     * @description => Looping over all the clouds that are moving this finds clouds that have gone
     *                  past the right side of the paper-world and deletes them from the DOM and
     *                  should clear them from the RAM.
     *
     */
    destroyClouds: function() {
      // checks how far from the left a cloud is and marks it for deletion
      // if it is farther from the left than the width of the screen
      homePageBanner.sky.$clouds.filter(':not(.hpb-stopped)')
                    .each(function() {
                      // "+ 10" is just for small browser rendering differences to be sure the cloud is all
                      // the way off the screen before being deleted
                      var width = homePageBanner.view.width + 10;
                      var left  = $(this)
                        .offset().left;
                      if (left > width) {
                        $(this)
                          .addClass('hpb-destroy');
                      }
                    });
      // deletes all clouds marked for destruction
      $(".hpb-destroy")
        .remove();
      homePageBanner.sky.updateCloudSelection();
    },

    /**
     * @call        => homePageBanner.sky.cloudIntervalHandler();
     *
     * @date        => May 13, 2016
     *
     * @description => This calls a list of functions in the proper order to maintain the clouds
     *                  in the sky. First it starts previously created clouds on their way
     *                  across the screen. Then it destroys clouds that have moved past
     *                  the right edge of the screen. Finally it creates new clouds
     *                  that will wait until the next interval to start moving.
     *
     */
    cloudIntervalHandler: function() {
      homePageBanner.sky.moveClouds();
      homePageBanner.sky.destroyClouds();
      homePageBanner.sky.createCloudCluster();
    },

    /**
     * @call        => homePageBanner.sky.createInitialClouds();
     *
     * @date        => May 13, 2016
     *
     * @description => This calls homePageBanner.sky.createCloudCluster() placing space between
     *                  each cloud cluster for the initial look and layout of the clouds.
     *
     */
    createInitialClouds: function() {
      var leftIncrement = 500 * homePageBanner.view.scale;
      for (var i = 0; i < homePageBanner.sky.cloudOptions_ii; i++) {
        var extraLeft = (i * leftIncrement) - 250;
        homePageBanner.sky.createCloudCluster(undefined, extraLeft);
      }
    },

    /**
     * @call        => homePageBanner.sky.initiate();
     *
     * @date        => May 13, 2016
     *    @edit        => June 3, 2016
     *                    Added a check to make sure the background image is loaded which will ensure
     *                    that the css transition is ready to slow down (aka transition) the
     *                    translate that happens from the homePageBanner.sky.moveClouds()
     *                    otherwise the clouds are moved instantly 100000px or so over
     *                    and the homePageBanner.sky.destroyClouds() immediately
     *                    destroys them and cleans the RAM of their existence
     *
     * @description => Initializes starting sky values, saves jQuery access to local sky globals,
     *                  and sets event handlers that relate to the paper-world sky. Currently if
     *                  it detects that the device is mobile then it will not have the clouds
     *                  move and hence not create any clouds either.
     *
     */
    initiate: function() {
      homePageBanner.sky.cloudOptions_ii = homePageBanner.sky.cloudAttrOptions.length;
      homePageBanner.sky.$sky            = homePageBanner.view.$paperWorld.find('#hpb-sky');

      homePageBanner.sky.updateCloudSelection();
      homePageBanner.sky.$clouds.remove();

      homePageBanner.sky.createInitialClouds();

      // the following structure allows us to wait for the css to prep the transition so the
      // clouds from homePageBanner.sky.createInitialClouds() aren't just destroyed
      var backgroundToWaitOn = homePageBanner.sky.$clouds.find(".hpb-cloud-img")
                                             .css('background-image');
      if (backgroundToWaitOn) {
        var source = backgroundToWaitOn.replace(/(^url\()|(\)$|["'])/g, '');
        /*var $temporaryImg = */
        $('<img />')
          .attr('src', source)
          .on("load", function() {
            homePageBanner.sky.destroyClouds(); // check right away to clear any unwanted clouds

            if (!homePageBanner.view.isMobile) // if this is a mobile device don't do anything fancy
            {
              homePageBanner.sky.cloudIntervalHandler();

              setInterval(
                function() {
                  homePageBanner.sky.cloudIntervalHandler();
                },
                (2000 * homePageBanner.view.scale) // 1 minute and 2 seconds between cloud creation batches
                // the 2 seconds adds just enough space between clouds
              );
            }
          });
      }
    }
  },
  /**
   * @call        => homePageBanner.initiate();
   *
   * @date        => May 10, 2016
   *
   * @description => Initializes starting values, saves jQuery access to local globals, and sets event handlers.
   *
   */
  initiate: function() {
    homePageBanner.view.initiate();
    homePageBanner.city.initiate();
    homePageBanner.sky.initiate();
    homePageBanner.view.initiated = true;
  }
};


homePageBanner.initiate();

/* resources/assets/js/app/plan_selector.js */
var plan_selector = {
  $plan_buttons          : null,
  $plan_selector         : null,
  $plan_pop_up           : null,
  $selector_to_be_set    : null, // useful for when multiple plan selectors exist at once
  $renewal_rate_container: null,
  $renewal_price         : null,
  $annual_monthly        : null,

  planPopUpSetSelected: function() {
    plan_selector.$plan_buttons.text(publicText("SELECT"))
                 .removeClass('selected btn-info')
                 .addClass('btn-inverse inverse-blue')
      //fine tune selection from all buttons to individual selected button
                 .filter('[data-plan-code=' +
                         plan_selector.$selector_to_be_set.filter('select').val() +
                         ']')
                 .addClass('selected btn-info')
                 .removeClass('btn-inverse inverse-blue')
                 .text(publicText("SELECTED"));

  },

  planPopUpOpen: function(e) {
    if (typeof e !== 'undefined') {
      if (e.stopPropagation) {
        e.stopPropagation()
      }
      ;
    }
    plan_selector.planPopUpSetSelected();
    var selectedPlan = plan_selector.$selector_to_be_set.filter('select').val();
    plan_selector.$plan_pop_up.find('.pricing-plan-tabs [role="tab"]').filter(function() {
      return this.getAttribute('aria-controls') === 'pricing-plan-' + selectedPlan;
    }).tab('show');
    plan_selector.$plan_pop_up.addClass('open');
    siteGlobals.$body.addClass('modal-open');
  },

  planPopUpClose: function() {
    plan_selector.$plan_pop_up.removeClass('open');
    siteGlobals.$body.removeClass('modal-open');
    setTimeout(function() {
      plan_selector.$plan_pop_up.scrollTop(0);
    }, 300);
  },

  planPopUpSelected                 : function($button) {
    if ($button instanceof jQuery && $button.length === 1) {
      plan_selector.$selector_to_be_set.filter('select').selectpicker('val', $button.attr('data-plan-code'))
                   .trigger('change').next('.bootstrap-select').find('button.selectpicker').focus();
      setTimeout(function() {
        plan_selector.planPopUpClose();
        setTimeout(function() {
          siteGlobals.pulseElement(plan_selector.$selector_to_be_set.filter('select').next('.bootstrap-select')
                                                .find('button.selectpicker'));
        }, 250)
      }, 500);
    }
  },
  updateRenewalRateInfo             : function() {
    var date      = '';
    var plan_code = plan_selector.$plan_selector.val();
    if (plan_code === '--') {
      plan_selector.$renewal_rate_container.addClass('o-fade');
      return true;
    }
    var price             = plan_selector.$plan_selector.find('option[value=' + plan_code + ']');
    var annual_or_monthly = plan_selector.$plan_selector.attr('data-current-display');
    if (annual_or_monthly === 'annual') {
      price = price.attr('data-annual');
    }
    else {
      plan_selector.$renewal_rate_container.addClass('o-fade');
      return true;
    }
    price.trim();
    plan_selector.$renewal_price.text(price);
    plan_selector.$renewal_rate_container.removeClass('o-fade');
  },
  switchAnnualMonthlyRateInSelection: function(annual_or_monthly) {
    var $options = plan_selector.$plan_selector.find('option:not([value=--])');
    if (annual_or_monthly === 'annual') {
      if (plan_selector.$plan_selector.attr('data-current-display') !== 'annual') {
        $options.each(function() {
            var $this = $(this);
            var text  = $this.attr('data-plan-title') + publicText(" - 12 months @ $") + $this.attr('data-intro') + publicText("/mo");
            $this.text(text);
          }
        );
      }
      plan_selector.$plan_selector.attr('data-current-display', 'annual');
    }
    else if (annual_or_monthly === 'monthly') {
      if (plan_selector.$plan_selector.attr('data-current-display') !== 'monthly') {
        $options.each(function() {
            var $this = $(this);
            var text  = $this.attr('data-plan-title') + publicText(" - 1 month @ $") + $this.attr('data-monthly') + publicText("/mo");
            $this.text(text);
          }
        );
      }
      plan_selector.$plan_selector.attr('data-current-display', 'monthly');
    }
    else {
      if (plan_selector.$plan_selector.attr('data-current-display') !== '') {
        $options.each(function() {
            var $this = $(this);
            var text  = $this.attr('data-plan-title');
            $this.text(text);
          }
        );
      }
      plan_selector.$plan_selector.attr('data-current-display', '');
    }
    // plan_selector.$plan_selector.selectpicker('refresh');
  },

  initiate: function() {
    $('#app-layout .selectpicker').selectpicker();
    plan_selector.$plan_selector = $("#plan-select-box");
    if (plan_selector.$plan_selector.length) {

      plan_selector.$selector_to_be_set = plan_selector.$plan_selector;
      //----------------------------------------------------------------------------------
      // initialize jquery selections
      //----------------------------------------------------------------------------------

      // noinspection JSJQueryEfficiency
      plan_selector.$plan_buttons           = $("#plan-pop-up-container .btn[data-plan-code]");
      plan_selector.$plan_pop_up            = $("#plan-pop-up-container");
      plan_selector.$renewal_rate_container = $(".plan-selector-renewal-price-container");
      plan_selector.$renewal_price          = $(".plan-selector-renewal-price");
      plan_selector.$annual_monthly         = $("input[type=radio][name=annual_monthly]");

      //----------------------------------------------------------------------------------
      // initialize event listeners
      //----------------------------------------------------------------------------------

      plan_selector.$plan_selector.on('change blur input keydown click', function() {
        plan_selector.planPopUpSetSelected();
        plan_selector.updateRenewalRateInfo();
      });

      plan_selector.$plan_buttons.click(function(e) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }

        plan_selector.planPopUpSelected($(e.target).closest('.btn[data-plan-code]'));
        plan_selector.updateRenewalRateInfo();
      });

      $('#plan-pop-up-button').click(function(e) {
        plan_selector.$selector_to_be_set = $(e.target).closest('.plan-selector-container').find('.plan-selector');
        plan_selector.planPopUpOpen(e);
      });

      $('#plan-pop-up-close, #feature-header-spacer').click(function(e) {
        if (e.stopPropagation) {
          e.stopPropagation()
        }
        ;
        plan_selector.planPopUpClose();
      });
      $('#plan-pop-up').click(function(e) {
        if ($(e.target).closest('#plans-container').length) return;
        if (e.stopPropagation) {
          e.stopPropagation()
        }
        ;
        plan_selector.planPopUpClose();
      });
      if (plan_selector.$annual_monthly.length === 2) {
        plan_selector.$annual_monthly.on('input change blur keyup', function() {
          plan_selector.switchAnnualMonthlyRateInSelection(plan_selector.$annual_monthly.filter(':checked').val());
          plan_selector.updateRenewalRateInfo();
        });
      }

      //----------------------------------------------------------------------------------
      // prepare initial state
      //----------------------------------------------------------------------------------
      var $preselected_plan = $('#preselected-plan-code');
      if ($preselected_plan.length > 0 && $preselected_plan.val() !== '--') {
        plan_selector.$plan_selector.val($preselected_plan.val());
        // plan_selector.$plan_selector.selectpicker('val', $preselected_plan.val());
      }
      plan_selector.planPopUpSetSelected();
      plan_selector.updateRenewalRateInfo();

      var $black_screen = plan_selector.$plan_pop_up.next('.black-screen');
      plan_selector.$plan_pop_up.appendTo($('#modals'));
      $black_screen.appendTo($('#modals'));

      //  End of if statement wrapping container
    }
  }
};
plan_selector.initiate();

/* resources/assets/js/app/pricing_tabs.js */
// Bootstrap switches panels; this adds the standard keyboard controls for the tab list.
$(document).on('keydown', '.pricing-plan-tabs [role="tab"]', function (event) {
  var tabs = Array.from(this.parentElement.querySelectorAll('[role="tab"]'));
  var index = tabs.indexOf(this);
  if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
  else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
  else if (event.key === 'Home') index = 0;
  else if (event.key === 'End') index = tabs.length - 1;
  else return;
  event.preventDefault();
  tabs[index].focus({ preventScroll: true });
  $(tabs[index]).tab('show');
});

$(document).on('show.bs.tab', '.pricing-plan-tabs [role="tab"]', function (event) {
  var tabList = this.parentElement;
  if (!tabList.getClientRects().length || !event.relatedTarget) return;

  var scrollContainer = tabList.closest('#plan-pop-up-container, #cp-main-scroll-element') || window;
  var previousPanel = document.getElementById(event.relatedTarget.getAttribute('aria-controls'));
  var features = previousPanel.querySelector('.plan-panel-main');
  var visibleTop = tabList.getBoundingClientRect().bottom;
  var row;
  if (features.getBoundingClientRect().top <= visibleTop) {
    row = Array.from(features.querySelectorAll('[data-plan-feature]')).find(function (feature) {
      return feature.getBoundingClientRect().bottom > visibleTop;
    });
  }

  window.cancelAnimationFrame($(tabList).data('pricing-scroll-frame'));
  $(tabList).data('pricing-scroll-position', {
    feature: row ? row.getAttribute('data-plan-feature') : null,
    top: row ? row.getBoundingClientRect().top : null,
    scrollContainer: scrollContainer,
    scrollY: scrollContainer === window ? window.scrollY : scrollContainer.scrollTop
  });
});

$(document).on('shown.bs.tab', '.pricing-plan-tabs [role="tab"]', function () {
  $(this).siblings('[role="tab"]').attr('tabindex', '-1');
  $(this).attr('tabindex', '0');

  var tabList = this.parentElement;
  var position = $(tabList).data('pricing-scroll-position');
  $(tabList).removeData('pricing-scroll-position');
  if (!position) return;

  var panel = document.getElementById(this.getAttribute('aria-controls'));
  var frame = window.requestAnimationFrame(function () {
    var row = Array.from(panel.querySelectorAll('[data-plan-feature]')).find(function (feature) {
      return feature.getAttribute('data-plan-feature') === position.feature;
    });
    var currentScroll = position.scrollContainer === window ? window.scrollY : position.scrollContainer.scrollTop;
    var offset = row ? row.getBoundingClientRect().top - position.top : position.scrollY - currentScroll;
    position.scrollContainer.scrollBy({ top: offset, behavior: 'instant' });
    $(tabList).removeData('pricing-scroll-frame');
  });
  $(tabList).data('pricing-scroll-frame', frame);
});

/* resources/assets/js/app/order.js */
var orderForm = {
  $order_form           : null,  // local global to store jQuery access to the #order-slider element
  $order_real_form      : null,  // This is the acutal form. The above element is just badly named.
  $order_steps          : null,  // local global to store jQuery access to the '.order-step' elements
  $process_bar          : null,  // local global to store jQuery access to the '#full-process-bar' element
  $process_bar_container: null,  // local global to store jQuery access to the '#process-bar-spacer' element
  $current_slide        : null,  // local global to store jQuery access to the current slide element as defined by
                                 // slick.js
  $current_inputs: null,  // local global to store jQuery access to the inputs on the $current_slide
  $all_inputs    : null,  // local global to store jQuery access to all input fields from the #order-slider
                          // element
  $progress_bar         : null,  // local global to store jQuery access to the progress-bar itself
  $process_status_domain: null,  // local global to store jQuery access to the #process-status-domain
  $process_status_text  : null,  // local global to store jQuery access to the #process-status-text
  is_waiting            : false, // local global to store boolean `true` if on order/wait/{code} page
  external_links_hidden : false, // local global to store boolean `true` if orderForm.hideAllOrderExitingLinks()
  distractions_cleared  : false, // local global to store boolean `true` if
                                 // orderForm.removeDistractionsFromOrderForm()
  rate_update_timeout      : null,  // local global to store timeout used in "de-bouncing" the updateRates function
  rate_check_flag          : false, // local global to store if the last update request was just to check the promo code
  minimum_wait_time_passed : false, // local global to store if the minimum wait time has passed on the additional info
  user_waited_on_last_slide: false, // local global to store if the user has waited on the last slide long enough to
                                    // bypass the minimum wait time or filling out the form
  user_waiting_timeout: null,  // local global to store timeout used updating orderForm.user_waited_on_last_slide
  status              : null,  // local global to store the order's current status
  minimum_wait_time   : 0,     // minimum amount of wait time to show that the set up is complete
  finalized       : false,
  currentPromoCode: null,

  // Keep validation and later steps in the page language even when the preference cookie differs.
  orderUrl: function(path) {
    return (orderForm.$order_real_form.attr('data-order-base-url') || '/order-new') + path;
  },

  trackMarketingEvent: function(event) {
    if (!event || !event.event_name) return;
    // Actual lifecycle conversions are recorded independently on the server.
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
    gtag('event', event.event_name, event.params || {});
  },

  setUpTimeoutAndFinalize: function() {
    var time = siteGlobals.values['csrf_life'];
    time -= 2;// 2 minutes should be more than enough time for javascript
              // to load, run, and complete this timeout before the csrf token expires
    time = siteGlobals.secondsToMilliseconds(siteGlobals.minutesToSeconds(time));
    setTimeout(
      function() {
        siteGlobals.ajaxForm(orderForm.$order_form, orderForm.finalize, orderForm.finalize, {}, orderForm.orderUrl('/optional-details/ajax-update').replace(/^\//, ''));
      },
      time
    );

  },
  finalize               : function() {
    orderForm.finalized  = true;
    window.location.href = orderForm.orderUrl('/finalize/') + $('#code').val();
  },

  goToNextSlide: function() {
    siteGlobals.scrollToElement(orderForm.$process_bar);
    orderForm.$order_form.slick('slickNext'); // this is a simple call to a slick.js function
    orderForm.setUpCurrentSlide();

    //is the user on the "waiting" slide
    //(this is the last slide if there is not an order error
    // if there is an order error this is the second to last slide)
    if ((orderForm.status != 'error' &&
         orderForm.$current_slide.get(0) == orderForm.$order_steps.last().get(0))
        ||
        (orderForm.status == 'error' &&
         orderForm.$current_slide.get(0) == orderForm.$order_steps.toArray().slice(-2)[0])) {

      if (orderForm.user_waiting_timeout != null) {
        // clear the timeout, if one is pending
        clearTimeout(parseInt(orderForm.user_waiting_timeout));
        orderForm.user_waiting_timeout = null;
      }

      //start a timeout to let them continue without filling out the form or waiting the minimum time
      orderForm.user_waiting_timeout = setTimeout(function() {
        orderForm.user_waited_on_last_slide = true;
      }, 5000);
    }
  },

  mostFieldsFilledOut: function() {
    if (orderForm.$order_form.find('.alert.alert-danger').length > 0) {
      return false;
    }
    var softRequiredFields = [
      'phone',
      'cell_phone',
      'alternate_email_address',
      'password',
      // 'street',
      // 'city',
      // 'state',
      // 'postal_code',
      // 'country',
      // 'charge_authorization',
      'security_question',
      'security_answer'
      // 'source'
    ];
    var ii                 = softRequiredFields.length;
    for (var i = 0; i < ii; i++) {
      if (orderForm.$all_inputs.filter('#' + softRequiredFields[i]).val() == '') {
        return false;
      }
    }

    return true;
  },

  updateRates: function() {
    var code = $("#code");
    if (code.length > 0) {
      code = code.val();
      $.ajax({
        url       : orderForm.orderUrl('/optional-details/update-rates'),
        type      : "POST",
        data      : {code: code},
        beforeSend: function(xhr) {
          return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
        },
        success   : function(response) {
          var $priceElements = orderForm.$order_form.find(".price-info-span");
          // var hasPartial     = false;
          // if ($priceElements.filter("partial").length > 0) {
          //   hasPartial = true;
          // }
          for (var key in response) {
            if (response.hasOwnProperty(key)) {
              if (response[key] !== "Plan does not have a monthly rate.") {
                $priceElements.filter("." + key).text(response[key]);
                if (key === 'perMonthMonthly') {
                  $priceElements.closest('label').removeClass('disabled');
                  $("#annual-monthly-2").removeClass('disabled');
                }
              }
              else {
                $priceElements.filter("." + key).text('--');
                if (key === 'perMonthMonthly') {
                  $priceElements.filter("." + key).closest('label').addClass('disabled');
                  $("#annual-monthly-2").addClass('disabled');
                  $("#annual-monthly-1").click();
                  toast({
                    message: publicText("Monthly billing is not available with this plan."),
                    type   : 'warning',
                    time   : 4500,
                    icon   : 'info'
                  });

                }
              }
            }
          }
        }
      });
    }
  },

  timeoutUpdateRates: function() {
    // this is for the new account order form. #tagSoYouCanFindOtherPromocodeRelatedCode
    var $promoInput = orderForm.$order_form.find("#promo_code");
    if ($promoInput.val().trim().length > 0) {
      siteGlobals.displayValidationErrors($promoInput, [publicText("Checking promo code.")], "info", "circle-notch fa-spin");
    }
    debounce(
      function() {
        var orderCode = orderForm.$order_form.closest("form").find("#code").val();
        if (typeof orderCode === "undefined" || orderCode === null || orderCode.length < 1) {
          // This is not an order in progress, abort
          return false;
        }
        orderForm.rate_check_flag = true;
        orderForm.clearErrors();
        siteGlobals.ajaxForm(orderForm.$order_form, orderForm.orderUpdateSuccessful, orderForm.orderUpdateError, {}, orderForm.orderUrl('/optional-details/ajax-update').replace(/^\//, ''));
      });
  },


  hideAllOrderExitingLinks: function() {
    if (!orderForm.external_links_hidden) {

      $("#page-footer").remove();

      $("#navbar-collapse, #navbar-content > .navbar-header > button.navbar-toggler, #page-footer")
        .css('visibility', "hidden")
        .css('pointerEvents', "none");
      $("#navbar-content > .navbar-header > a.navbar-brand, #footer-copyright-info > p:first-child > a")
        .attr("href", "#").attr("tabindex", "-1");
      orderForm.external_links_hidden = true;
    }
    siteNavbar.$window.off();
    siteNavbar.compact();
  },

  clearErrors: function() {
    $("#force_domain-wrapper").hide();
    orderForm.$order_form.find('.alert.alert-danger').each(function() {
      $(this).addClass("removing-order-form-alert");
      siteGlobals.animateRemove(this);
    });
  },

  removeDistractionsFromOrderForm: function() {
    $(".order-form-remove").remove();
    if (!orderForm.distractions_cleared) {
      orderForm.hideAllOrderExitingLinks();
      var stripe = $("#order-stripe");
      if (stripe.length > 0) {
        stripe.siblings(":not(footer)").remove();
        stripe.children(".container").children("h3").css('visibility', 'hidden');
        siteGlobals.scrollToX(0);
      }
      orderForm.distractions_cleared = true;
    }
  },


  checkOrderStatus: function() {
    if (orderForm.finalized) {
      return true;
    }
    orderForm.is_waiting = ((orderForm.status != 'error' &&
                             orderForm.$current_slide.get(0) == orderForm.$order_steps.last().get(0))
                            ||
                            (orderForm.status == 'error' &&
                             orderForm.$current_slide.get(0) == orderForm.$order_steps.toArray().slice(-2)[0]));
    var code             = $("#code");
    if (code.length > 0) {
      code = code.val();

      $.ajax({
        url       : orderForm.orderUrl('/optional-details/check-status'),
        type      : "POST",
        data      : {code: code},
        beforeSend: function(xhr) {
          return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
        },
        success   : function(response) {
          var domain           = response['orderStatus']['domain'];
          var status           = response['orderStatus']['statusText'];
          var percentCompleted = response['orderStatus']['progressbar'];
          orderForm.status     = response['orderStatus']['status'];

          orderForm.updateProcessBar(domain, status, percentCompleted);
          if (orderForm.is_waiting && response['orderStatus']['status'] == 'complete') {
            orderForm.finalized = true;
            if (response['autologin'] !== '') {
              setTimeout(function() {
                window.location.assign(response['autologin']);
              }, 0);
            }
          }
          if (response['orderStatus']['status'] === 'error') {
            if (response['thank_you_slide'] !== '' && orderForm.$order_form.find("#thank_you_slide").length === 0) {
              var $temp_container = $('<div></div>');
              $temp_container.html(response['thank_you_slide']);
              var $thank_you_slide = $temp_container.find("#thank_you_slide");
              orderForm.$order_form.slick('slickAdd', $thank_you_slide);
              orderForm.$order_steps = orderForm.$order_form.find('.order-step');
            }
            if (orderForm.is_waiting && response['orderStatus']['status'] === 'error') {
              orderForm.goToNextSlide();
            }
          }
        }
      });
    }
  },

  updateProcessBar: function(domain, status, percentCompleted) {
    percentCompleted = Math.min(percentCompleted, 100);
    percentCompleted = Math.max(percentCompleted, 5);
    if (percentCompleted == 100) {
      if (!orderForm.minimum_wait_time_passed &&
          !orderForm.mostFieldsFilledOut() &&
          !orderForm.user_waited_on_last_slide) {
        percentCompleted = Math.max(parseInt(orderForm.$progress_bar.attr('style').substr(7, 3)), 95);
        // status           = orderForm.$process_status_text.text();
        orderForm.$progress_bar.css('transition-duration', '150s').css('transition-timing-function', 'linear');
      }
      else {
        orderForm.$progress_bar.css('transition-duration', '0.6s').css('transition-timing-function', 'ease');
      }
    }
    setTimeout(function() {
      if (parseInt(orderForm.$progress_bar.attr('style').substr(7, 3)) != percentCompleted) {
        orderForm.$progress_bar.width("calc(" + percentCompleted + "% - 2px)");
      }
      domain = publicText("Setting Up Service: ") + domain;
      if (orderForm.$process_status_domain.text() != domain) {
        orderForm.$process_status_domain.text(domain);
      }
      // if (orderForm.$process_status_text.text() != status) {
      //   orderForm.$process_status_text.text(status);
      // }
    }, 50);

  },

  /**
   * @call        => orderForm.prevSlide();
   *
   * @author      => Spencer O'Reilly
   * @date        => May 30, 2016
   *
   * @description => Calls the slick.js slickPrev() function to step back to the previous step in the order process
   *
   */
  prevSlide: function() {
    siteGlobals.scrollToElement(orderForm.$process_bar);
    orderForm.$order_form.slick('slickPrev'); // this is a simple call to a slick.js function
    orderForm.setUpCurrentSlide();
    if (orderForm.user_waiting_timeout != null) {
      // clear the timeout, if one is pending
      clearTimeout(parseInt(orderForm.user_waiting_timeout));
      orderForm.user_waiting_timeout = null;
    }
  },

  /**
   * @call        => orderForm.tryNextSlide();
   *
   * @author      => Spencer O'Reilly
   * @date        => May 30, 2016
   *
   * @description => If the form input elements on the current slide pass validation then
   *                  this calls the slick.js slickNext() function to move on to
   *                  the next step in the order process
   */
  tryNextSlide: function() {
    siteGlobals.$body.css("cursor", "progress");
    orderForm.clearErrors();
    orderForm.$order_form.find("#promo_code").trigger("input");

    siteGlobals.ajaxForm(orderForm.$order_form, orderForm.orderUpdateSuccessful, orderForm.orderUpdateError, {next_slide: "yes"}, orderForm.orderUrl('/optional-details/ajax-update').replace(/^\//, ''));
  },

  /**
   * @call        => orderForm.orderUpdateSuccessful();
   *
   * @author      => Spencer O'Reilly
   * @date        => September 14, 2016
   *
   * @description => Function called if the ajax call to update the
   *                 order details was successful. This should
   *                 update the order status on screen, and
   *                 allow us to continue to filling out
   *                 information.
   *
   * @param response
   */
  orderUpdateSuccessful: function(response) {
    var $promoInput = orderForm.$order_form.find("#promo_code");
    if ($promoInput.val().trim().length > 0) {
      var promoCodeText = publicText("Valid promo code, complete your order to apply.");
      if (typeof response.promo_code_details !== "undefined" && response.promo_code_details.length > 0) {
        promoCodeText = response.promo_code_details;
      }
      var promoCodeCheckbox = null;
      if (typeof response.promo_code_checkbox !== "undefined" && response.promo_code_checkbox !== null && response.promo_code_checkbox.length > 0) {
        promoCodeCheckbox = response.promo_code_checkbox;
      }
      siteGlobals.displayValidationErrors($promoInput, [promoCodeText], "success", "check");
      if (promoCodeCheckbox === null) {
        $("#promo-code-confirm-checkbox-wrapper").hide();
      }
      else {
        $("#promo-code-confirm-checkbox-wrapper").show();
        $("#promo-code-confirm-checkbox-text").html(promoCodeCheckbox);
      }
    }
    else {
      $("#promo-code-confirm-checkbox-wrapper").hide();
    }
    orderForm.updateRates();
    siteGlobals.$body.css("cursor", "default");
    if (typeof response !== 'undefined') {
      orderForm.updateProcessBar(response['order_status']['domain'],
        response['order_status']["statustext"],
        response['order_status']['progressbar']);
    }
    if ((orderForm.status !== 'error' && orderForm.$current_slide.get(0) !== orderForm.$order_steps.last().get(0))
        ||
        (orderForm.status === 'error' && orderForm.$current_slide.get(0) !== orderForm.$order_steps.toArray().slice(-2)[0])) {
      orderForm.is_waiting = false;
      if (!orderForm.rate_check_flag) {
        orderForm.goToNextSlide();
      }
    }
    else {
      orderForm.is_waiting = true;
      if (orderForm.minimum_wait_time_passed ||
          orderForm.mostFieldsFilledOut() ||
          orderForm.user_waited_on_last_slide) {
        if (orderForm.status === 'error') {
          orderForm.goToNextSlide();
        }
      }
    }
    orderForm.rate_check_flag = false;
  },

  /**
   * @call        => orderForm.orderUpdateError();
   *
   * @author      => Spencer O'Reilly
   * @date        => September 14, 2016
   *
   * @description => Function called if the ajax call to update the order details fails. This gets called hopefully
   *   only when a validation error is thrown, in which case, we need to display that error.
   *
   * @param response
   */
  orderUpdateError: function(response) {
    orderForm.updateRates();
    siteGlobals.$body.css("cursor", "default");
    if (parseInt(response.status) === 422) {
      if (siteGlobals.consoleLog) {
        console.log('ERROR 422: Form Validation Failed.');
      }
      var focusIsSet = false;
      orderForm.$all_inputs.each(function() {
        var $this                = $(this);
        var showErrors           = true;
        var setFocusToFirstInput = false;
        var name                 = $this.attr('name');
        if (response.responseText.hasOwnProperty(name)) {
          if (!focusIsSet) {
            if ($.contains(orderForm.$current_slide[0], $this[0])) {
              focusElementPreventScroll($this);
              $this.popover('hide');
              focusIsSet = true;
            }
            else {
              if (!orderForm.rate_check_flag) {
                var errorSlideIndex = orderForm.$order_steps.index($this.closest('.order-step')[0]);
                var currentSlide    = orderForm.$order_form.slick("getCurrent");
                var goToSlide       = errorSlideIndex;
                // don't skip forward in the form to show an error for a field they haven't even seen yet!
                if ((currentSlide + 1) <= errorSlideIndex) {
                  goToSlide            = currentSlide + 1;
                  setFocusToFirstInput = true;
                  showErrors           = false; // don't show an error on a slide we're not looking at...
                }
                orderForm.$order_form.slick('slickGoTo', goToSlide, false);
                orderForm.setUpCurrentSlide(setFocusToFirstInput);
                if (showErrors) {
                  focusElementPreventScroll($this);
                  $this.popover('hide');
                  focusIsSet = true;

                }

              }

            }


          }

          if (showErrors) {
            orderForm.handleOrderValidationError($this, response.responseText[name]);
          }


        }
      });
    }
    if (parseInt(response.status) === 419) {
      orderForm.handleOrderValidationError($(orderForm.$all_inputs[0]), [response.responseText.message]);
    }
    orderForm.rate_check_flag = false;
  },


  /**
   * @call        => orderForm.setUpCurrentSlide();
   *
   * @author      => Spencer O'Reilly
   * @date        => June 21, 2016
   *
   * @description => Sets up tab-indexes, and prepares validation on blur.
   *
   * @param        setFocus (BOOLEAN) defaults to true, if set to false the current focus will not be affected.
   */
  setUpCurrentSlide: function(setFocus) {
    setFocus                  = typeof setFocus === "undefined" ? true : setFocus;
    var index                 = orderForm.$order_form.slick('slickCurrentSlide');
    orderForm.$current_slide  = $(orderForm.$order_form.find('li.order-step').get(index));
    orderForm.$current_inputs = orderForm.$current_slide
                                         .find('input:not([type="button"]):not([type="reset"]):not([type="submit"])[name]:not([name=""]), select[name]:not([name=""]), textarea[name]:not([name=""])');

    var $inputsToTab = orderForm.$current_slide.find('input:not(:hidden), select:not(:hidden), textarea:not(:hidden), .order-next');
    $("[tabindex]:not([tabindex='-1'])").removeAttr("tabindex");
    orderForm.$all_inputs.attr("tabindex", -1);
    var skippedCount = 0;
    $inputsToTab.each(function(i) {
      var $this = $(this);
      if (siteGlobals.isVisible($this.get(0))) {
        $this.attr("tabindex", i + 1 - skippedCount);
        // the plus one allows us to start counting at 1 instead of 0
        // this in no way affects the value of i
      }
      else {
        skippedCount += 1;
        $this.attr("tabindex", -1);
      }
    });
    if (setFocus) {
      var $firstInput = $($inputsToTab.get(0));
      if ($firstInput.attr('id') !== 'full_name') {
        focusElementPreventScroll($firstInput);
      }
    }
    var nextTabindex = $inputsToTab.length - skippedCount + 1;
    orderForm.$current_slide.find('.order-prev').attr("tabindex", nextTabindex);
    if (typeof conditionalJsAuto !== "undefined") {
      conditionalJsAuto(orderForm.$current_slide);
    }
  },

  /**
   * @call        => orderForm.handleOrderResponseSuccess();
   *
   * @author      => Spencer O'Reilly
   * @date        => June 22, 2016
   *
   * @description =>
   *
   */
  handleOrderResponseSuccess: function(response) {
    $('.rm-if-js').remove();
    // {{-- clicktracking --}}
    if (typeof improvely !== "undefined") {
      improvely.init('isparks', 1);
      improvely.conversion({
        goal     : 'free trial',
        revenue  : 0,
        reference: response['code']
      });
    }
    orderForm.trackMarketingEvent(response["marketing_event"]);
    orderForm.$current_slide.find('.alert.alert-danger').each(function() {
      siteGlobals.animateRemove(this);
    });
    orderForm.$order_form.slick('slickNext'); // this is a simple call to a slick.js function
    orderForm.setUpCurrentSlide();
    siteGlobals.scrollToElement(orderForm.$process_bar);
    orderForm.$process_bar.addClass('active');
    orderForm.$order_form.closest('form').attr('action', orderForm.orderUrl('/optional-details'));
    var $methodSimulation = $('<input>').attr({
      type : 'hidden',
      id   : '_method',
      name : '_method',
      value: 'PATCH'
    });
    var $code             = $('<input>').attr({
      type : 'hidden',
      id   : 'code',
      name : 'code',
      value: response['code']
    });
    if (typeof response !== "undefined" && typeof response['orderlog'] !== "undefined" && typeof response['orderlog']['promocode'] !== "undefined" &&
        response['orderlog']['promocode'].length > 0) {
      orderForm.$order_form.find("#promo_code").val(response['orderlog']['promocode']);
    }
    orderForm.$order_real_form.append([$methodSimulation, $code]);
    orderForm.removeDistractionsFromOrderForm();
    orderForm.$order_form.closest('form').submit(function(e) {
      orderForm.tryNextSlide();
      if (e.preventDefault) {
        e.preventDefault();
      }
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    });
    orderForm.$first_submit.remove();
    setTimeout(function() {
      orderForm.minimum_wait_time_passed = true;
    }, orderForm.minimum_wait_time);
    orderForm.setUpTimeoutAndFinalize();

    // Putting this on a timeout so it doesn't happen during the animation.
    setTimeout(function() {
      // Calling this once makes slick automatically resize itself when the window changes size.
      var prevFocus = $(":focus");
      orderForm.$order_form.slick('refresh');
      $('.rm-if-js').remove();
      // The first step can't be returned to, make it invisible to disable tabbing to elements within it.
      $("#first-step-of-order-form").css({visibility: "hidden"});
      prevFocus.focus();
    }, 500);
  },

  /**
   * @call        => orderForm.handleOrderResponseFailure();
   *
   * @author      => Spencer O'Reilly
   * @date        => June 20, 2016
   *
   * @description =>
   *
   */
  handleOrderResponseFailure: function(response) {
    orderForm.$first_submit.html(orderForm.$first_submit.attr("data-original-text")).prop("disabled", false);
    if (response.status == 422) {
      if (siteGlobals.consoleLog) {
        console.log('ERROR 422: Form Validation Failed.');
      }
      var focusIsSet = false;
      orderForm.$current_inputs.each(function() {
        var $this = $(this);
        var name  = $this.attr('name');
        if (response.responseText.hasOwnProperty(name)) {
          if (!focusIsSet) {
            focusElementPreventScroll($this);
            focusIsSet = true;
          }

          orderForm.handleOrderValidationError($this, response.responseText[name]);

        }
      });
    }
    if (response.status == 419) {
      if (siteGlobals.consoleLog) {
        console.log('ERROR 419: Page expired.');
      }
      orderForm.$current_inputs.each(function() {
        var $this = $(this);
        orderForm.handleOrderValidationError($this, [response.responseText.message]);
        return false;
      });
    }
  },

  handleOrderValidationError: function(input, error) {

    if (input.attr("name") === "domain") {
      error.forEach(function(singleError) {
        if (singleError.indexOf('data-order-warning="mail-server"') !== -1 || singleError.indexOf("mail server") !== -1) {
          $("#force_domain-wrapper").show();
        }
      });
    }

    if ($(".removing-order-form-alert").length) {
      setTimeout(function() {
        siteGlobals.displayValidationErrors(input, error);
      }, 500);
    }
    else {
      siteGlobals.displayValidationErrors(input, error);
    }

  },

  /**
   * @call        => orderForm.handleOptionalDetailsResponse();
   *
   * @author      => Spencer O'Reilly
   * @date        => June 14, 2016
   *
   * @description => Set up the optional details steps. Alter functionality of order button to use ajax.
   *
   */
  handleOptionalDetailsResponse: function(response) {
    var $tempContainer = $('<div></div>');
    $tempContainer.html(response['process-bar']);
    orderForm.$process_bar = $tempContainer.find("#full-process-bar");
    orderForm.$process_bar_container.prepend(orderForm.$process_bar);

    $tempContainer.html(response['optional-details']);
    var $li = $tempContainer.children('li');
    $li.each(function(index) {
      var $this = $(this);
      if (index == 0) {
        $this.find('.order-prev').remove();
      }
      orderForm.$order_form.slick('slickAdd', $this);
    });
    $tempContainer.html(""); // just in extra effort to clear cache
    //noinspection JSUnusedAssignment
    $tempContainer = undefined;

    orderForm.reInitiate();
  },

  /**
   * @call        => orderForm.reInitiate();
   *
   * @author      => Spencer O'Reilly
   * @date        => July 29, 2016
   *
   * @description =>  Initializes starting values, saves jQuery access to local globals, and sets event handlers.
   *                  For additional optional info may be done after page load.
   *
   */
  reInitiate: function() {
    siteGlobals.reInitiate();

    orderForm.$second_submit         = orderForm.$order_form.find('#second-submit');
    orderForm.$all_inputs            =
      orderForm.$order_form.find("input, select, textarea, button, .order-prev, .order-next");
    orderForm.$progress_bar          = $('.progress-bar');
    orderForm.$process_status_domain = $('#process-status-domain');
    orderForm.$process_status_text   = $('#process-status-text');
    orderForm.$order_steps           = orderForm.$order_form.find('.order-step');

    orderForm.setUpCurrentSlide();
    var $orderPrev = $('.order-prev');
    var $orderNext = $('.order-next');

    $orderPrev.unbind('click');
    $orderPrev.click(function() {
      orderForm.prevSlide()
    });

    $orderNext.unbind('click');
    $orderNext
      .click(function() {
        orderForm.tryNextSlide()
      });

    orderForm.$first_submit.click(function(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (e.stopPropagation) {
        e.stopPropagation();
      }
      orderForm.$first_submit.html("<i class='fa fa-circle-notch fa-spin'></i>").prop("disabled", true);

      // var $validationErrors = orderForm.$order_form.find( '.alert.alert-danger:not(js-set)' );
      // if ( $validationErrors.length == 0 )
      // {
      orderForm.clearErrors();
      siteGlobals.ajaxForm(orderForm.$order_form, orderForm.handleOrderResponseSuccess, orderForm.handleOrderResponseFailure);
      // }
      // else
      // {
      siteGlobals.scrollToElement(orderForm.$process_bar_container);
      // }
      return false;
    });
    siteGlobals.$document.on('input change blur keyup', function(e) {
      var code = (e.keyCode ? e.keyCode : e.which);
      if (parseInt(code) === 13) {
        var $focusedElement = $(document.activeElement);
        if ($focusedElement.length === 1) {
          if ($focusedElement.hasClass('order-next')) {
            orderForm.tryNextSlide();
          }
          else if ($focusedElement.hasClass('order-prev')) {
            orderForm.prevSlide();
          }
        }
      }
    });
    $('input[type=radio][name=billing_method]').on('input', function() {
      orderForm.setUpCurrentSlide(false);
    });
    var $promo_code = orderForm.$order_form.find("#promo_code");
    $promo_code.on('input', function() {
      if ($(this).val() === orderForm.currentPromoCode) {
        return true;
      }
      orderForm.currentPromoCode = $(this).val();
      $("#promo-code-confirm-checkbox-wrapper").hide();
      orderForm.timeoutUpdateRates();
    });
    plan_selector.initiate();
    if (plan_selector.$plan_selector !== null) {
      plan_selector.$plan_selector.on('input', function() {
        orderForm.timeoutUpdateRates();
      });
    }


  },


  /**
   * @call        => orderForm.initiate();
   *
   * @author      => Spencer O'Reilly
   * @date        => May 30, 2016
   *
   * @description => Initializes starting values, saves jQuery access to local globals, and sets event handlers.
   *
   */
  initiate: function() {
    orderForm.$order_form = $("#order-slider"); // what?? that's not the form! bad name for this variable. Do not alter the dom of this, it
                                                // messes up slick.
    orderForm.$order_real_form = orderForm.$order_form.closest("form");
    if (orderForm.$order_form.length > 0) {
      orderForm.$first_submit          = orderForm.$order_form.find('#first-submit');
      orderForm.$second_submit         = orderForm.$order_form.find('#second-submit');
      orderForm.$order_steps           = orderForm.$order_form.find('.order-step');
      orderForm.$process_bar           = $('#full-process-bar');
      orderForm.$progress_bar          = orderForm.$process_bar.find('.progress-bar');
      orderForm.$process_status_domain = orderForm.$process_bar.find('#process-status-domain');
      orderForm.$process_status_text   = orderForm.$process_bar.find('#process-status-text');

      orderForm.$process_bar_container = $('#process-bar-spacer');
      orderForm.$all_inputs            =
        orderForm.$order_form.find("input, select, textarea, button, .order-prev, .order-next");

      $("#order-scroll-button").click(function() {
        siteGlobals.scrollToElement(orderForm.$process_bar_container)
      });
      $("#domain").on('input change blur keyup', function() {
        $(this).val($(this).val().trim());
        if ($(this).val().substring(0, 5).toLowerCase() !== "mail.") {
          $("#force_domain-wrapper").hide();
          $("#force_domain-checkbox").prop("checked", false);
        }
      });
      orderForm.setUpCurrentSlide();

      $('.order-prev')
        .click(function() {
          orderForm.prevSlide()
        });

      $('.order-next')
        .click(function() {
          orderForm.tryNextSlide()
        });
      if (siteGlobals.url.indexOf("/optional-details/") == -1 && siteGlobals.url.indexOf("order/wait/") == -1) {
        siteGlobals.ajaxLoad(orderForm.orderUrl('/optional-details').replace(/^\//, ''), orderForm.handleOptionalDetailsResponse);
      }
      else {
        var $slides = $(orderForm.$order_form.find('.order-step'));
        $slides.eq(1).find('.order-prev').remove();
        var $errors = orderForm.$order_form.find('.error-bag');
        if ($errors.length > 0) {
          var $firstError = $errors.eq(0);
          var $slide      = $firstError.closest('.order-step');
          var slideIndex  = parseInt($slides.index($slide));
          orderForm.$order_form.slick('slickGoTo', slideIndex, false);
          orderForm.setUpCurrentSlide(false);

          var $inputFocus = $("#" + $firstError.attr('data-error-bag-for'));
          if ($inputFocus.length == 1) {
            focusElementPreventScroll($inputFocus);
          }

        }
      }
      if (siteGlobals.url.indexOf("optional-details") != -1) {
        orderForm.setUpTimeoutAndFinalize();
        orderForm.reInitiate();
        orderForm.$order_form.closest('form').submit(function(e) {
          orderForm.tryNextSlide();
          if (e.preventDefault) {
            e.preventDefault();
          }

          if (e.stopPropagation) {
            e.stopPropagation();
          }

        });
        orderForm.hideAllOrderExitingLinks();
        setTimeout(function() {
          orderForm.minimum_wait_time_passed = true;
        }, orderForm.minimum_wait_time);
      }
      /*var statusInterval = */
      setInterval(orderForm.checkOrderStatus, 2000);
    }
  }
};

orderForm.initiate();


$("#no-domain-order-link").click(function(e) {


  var name  = $("#full_name").val();
  var email = $("#email_address").val();

  if (name.length < 1 && email.length < 1) {
    return;
  }

  var url   = $(this).attr("href");
  var query = "?";
  if (name.length > 0) {
    query += "name=" + name;
    if (email.length > 0) {
      query += "&";
    }
  }
  if (email.length > 0) {
    query += "email=" + email;
  }

  e.preventDefault();
  window.location.href = url + query;
});

var focusPreventScrollSupported = false;

document.createElement('div').focus({
  get preventScroll()
  {
    focusPreventScrollSupported = true;

    return false;
  },
});

var focusElementPopoverTimeout = null;
var focusElementTimeout        = null;

function focusElementPreventScroll($element)
{
  clearTimeout(focusElementTimeout);
  clearTimeout(focusElementPopoverTimeout);
  $('.popover').popover('hide');
  if (!$element.length) {
    return;
  }
  if (focusPreventScrollSupported) {
    $element[0].focus({preventScroll: true});
    $element.popover("hide");
    focusElementPopoverTimeout = setTimeout(function() {
      $element.popover("show");
    }, 500);
  }
  else {
    focusElementTimeout = setTimeout(function() {
      $element[0].focus();
    }, 500);
  }
}


$("#test-order-button").click(function() {
  var currentDate = new Date();
  var seconds     = currentDate.getSeconds();
  var minute      = currentDate.getMinutes();
  var hour        = currentDate.getHours();
  var day         = currentDate.getDate();
  var month       = currentDate.getMonth() + 1;
  var year        = currentDate.getFullYear();
  var testName    = "Test-" + year + "-" + month + "-" + day + "-" + hour + "-" + minute + "-" + seconds;

  var $fullName     = $("#full_name");
  var $emailAddress = $("#email_address");
  var $domain       = $("#domain");

  if ($fullName.val().length < 1) {
    $fullName.val("Test Man");
  }
  if ($emailAddress.val().length < 1) {
    $emailAddress.val(testName + "@example.com");
  }
  if ($domain.val().length < 1) {
    $domain.val(testName + ".com");
  }
  $("#first-submit").click();
});

/* resources/assets/js/app/testimonial.js */
var TestimonialEngine = {
  highlightTestimonial: function(id_selector) {
    var $testimonial = $(id_selector)
      .css('background', '#61B7EA')
      // .css('background', '#FCB040')
      .css('color', '#FFF');
    setTimeout(function() {
      $testimonial.css('transition', 'all 1s cubic-bezier(0,1,0,-1)');
      setTimeout(function() {
        $testimonial.css('background', '').css('color', '');
        setTimeout(function() {
          $testimonial.css('transition', '');
        }, 1500);//allow the transition to complete before removing transition properties
      }, 50);//allow the transition property to be provisioned before calling on it
    }, 50);//allow the color flash to be set before setting the transition property.... other wise we get double flash

  }
};

// Run the code that is relevant to the review page
if ($('#reviews').length > 0) {
  // does the url have a hash value for a specific testimonial?
  var index = siteGlobals.url.indexOf('#testimonial-');
  // found it!
  if (index !== -1) {
    // get the string that jQuery will use to select the element
    var id_selector = siteGlobals.url.substring(index);
    setTimeout(
      function() {
        TestimonialEngine.highlightTestimonial(id_selector);
      }, 100); //slight delay allows page to render and scroll to element to work properly


  }
}

/* resources/assets/js/app/reseller_sign_up.js */
var resellerSignUp = {
  $reseller_sign_up_form       : null,
  $account_details             : null,
  $login_details               : null,
  $company_classification      : null,
  $company_classification_other: null,
  $logged_in                   : null,
  $existing_account_1          : null,
  $existing_account_2          : null,
  debounce_show_timeout        : null,
  $company_details             : null,
  $sign_up_button_container    : null,

  debouncedShowOtherClassification: function() {
    if (resellerSignUp.debounce_show_timeout !== null) {
      clearTimeout(parseInt(resellerSignUp.debounce_show_timeout));
    }
    resellerSignUp.debounce_show_timeout = setTimeout(function() {
      resellerSignUp.debounce_show_timeout = null;
      resellerSignUp.showOtherClassification();
    }, 300)
  },
  showOtherClassification         : function() {
    if (resellerSignUp.$company_classification.val() === 'other') {
      siteGlobals.animateShowVertical(resellerSignUp.$company_classification_other);
      resellerSignUp.$company_classification_other.find('input').removeProp('tabindex');
    }
    else {
      siteGlobals.animateHideVertical(resellerSignUp.$company_classification_other);
      resellerSignUp.$company_classification_other.find('input').prop('tabindex', -1);
    }
  },
  debouncedShowValidAccountFields : function() {
    if (resellerSignUp.debounce_show_timeout !== null) {
      clearTimeout(parseInt(resellerSignUp.debounce_show_timeout));
    }
    resellerSignUp.debounce_show_timeout = setTimeout(function() {
      resellerSignUp.debounce_show_timeout = null;
      resellerSignUp.showValidAccountFields();
    }, 300)
  },

  showValidAccountFields: function() {
    if (resellerSignUp.$existing_account_1.is(':checked')) {
      siteGlobals.animateShowVertical(resellerSignUp.$account_details);
      siteGlobals.animateHideVertical(resellerSignUp.$login_details);
      resellerSignUp.$company_details.removeClass('o-fade');
      resellerSignUp.$sign_up_button_container.removeClass('o-fade');
    }

    else if (resellerSignUp.$existing_account_2.is(':checked')) {
      siteGlobals.animateHideVertical(resellerSignUp.$account_details);
      siteGlobals.animateShowVertical(resellerSignUp.$login_details);
      resellerSignUp.$company_details.addClass('o-fade');
      resellerSignUp.$sign_up_button_container.addClass('o-fade');
    }
  },


  initiate: function() {
    resellerSignUp.$reseller_sign_up_form = $("#reseller-sign-up-form");
    if (resellerSignUp.$reseller_sign_up_form.length) {

      resellerSignUp.$company_details          = resellerSignUp.$reseller_sign_up_form.find('.company-details');
      resellerSignUp.$sign_up_button_container =
        resellerSignUp.$reseller_sign_up_form.find('.sign-up-button-container');

      resellerSignUp.$company_classification       = $('#company-classification');
      resellerSignUp.$company_classification_other = $('#company-classification-other');
      resellerSignUp.$logged_in                    = $('#logged-in');
      if (!resellerSignUp.$logged_in.length) {

        resellerSignUp.$existing_account_1 = $('#existing-account-1');
        resellerSignUp.$existing_account_2 = $('#existing-account-2');
        resellerSignUp.$account_details    = $('#account-details');
        resellerSignUp.$login_details      = $('#login-details');

        siteGlobals.instantHideVertical(resellerSignUp.$login_details);
        resellerSignUp.$login_details.removeClass('invisible');
        resellerSignUp.$login_details.insertBefore(resellerSignUp.$account_details);

        resellerSignUp.showValidAccountFields();

        resellerSignUp.$existing_account_1.on('input change blur keyup',function() {
          resellerSignUp.debouncedShowValidAccountFields();
        });
        resellerSignUp.$existing_account_2.on('input change blur keyup',function() {
          resellerSignUp.debouncedShowValidAccountFields();
        });
      }
      if (resellerSignUp.$company_classification.val() !== 'other') {
        siteGlobals.instantHideVertical(resellerSignUp.$company_classification_other);
        resellerSignUp.$company_classification_other.find('input').prop('tabindex', -1);
      }
      resellerSignUp.$company_classification.on('input change blur keyup',function() {
        resellerSignUp.debouncedShowOtherClassification();
      });

    }
  }
};

resellerSignUp.initiate();

/* resources/assets/js/app/passwordStrength.js */
/**
 * Created by Skeets on 5/18/2017.
 */
var $passwordStrengthMeter = $(".passwordStrengthMeter");
if ($passwordStrengthMeter.length) {

    var $passwordInput = $("input[name=new_password]");

    if (!$passwordInput.length) {
        $passwordInput = $("input[name=password]");
    }

    var passwordMinLength = $passwordInput.attr("data-min-length") || 12;


    // code adapted from: https://bootsnipp.com/snippets/featured/password-strength-popover (MIT licence)
    //minimum  characters
    var passwordMeter_bad = new RegExp("(?=.{" + passwordMinLength + ",}).*");
// Alpha Numeric + minimum length
    var passwordMeter_good = new RegExp(
        "^(?=\\S*?[a-z])(?=\\S*?[0-9])\\S{" + passwordMinLength + ",}$"
    );
// Upper + lower + (number OR special char)
    var passwordMeter_better = new RegExp(
        "^(?=\\S*?[A-Z])(?=\\S*?[a-z])((?=\\S*?[0-9])|(?=\\S*?[\\W_]))\\S{" + passwordMinLength + ",}$"
    );
// Upper + lower + number AND special char
    var passwordMeter_best = new RegExp(
        "^(?=\\S*?[A-Z])(?=\\S*?[a-z])(?=\\S*?[0-9])(?=\\S*?[\\W_])\\S{" + passwordMinLength + ",}$"
    );
    $passwordInput.on('input change blur keyup', function () {

        var strength = publicText("Weak");
        var pclass = 'danger';

        var pass = $passwordInput.val();
        if (passwordMeter_best.test(pass) == true) {
            strength = publicText("Very strong");
            // Never hide the password error: esp:291858
            // $("[data-error-bag-for=password]").hide();
            pclass = 'success';
        } else if (passwordMeter_better.test(pass) == true) {
            strength = publicText("Almost strong");
            pclass = 'warning';
            $("[data-error-bag-for=password]").show();
        } else if (passwordMeter_good.test(pass) == true) {
            strength = publicText("Almost strong");
            pclass = 'warning';
            $("[data-error-bag-for=password]").show();
        } else if (passwordMeter_bad.test(pass) == true) {
            strength = publicText("Weak");
            $("[data-error-bag-for=password]").show();
        } else {
            strength = publicText("Very weak");
            $("[data-error-bag-for=password]").show();
        }


        $passwordStrengthMeter.html(strength);
        $passwordStrengthMeter.addClass("alert");
        $passwordStrengthMeter.removeClass("alert-success");
        $passwordStrengthMeter.removeClass("alert-warning");
        $passwordStrengthMeter.removeClass("alert-danger");
        $passwordStrengthMeter.removeClass("alert-info");
        $passwordStrengthMeter.addClass("alert-" + pclass);

        if (pass.length === 0) {
            $passwordStrengthMeter.hide();
        } else {
            $passwordStrengthMeter.show();
        }

    });
}

/* resources/assets/js/app/contact.js */
function showContactMethod(method) {
    if (method != 'contact_call') {
        $('#contact_call').css('display', 'none');
    }

    if (method != 'contact_email') {
        $('#contact_email').css('display', 'none');
    }

    if (method === 'contact_call') {
        $("#contact-call").modal("show");
    }


    $('#' + method).css('display', 'block');

    siteGlobals.reInitiate();
    var x = window.scrollX, y = window.scrollY;
    $("#subject").focus();
    window.scrollTo(x, y);

    siteGlobals.scrollToElement('#contact-method-buttons');

}

// var categories
// Categories, Subcategories, and Placeholders
var categories = {
    'general_inquiry': {
        'text': publicText("General Inquiry"),
        'showsub': false,
        'subcategories': {
            'default': {
                'text': undefined,
                'placeholder': publicText("Please describe your problem or question in detail. Where applicable, provide steps on how to reproduce the issue.")
            }
        }
    },
    'getting_started': {
        'text': publicText("Getting Started"),
        'showsub': true,
        'subcategories': {
            'setup_help': {
                'text': publicText("Service setup help"),
                'placeholder': undefined
            },
            'outbound_smtp': {
                'text': publicText("Outbound SMTP setup"),
                'placeholder': undefined
            }
        }
    },
    'receiving_mail': {
        'text': publicText("Receiving Mail"),
        'showsub': true,
        'subcategories': {
            'no_certain_messages': {
                'text': publicText("Can't receive certain message(s)*"),
                'placeholder': publicText("Please provide the To/From/Subject/Date of the expected message."),
                'require_msg_link': true // keep in sync with array in ContactRequest class
            },
            'no_mail': {
                'text': publicText("Can't receive any mail"),
                'placeholder': publicText("Please provide any error messages you have seen, and if you have made any recent changes to your mail host settings.")
            },
            'slow_mail': {
                'text': publicText("Slow delivery or mail deferring*"),
                'placeholder': publicText("Please provide the To/From/Subject/Date of the delayed message, or the raw message header.  The raw message header is best for us, and quicker for us to troubleshoot."),
                'require_msg_link': true // keep in sync with array in ContactRequest class
            },
            'not_in_quarantine': {
                'text': publicText("Message is not in the quarantine"),
                'placeholder': publicText("Please provide as many details about the message as possible. (To/From/Subject/Date)"),
                'hide': ["#select-message-alert"],
                'show': ["#missing-message-alert"]
            }
        }
    },
    'sending_mail': {
        'text': publicText("Sending Mail"),
        'showsub': true,
        'subcategories': {
            'cant_send': {
                'text': publicText("Can't send any mail"),
                'placeholder': undefined
            },
            'outbound_setup': {
                'text': publicText("Outbound SMTP setup"),
                'placeholder': undefined
            }
        }
    },
    'filtering_issues': {
        'text': publicText("Filtering Issues"),
        'showsub': true,
        'subcategories': {
            'better_tuning': {
                'text': publicText("Tuning for better accuracy"),
                'placeholder': undefined
            },
            'receiving_spam': {
                'text': publicText("Spam message received"),
                'placeholder': undefined,
                'require_msg_link': true // keep in sync with array in ContactRequest class

                // 'placeholder': publicText("Please provide at least one example of a Spam Message you are seeing (either the To/From/Subject/Date, or raw header)"),
            },
            'false_positives': {
                'text': publicText("Clean messages quarantined*"),
                'placeholder': publicText("Please provide at least one example of the false positive message you are seeing (either the To/From/Subject/Date, or the raw header)"),
                'require_msg_link': true // keep in sync with array in ContactRequest class
            },
            'general': {
                'text': publicText("General filtering questions"),
                'placeholder': undefined
            }
        }
    },
    'other': {
        'text': publicText("Other"),
        'showsub': true,
        'subcategories': {
            'reseller_questions': {
                'text': publicText("Reseller Questions"),
                'placeholder': undefined
            },
            'cp_questions': {
                'text': publicText("Control panel questions"),
                'placeholder': undefined
            },
            'bug': {
                'text': publicText("Found bug"),
                'placeholder': publicText("Please provide detailed steps on how to replicate the bug you are seeing.")
            }
        }
    }
};


// populateCategories
//
// @param selectPicker select
// @param options JSON
// @param show bool
// @returns void
// Initialize the main categories
function populateCategories(selectPicker, options, value, subVal) {
    var subCategory = false;
    if ($(selectPicker).attr("id") === "subcategory") {
        subCategory = true;
    }
    var categoryExists = typeof value !== "undefined" && value !== null && value.length && typeof categories[value] !== "undefined";
    selectPicker.options.length = 0;
    var show;
    if (categoryExists) {
        show = categories[value]["showsub"];
    } else {
        show = typeof value !== "undefined" && value !== null && value.length;
    }
    var selected = false;

    // Setup the real options
    for (index in options) {
        var new_opt = document.createElement("option");
        new_opt.textContent = options[index].text;
        new_opt.value = index;
        new_opt.disabled = false;
        if (new_opt.value === value) {
            new_opt.selected = true;
            selected = true;
        }


        selectPicker.appendChild(new_opt);
    }

    // Enter the "Select an option" option
    var new_option = document.createElement("option");
    new_option.textContent = publicText(" -- select an option -- ");
    new_option.disabled = true;
    if (!selected) {
        new_option.selected = true;
    }
    new_option.value = 'disabled';
    selectPicker.insertBefore(new_option, selectPicker.firstChild);

    $('#' + selectPicker.id).selectpicker('refresh');

    // Should we show the subcategories box?
    if (!show) {
        //$('#subject_details').removeClass('hidden');
        $('#subcategory_details').addClass('hidden');
    } else {
        //$('#subject_details').addClass('hidden');
        $('#subcategory_details').removeClass('hidden');
    }
    if (categoryExists && !subCategory && show) {
        populateCategories(document.getElementById("subcategory"), categories[value]["subcategories"], subVal);
    }
}

// updateSubmit
//
// @returns void
function updateSubmit() {
    var subcat = document.getElementById('subcategory');
    var createTicket = document.getElementById("received-spam-create-ticket").checked;
    // If they want to report missed spam, disable the submit button
    // If subcategory = receiving_spam
    if (subcat === null) {
        return;
    }
    if (subcat.value === 'receiving_spam') {

        $("#message-attachment-wrapper").hide();
        $("#specific-messages-box").hide();
        $("#report-spam-box").show();


        if (createTicket) {
            $("#message_area").removeClass("d-none");
            $("#submit_button").removeClass("disabled");
            $("#contact-submit-button-wrapper").show();
            $("#report-spam-identify-message-wrapper").show();
        } else {
            $("#message_area").addClass("d-none");
            $("#contact-submit-button-wrapper").hide();
            $("#submit_button").addClass("disabled");
            $("#report-spam-identify-message-wrapper").hide();
        }
    } else {
        // Otherwise, make sure submit button is good
        $("#message_area").removeClass("d-none");
        $("#message-attachment-wrapper").show();
        $("#report-spam-box").hide();
        $("#report-spam-identify-message-wrapper").hide();


        $("#specific-messages-box").show();
        $("#submit_button").removeClass("disabled");
        $("#contact-submit-button-wrapper").show();
    }
}

// updateCategoryDisplay
//
// @returns void
// Update the subject of the message
function updateCategoryDisplay() {
    var category = document.getElementById('category');
    var subcategory = document.getElementById('subcategory');
    var category_display = document.getElementById('category-display');

    var labels = JSON.parse(category_display.getAttribute('data-labels'));
    var selectedCategory = labels[category.value];
    var selectedSubcategory = selectedCategory && selectedCategory.subcategories[subcategory.value];
    category_display.value = selectedCategory
        ? selectedCategory.label + (selectedSubcategory ? " - " + selectedSubcategory : "")
        : "";

    updateSubmit();
}

$(document).ready(function () {
    if ($("#received-spam-create-ticket").length) {
        $("#received-spam-create-ticket").on("input click change", function () {
            updateSubmit();
        });
        updateSubmit();
    }
});


// updatePlaceholder
//
// @param string subcat
// @returns void
// This populates the Message's placeholder for request data.
function updatePlaceholder(subcat) {
    $(".sub-category-show-default").show();
    $(".sub-category-hide-default").hide();

    var message = document.getElementById('message');
    var category = document.getElementById('category');
    var new_placeholder = categories[category.value]['subcategories'][subcat.value]['placeholder'];
    var hide = categories[category.value]['subcategories'][subcat.value]['hide'];
    var show = categories[category.value]['subcategories'][subcat.value]['show'];

    if (typeof new_placeholder != 'undefined') {
        message.placeholder = new_placeholder;
    } else {
        message.placeholder = categories['general_inquiry']['subcategories']['default']['placeholder'];
    }

    if (categories[category.value]['subcategories'][subcat.value].require_msg_link) {
        $("#require-msg-link").show();
        $("#no-require-msg-link").hide();
    } else {
        $("#require-msg-link").hide();
        $("#no-require-msg-link").show();
    }

    if (typeof hide !== "undefined") {
        hide.forEach(function (selector) {
            $(selector).hide();
        });
    }
    if (typeof show !== "undefined") {
        show.forEach(function (selector) {
            $(selector).show();
        });
    }

    updateCategoryDisplay();
}

if ($("#ContactSupport").length) {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');

    // Check if  IE 11 or down is used, if so, don't use the category field
    if (msie > 0 || trident > 0) {
        $('#category_details').addClass('hidden');
    } else {
        populateCategories(document.getElementById('category'), categories, $("#prev-category").val(), $("#prev-subcategory").val());
    }
}


// Auto Suggestions
var messageArea = document.getElementById('subject');
var suggestionArea = document.getElementById('suggestion_area');
var timeout = null;
if (messageArea !== null) {
    messageArea.oninput = function (e) {
        clearTimeout(timeout);
        $(suggestionArea)
            .html("<div style=\"height: 100%; width: 100%;\" class=\"d-flex align-items-center justify-content-center\"><h4 ><i class='fa fa-circle-notch fa-spin'></i></h4></div>");
        timeout = setTimeout(function () {
            $.post("/support/suggest",
                {
                    content: messageArea.value
                },
                function (data, status) {
                    suggestionArea.innerHTML = data['articles'];

                    console.log(data['articles']);

                    if (typeof data['articles'] === 'undefined' || data['articles'].indexOf("NoRecord") !== -1 || data['articles'].length < 1) {
                        if (messageArea.value.length) {
                            suggestionArea.innerHTML =
                                "<div style=\"height: 100%; width: 100%;\" class=\"d-flex align-items-center justify-content-center\"><h4 class=\"text-muted\">No results</h4></div>";
                        } else {
                            suggestionArea.innerHTML =
                                "<div style=\"height: 100%; width: 100%;\" class=\"d-flex align-items-center justify-content-center\"><h4 class=\"text-muted text-center\">Enter question description for results</h4></div>";
                        }
                    }
                    // else {
                    //     suggestionArea.innerHTML += "<h3>Do any of the above articles answer your question?</h3>";
                    // }
                })
        }, 800);
    };
}

$(".open-at-start").modal("show");

/* resources/assets/js/app/existing_order_details.js */
var existing_order_details = {
  $ui_radios : null,
  $ui_radio_1: null,
  $ui_radio_2: null,

  $billing_methods : null,
  $billing_method_1: null,
  $billing_method_2: null,
  $billing_method_3: null,

  $billing_panel_toggle_1: null,
  $billing_panel_toggle_2: null,

  $billing_panel_heading_1: null,
  $billing_panel_heading_2: null,

  $account: null,

  $billing_address_form: null,

  $cc_inputs             : null,
  $ach_inputs            : null,
  $billing_address_inputs: null,

  click_loop_breaker: false,

  click_loop_breaker_timeout: null,

  click_loop_breaker_activate: function() {
    existing_order_details.click_loop_breaker = true;

    if (existing_order_details.click_loop_breaker_timeout != null) {
      // clear the timeout, if one is pending
      clearTimeout(parseInt(existing_order_details.click_loop_breaker_timeout));
      existing_order_details.click_loop_breaker_timeout = null;
    }

    //start a time out to let them continue without filling out the form or waiting the minimum time
    existing_order_details.click_loop_breaker_timeout = setTimeout(function() {
      existing_order_details.click_loop_breaker = false;
    }, 20);
  },


  initiate: function() {
    if ($('#existing-customer-order-details').length) {

      //----------------------------------------------------------------------------------
      // initialize jquery selections
      //----------------------------------------------------------------------------------
      existing_order_details.$ui_radios  = $('#ui-radio-1, #ui-radio-2');
      existing_order_details.$ui_radio_1 = $('#ui-radio-1');
      existing_order_details.$ui_radio_2 = $('#ui-radio-2');


      existing_order_details.$billing_methods  = $('#billing-method-1, #billing-method-2, #billing-method-3');
      existing_order_details.$billing_method_1 = $('#billing-method-1');
      existing_order_details.$billing_method_2 = $('#billing-method-2');
      existing_order_details.$billing_method_3 = $('#billing-method-3');
      existing_order_details.$billing_method_4 = $('#billing-method-4');

      existing_order_details.$billing_panel_toggle_1 = $('#billing-method-panel-heading-1');
      existing_order_details.$billing_panel_toggle_2 = $('#billing-method-panel-heading-2');

      existing_order_details.$billing_panel_heading_1 =
        existing_order_details.$billing_panel_toggle_1.closest('.card-header');
      existing_order_details.$billing_panel_heading_2 =
        existing_order_details.$billing_panel_toggle_2.closest('.card-header');

      existing_order_details.$account = $('#account');

      existing_order_details.$billing_address_form = $('#billing-address-form');

      existing_order_details.$billing_address_inputs =
        existing_order_details.$billing_address_form.find('input, select');
      existing_order_details.$cc_inputs              = $('.cc');
      existing_order_details.$ach_inputs             = $('.ach');

      //----------------------------------------------------------------------------------
      // initialize event listeners
      //----------------------------------------------------------------------------------


      existing_order_details.$ui_radios.on('input change blur keyup', function() {
        if (existing_order_details.$ui_radio_1.is(':checked')) {
          existing_order_details.$billing_method_1.click();
        }
        else {
          if (!existing_order_details.$billing_method_2.is(':checked') &&
              !existing_order_details.$billing_method_3.is(':checked')) {
            existing_order_details.$billing_method_4.click();
          }
        }
      });

      //----------------------------------------------------------------------------------
      existing_order_details.$billing_panel_heading_1.click(function() {
        if (!existing_order_details.click_loop_breaker) {
          existing_order_details.click_loop_breaker_activate();
          existing_order_details.$billing_method_1.click();
          existing_order_details.$billing_panel_toggle_1.click();
        }
      });
      existing_order_details.$billing_panel_heading_2.click(function() {
        if (!existing_order_details.click_loop_breaker) {
          existing_order_details.click_loop_breaker_activate();
          if (!existing_order_details.$billing_method_2.is(':checked') &&
              !existing_order_details.$billing_method_3.is(':checked')) {
            existing_order_details.$billing_method_2.click();
            existing_order_details.$billing_panel_toggle_2.click();
          }
        }
      });
      //----------------------------------------------------------------------------------

      existing_order_details.$billing_methods.on('input change blur keyup', function() {
        if (existing_order_details.$billing_method_1.is(':checked')) {
          existing_order_details.$account.removeClass('disabled').siblings('.bootstrap-select').removeClass('disabled');
          existing_order_details.$billing_address_form.css('position', 'absolute');
          existing_order_details.$ui_radio_1.click();
          existing_order_details.$billing_address_inputs.attr('tabindex', '-1');
          existing_order_details.$cc_inputs.attr('tabindex', '-1');
          existing_order_details.$ach_inputs.attr('tabindex', '-1');
        }
        else {
          existing_order_details.$account.addClass('disabled').siblings('.bootstrap-select').addClass('disabled');
          existing_order_details.$billing_address_form.css('position', '');
          existing_order_details.$ui_radio_2.click();
          existing_order_details.$billing_address_inputs.attr('tabindex', '');
          if (existing_order_details.$billing_method_2.is(':checked')) {
            existing_order_details.$cc_inputs.attr('tabindex', '');
            existing_order_details.$ach_inputs.attr('tabindex', '-1');
          }
          if (existing_order_details.$billing_method_3.is(':checked')) {
            existing_order_details.$cc_inputs.attr('tabindex', '-1');
            existing_order_details.$ach_inputs.attr('tabindex', '');
          }
        }
      });
      //----------------------------------------------------------------------------------

      existing_order_details.$account.on('input change blur keyup', function() {
        existing_order_details.$ui_radio_1.click();
      });
      //----------------------------------------------------------------------------------
      if (existing_order_details.$billing_method_2.is(':checked') ||
          existing_order_details.$billing_method_3.is(':checked')) {
        existing_order_details.$ui_radio_2.click();
        existing_order_details.$billing_address_form.css('position', '');
        if (existing_order_details.$billing_method_2.is(':checked')) {
          existing_order_details.$cc_inputs.attr('tabindex', '');
          existing_order_details.$ach_inputs.attr('tabindex', '-1');
        }
        if (existing_order_details.$billing_method_3.is(':checked')) {
          existing_order_details.$cc_inputs.attr('tabindex', '-1');
          existing_order_details.$ach_inputs.attr('tabindex', '');
        }
      }

      //  End of if statement wrapping container
    }
  }
};
existing_order_details.initiate();

/* resources/assets/js/app/reseller_order_details.js */
var reseller_order_details = {

      $subaccount_add_new_radios: null,
      $subaccount_add_new_1     : null,
      $subaccount_add_new_2     : null,

      $subAccount: null,

      $subaccount_toggle_open : null,
      $subaccount_toggle_close: null,

      $subaccount_add_new_check: null,

      $subuser_add_new_form: null,
      // $subuser_add_new_form_toggle: null,
      $subuser_add_new     : null,
      $subuser_fieldset    : null,

      click_loop_breaker: false,

      click_loop_breaker_timeout: null,

      click_loop_breaker_activate: function() {
        reseller_order_details.click_loop_breaker = true;

        if (reseller_order_details.click_loop_breaker_timeout != null) {
          // clear the timeout, if one is pending
          clearTimeout(parseInt(reseller_order_details.click_loop_breaker_timeout));
          reseller_order_details.click_loop_breaker_timeout = null;
        }

        //start a time out to let them continue without filling out the form or waiting the minimum time
        reseller_order_details.click_loop_breaker_timeout = setTimeout(function() {
          reseller_order_details.click_loop_breaker = false;
        }, 20);
      },

      initiate: function() {
        if ($('#reseller-order-details').length) {

          //----------------------------------------------------------------------------------
          // initialize jquery selections
          //----------------------------------------------------------------------------------


          reseller_order_details.$subaccount_add_new_radios = $('#subaccount-add-new-1, #subaccount-add-new-2');
          reseller_order_details.$subaccount_add_new_1      = $('#subaccount-add-new-1');
          reseller_order_details.$subaccount_add_new_2      = $('#subaccount-add-new-2');


          reseller_order_details.$subaccount_add_new_check = $('#subaccount-add-new-check');

          reseller_order_details.$subaccount_toggle_open  = $('#subaccount-toggle-open');
          reseller_order_details.$subaccount_toggle_close = $('#subaccount-toggle-close');

          reseller_order_details.$subuser_add_new_form        = $('#subuser-add-new-form');
          reseller_order_details.$subuser_add_new_form_toggle = $('#subuser-add-new-form-toggle');
          reseller_order_details.$subuser_add_new             = $('#subuser-add-new');
          reseller_order_details.$subuser_fieldset            = $('#subuser-fieldset');

          reseller_order_details.$subAccount = $('#subaccount');


          //----------------------------------------------------------------------------------
          // initialize event listeners
          //----------------------------------------------------------------------------------

          //----------------------------------------------------------------------------------
          reseller_order_details.$subaccount_toggle_open.click(function() {
            if (!reseller_order_details.click_loop_breaker) {
              reseller_order_details.click_loop_breaker_activate();
              reseller_order_details.$subaccount_add_new_1.click();
            }
          });
          reseller_order_details.$subaccount_toggle_close.click(function() {
            if (!reseller_order_details.click_loop_breaker) {
              reseller_order_details.click_loop_breaker_activate();
              reseller_order_details.$subaccount_add_new_2.click();
            }
          });

          // reseller_order_details.$subuser_add_new_form_toggle.click(function()
          // {
          //   if (!reseller_order_details.click_loop_breaker) {
          //     reseller_order_details.click_loop_breaker_activate();
          //     reseller_order_details.$subaccount_add_new_2.click();
          //   }
          // });

          // //----------------------------------------------------------------------------------


          reseller_order_details.$subuser_add_new
                                .on('input change blur keyup', function() {
                                  if (reseller_order_details.$subuser_add_new.is(':checked')) {
                                    reseller_order_details.$subuser_fieldset
                                                          .removeClass('closed');
                                    reseller_order_details.$subuser_add_new_form.collapse('show');

                                  }
                                  else {
                                    reseller_order_details.$subuser_fieldset
                                                          .addClass('closed');
                                    reseller_order_details.$subuser_add_new_form.collapse('hide');
                                  }
                                });

          reseller_order_details.$subAccount.click(function(e) {
            reseller_order_details.$subaccount_add_new_2.click();
          });
          reseller_order_details.$subAccount.on('input change blur keyup', function() {
            reseller_order_details.$subaccount_add_new_2.click();
          });


          reseller_order_details.$subaccount_add_new_radios.on('change input click', function() {
            if (reseller_order_details.$subaccount_add_new_1.is(':checked')) {
              reseller_order_details.$subaccount_add_new_check.collapse('show');
            }
            else {
              reseller_order_details.$subaccount_add_new_check.collapse('hide');
            }
            if (reseller_order_details.$subaccount_add_new_2.is(':checked')) {
              reseller_order_details.$subAccount.removeClass('disabled').data("selectpicker").$newElement.removeClass('disabled');
            }
            else {
              reseller_order_details.$subAccount.addClass('disabled').data("selectpicker").$newElement.addClass('disabled');
            }
          });

        }
      }
    }
;
reseller_order_details.initiate();

/* resources/assets/js/app/finalize_order.js */
var orderFinalizePage = {
  $finalize_order_display: null,
  $process_bar           : null,
  $process_bar_container : null,
  $progress_bar          : null,
  $process_status_domain : null,
  $process_status_text   : null,
  status                 : null,

  checkOrderStatus: function() {
    $.ajax({
      url       : siteGlobals.url + '/check-status',
      type      : "POST",
      beforeSend: function(xhr) {
        return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
      },
      success   : function(response) {
        if (response['orderStatus']['status'] === 'error') {
          setTimeout(function() {
            window.location.assign(response['error_page']);
          }, 0);
          return;
        }

        var domain               = response['orderStatus']['domain'];
        var status               = response['orderStatus']['statusText'];
        var percentCompleted     = response['orderStatus']['progressbar'];
        orderFinalizePage.status = response['orderStatus']['status'];

        orderFinalizePage.updateProcessBar(domain, status, percentCompleted);
        if (response['orderStatus']['status'] === 'complete') {
          if (response['autologin'] != '') {
            setTimeout(function() {
              window.location.assign(response['autologin']);
            }, 0);
          }
        }

      }
    });
  },

  updateProcessBar: function(domain, status, percentCompleted) {
    percentCompleted = Math.min(percentCompleted, 100);
    percentCompleted = Math.max(percentCompleted, 5);

    if (parseInt(orderFinalizePage.$progress_bar.attr('style').substr(7, 3)) != percentCompleted) {
      orderFinalizePage.$progress_bar.width("calc(" + percentCompleted + "% - 2px)");
    }
    domain = publicText("Setting Up Service: ") + domain;
    if (orderFinalizePage.$process_status_domain.text() != domain) {
      orderFinalizePage.$process_status_domain.text(domain);
    }
  },
  initiate        : function() {
    orderFinalizePage.$finalize_order_display = $("#finalize-order-display");
    if (orderFinalizePage.$finalize_order_display.length > 0) {
      orderFinalizePage.$process_bar           = $('#full-process-bar');
      orderFinalizePage.$progress_bar          = orderFinalizePage.$process_bar.find('.progress-bar');
      orderFinalizePage.$process_status_domain = orderFinalizePage.$process_bar.find('#process-status-domain');
      orderFinalizePage.$process_status_text   = orderFinalizePage.$process_bar.find('#process-status-text');
      orderFinalizePage.$process_bar_container = $('#process-bar-spacer');

      setInterval(orderFinalizePage.checkOrderStatus, 2000);
    }
  }
};

orderFinalizePage.initiate();

/* resources/assets/js/app/alt_billing_preferences.js */
var billingPreferencesAlt = {
  $billing_preference_alt: null,
  rate_update_timeout    : null,
  code                   : null,
  $promo_code_field      : null,
  ratesBeingChecked      : false,
  currentPromoCode       : null,

  updateRates: function() {
    // this is for existing / reseller account order forms. #tagSoYouCanFindOtherPromocodeRelatedCode
    if (billingPreferencesAlt.$promo_code_field.val().trim().length > 0) {
      siteGlobals.displayValidationErrors(billingPreferencesAlt.$promo_code_field, [publicText("Checking promo code.")], "info", "circle-notch fa-spin");
    }

    debounce(function() {
      var data = {
        code      : billingPreferencesAlt.code,
        promo_code: billingPreferencesAlt.$promo_code_field.val()
      };
      if (billingPreferencesAlt.$plan_code.length > 0) {
        data['plan_code'] = billingPreferencesAlt.$plan_code.val();
      }
      if (billingPreferencesAlt.code !== null) {
        billingPreferencesAlt.ratesBeingChecked = true;
        $.ajax({
          url       : siteGlobals.url + '/update-rates',
          type      : "POST",
          data      : data,
          beforeSend: function(xhr) {
            return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
          },
          success   : function(response) {
            var $priceElements = billingPreferencesAlt.$billing_preference_alt.find(".price-info-span");
            for (var key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key] !== "Plan does not have a monthly rate.") {
                  $priceElements.filter("." + key).text(response[key]);
                  if (key === 'perMonthMonthly') {
                    $priceElements.closest('label').removeClass('disabled');
                    $("#annual-monthly-2").removeClass('disabled');
                  }
                }
                else {
                  $priceElements.filter("." + key).text('--');
                  if (key === 'perMonthMonthly') {
                    $priceElements.filter("." + key).closest('label').addClass('disabled');
                    $("#annual-monthly-2").addClass('disabled');
                    $("#annual-monthly-1").click();
                    toast({
                      message: publicText("Monthly billing is not available with this plan."),
                      type   : 'warning',
                      time   : 4500,
                      icon   : 'info'
                    });
                  }
                }
              }
            }
            // This code is for existing account orders / reseller account orders.
            var promoError = false;
            if (!response['promo_code_is_valid']) {
              siteGlobals.displayValidationErrors(billingPreferencesAlt.$promo_code_field, [publicText("Sorry, no promotional offer was found for that code.")]);
              $("#promo-code-confirm-checkbox-wrapper").hide();
              promoError = true;
            }
            if (!response['promo_code_plan_is_valid']) {
              siteGlobals.displayValidationErrors(billingPreferencesAlt.$promo_code_field, [publicText("This plan does not qualify for this promotional offer.")]);
              $("#promo-code-confirm-checkbox-wrapper").hide();
              promoError = true;
            }
            if (!response['promo_code_domain_is_valid']) {
              siteGlobals.displayValidationErrors(billingPreferencesAlt.$promo_code_field, [publicText("Your domain does not qualify for this promotional offer.")]);
              $("#promo-code-confirm-checkbox-wrapper").hide();
              promoError = true;
            }
            if (!response['promo_code_within_limit']) {
              siteGlobals.displayValidationErrors(billingPreferencesAlt.$promo_code_field, [publicText("Your account has already reached the limit for this promo code.")]);
              $("#promo-code-confirm-checkbox-wrapper").hide();
              promoError = true;
            }
            if (!promoError) {

              if (billingPreferencesAlt.$promo_code_field.val().trim().length < 1) {
                siteGlobals.clearValidationErrors(billingPreferencesAlt.$promo_code_field);
              }
              else {
                var promoCodeText = publicText("Valid promo code, complete your order to apply.");
                if (typeof response.promo_code_details !== "undefined" && response.promo_code_details.length > 0) {
                  promoCodeText = response.promo_code_details;
                }
                var promoCodeCheckbox = null;
                if (typeof response.promo_code_checkbox !== "undefined" && response.promo_code_checkbox !== null
                    && response.promo_code_checkbox.length > 0) {
                  promoCodeCheckbox = response.promo_code_checkbox;
                }
                siteGlobals.displayValidationErrors(billingPreferencesAlt.$promo_code_field, [promoCodeText], "success", "check");
                if (promoCodeCheckbox === null) {
                  $("#promo-code-confirm-checkbox-wrapper").hide();
                }
                else {
                  $("#promo-code-confirm-checkbox-wrapper").show();
                  $("#promo-code-confirm-checkbox-text").html(promoCodeCheckbox);
                }
              }
            }
            billingPreferencesAlt.ratesBeingChecked = false;
          },
        });
      }
    });
  },


  initiate: function() {
    billingPreferencesAlt.$billing_preference_alt = $("#billing-preferences-alt");
    if (billingPreferencesAlt.$billing_preference_alt.length > 0) {
      billingPreferencesAlt.code              = $("#code").val();
      billingPreferencesAlt.$promo_code_field = billingPreferencesAlt.$billing_preference_alt.find("#promo_code");
      billingPreferencesAlt.$plan_code        = billingPreferencesAlt.$billing_preference_alt.find("#plan-select-box");
      if (billingPreferencesAlt.$plan_code.length > 0) {
        billingPreferencesAlt.$plan_code.on('change', function() {
          billingPreferencesAlt.updateRates();
        });
      }
      billingPreferencesAlt.$promo_code_field.on('input', function() {
        if ($(this).val() === billingPreferencesAlt.currentPromoCode) {
          return true;
        }
        $("#promo-code-confirm-checkbox-wrapper").hide();
        billingPreferencesAlt.updateRates();
        billingPreferencesAlt.currentPromoCode = $(this).val();
      }).trigger("input");
    }
  }
};

billingPreferencesAlt.initiate();

/* resources/assets/js/app/quote.js */
var quote = {

  $quote_container               : null,
  $plan_select_box               : null,
  $billing_schedule              : null,
  $plan_price_display            : null,
  $plan_renewal_price_container  : null,
  $plan_renewal_price_display    : null,
  $quarantine_users              : null,
  $quarantine_users_price_display: null,
  $monthly_inbound_emails        : null,
  $inbound_emails_price_display  : null,
  $monthly_outbound_emails       : null,
  $outbound_emails_price_display : null,
  $domains                       : null,
  $domains_display               : null,
  $total_price_display           : null,
  $total_renewal_price_container : null,
  $total_renewal_price_display   : null,
  $annual                        : null,
  $monthly                       : null,
  $inputs                        : null,
  debounceTimeout                : null,
  feature_unavailable            : false,


  plan_details             : null,
  important_feature_details: null,


  debouncedQuoteRequest: function(time) {
    if (quote.debounceTimeout !== null) {
      clearTimeout(parseInt(quote.debounceTimeout));
    }
    quote.debounceTimeout = setTimeout(function() {
      quote.debounceTimeout = null;
      quote.updateFields(false);
    }, time)
  },

  updateFields: function(default_to_included) {
    var plan_code = quote.$plan_select_box.val() === '--' ? 'sd' : quote.$plan_select_box.val();
    if (plan_code === 'et') {
      $(".quote-enterprise-hide").hide();
      $(".quote-enterprise-show").show();
    }
    else {
      $(".quote-enterprise-hide").show();
      $(".quote-enterprise-show").hide();
    }
    var billing_schedule = quote.$billing_schedule.val();
    if (billing_schedule === 'annual') {
      quote.$annual.removeClass('hidden');
      quote.$monthly.addClass('hidden');
      plan_selector.switchAnnualMonthlyRateInSelection('annual');
      plan_selector.updateRenewalRateInfo();
    }
    else {
      quote.$annual.addClass('hidden');
      quote.$monthly.removeClass('hidden');
      plan_selector.switchAnnualMonthlyRateInSelection('monthly');
      plan_selector.updateRenewalRateInfo();
    }
    if (typeof quote.plan_details[plan_code]['monthly_price'] === 'string' &&
        quote.plan_details[plan_code]['monthly_price'].length > 0) {
      quote.$billing_schedule.prop('disabled', false).find('[value=monthly]').prop('disabled', false).text(publicText("Monthly"));
      quote.$billing_schedule.closest('.row').find('.quote-label-cell').removeClass('disabled');
    }
    else {
      quote.$billing_schedule.prop('disabled', true)
           .find('[value=monthly]')
           .prop('disabled', true)
           .text(publicText("Monthly (not available for this plan)"));
      quote.$billing_schedule.closest('.row').find('.quote-label-cell').addClass('disabled');
    }
    quote.updatePlanPrice(plan_code, billing_schedule, default_to_included);
    quote.updateQuarantineUsers(plan_code, billing_schedule);
    quote.updateInboundEmails(plan_code, billing_schedule, default_to_included);
    quote.updateOutboundEmails(plan_code, billing_schedule, default_to_included);

    if (parseInt(quote.$domains.val()) > 99999) {
      quote.$domains.val(99999);
    }
    if (parseInt(quote.$domains.val()) < 2) {
      quote.$domains.val(1);
    }
    var domainsDisp = quote.$domains.val();
    if (isNaN(parseInt(quote.$domains.val()))) {
      domainsDisp = 1;
    }
    quote.$domains_display.text(domainsDisp).toLocaleString();
    quote.calculateTotal();
    if (quote.feature_unavailable === true) {
      toast({
        message: publicText("Some selected features have been reset as they are not available with this plan."),
        type   : 'warning',
        time   : 6500,
        icon   : 'info'
      });

    }
    quote.feature_unavailable = false;


    return true;
  },


  updatePlanPrice      : function(plan_code, billing_schedule, default_to_included) {
    var plan_price = quote.plan_details[plan_code];
    if (billing_schedule === 'annual') {
      if (plan_price['annual_price'] === plan_price['introductory_price']) {
        plan_price = plan_price['annual_price'];
        quote.$plan_renewal_price_container.addClass('hidden');
      }
      else {
        quote.$plan_renewal_price_container.removeClass('hidden');
        plan_price = plan_price['annual_price'];
        quote.$plan_renewal_price_display.text(plan_price.toLocaleString());
        plan_price = quote.plan_details[plan_code]['introductory_price'];
      }

    }
    else {
      quote.$plan_renewal_price_container.addClass('hidden');
      plan_price = plan_price['monthly_price'];
      if (typeof plan_price === 'undefined' || String(plan_price).length < 1) {
        quote.$billing_schedule.val('annual');
        quote.feature_unavailable = true;
        return quote.updateFields(default_to_included);
      }
    }

    quote.$plan_price_display.text(parseInt(plan_price).toLocaleString());
  },
  updateQuarantineUsers: function(plan_code, billing_schedule) {
    if (parseInt(quote.$quarantine_users.val()) > 9999999) {
      quote.$quarantine_users.val(9999999);
    }
    if (parseInt(quote.$quarantine_users.val()) < 1) {
      quote.$quarantine_users.val(0);
    }
    if (quote.important_feature_details['quarantine_users'][plan_code]['included']) {
      var quarantine_users_price = quote.$quarantine_users.val();
      quarantine_users_price *= quote.important_feature_details['quarantine_users'][plan_code]['price'];
      if (billing_schedule === 'annual') {
        quarantine_users_price *= 12; // 12 months in a year
      }
      quote.$quarantine_users_price_display.text(quarantine_users_price.toLocaleString());
      quote.$quarantine_users_price_display.closest('.row').removeClass('disabled');
    }
    else {
      quote.$quarantine_users_price_display.closest('.row').addClass('disabled');
      if (parseInt(quote.$quarantine_users.val()) !== 0) {
        quote.feature_unavailable = true;
      }
      quote.$quarantine_users.val(0);
      quote.$quarantine_users_price_display.text(0);
    }
  },
  updateInboundEmails  : function(plan_code, billing_schedule, default_to_included) {

    var inbound_included = quote.important_feature_details['inbound_emails_included'][plan_code]['alt'];
    if (default_to_included) {
      quote.$monthly_inbound_emails.val(inbound_included);
    }
    if (parseInt(quote.$monthly_inbound_emails.val()) > 99999999) {
      quote.$monthly_inbound_emails.val(99999999);
    }
    if (parseInt(quote.$monthly_inbound_emails.val()) < 1) {
      quote.$monthly_inbound_emails.val(0);
    }
    var inbound_quarantine_additional = quote.important_feature_details['overageInbound']['quarantine']['quantity'] *
                                        quote.$quarantine_users.val();
    if (plan_code === 'et') {
      inbound_quarantine_additional = 0;
    }
    var inbound_included_total = parseInt(inbound_included) + parseInt(inbound_quarantine_additional);
    var inbound_overage        = Math.max((quote.$monthly_inbound_emails.val() - inbound_included_total), 0);
    var inbound_price          = Math.ceil(inbound_overage /
                                           quote.important_feature_details['overageInbound'][plan_code]['quantity']);
    inbound_price *= quote.important_feature_details['overageInbound'][plan_code]['price'];
    if (billing_schedule === 'annual') {
      inbound_price *= 12; // 12 months in a year
    }
    quote.$inbound_emails_price_display.text(inbound_price.toLocaleString());
  },

  updateOutboundEmails: function(plan_code, billing_schedule, default_to_included) {

    if (quote.important_feature_details['outbound_service'][plan_code]['included']) {
      var outbound_included = quote.important_feature_details['outbound_emails_included'][plan_code]['alt'];
      // if (parseInt(quote.$monthly_outbound_emails.val()) < parseInt(outbound_included) || default_to_included) {
      //    quote.$monthly_outbound_emails.val(outbound_included);
      // }
      if (default_to_included) {
        quote.$monthly_outbound_emails.val(outbound_included);
      }
      if (parseInt(quote.$monthly_outbound_emails.val()) < 1) {
        quote.$monthly_outbound_emails.val(0);
      }
      if (parseInt(quote.$monthly_outbound_emails.val()) > 99999999) {
        quote.$monthly_outbound_emails.val(99999999);
      }
      var outbound_quarantine_additional = quote.important_feature_details['overageOutbound']['quarantine']['quantity'] *
                                           quote.$quarantine_users.val();
      if (plan_code === 'et') {
        outbound_quarantine_additional = 0;
      }
      var outbound_included_total = parseInt(outbound_included) + parseInt(outbound_quarantine_additional);
      var outbound_overage        = Math.max((quote.$monthly_outbound_emails.val() - outbound_included_total), 0);
      var outbound_price          = Math.ceil(outbound_overage /
                                              quote.important_feature_details['overageOutbound'][plan_code]['quantity']);
      outbound_price *= quote.important_feature_details['overageOutbound'][plan_code]['price'];
      if (billing_schedule === 'annual') {
        outbound_price *= 12; // 12 months in a year
      }
      quote.$monthly_outbound_emails.closest('.row').removeClass('disabled');
      quote.$outbound_emails_price_display.text(outbound_price.toLocaleString());

    }
    else {
      quote.$monthly_outbound_emails.closest('.row').addClass('disabled');
      if (parseInt(quote.$monthly_outbound_emails.val()) !== 0) {
        quote.feature_unavailable = true;
      }
      quote.$monthly_outbound_emails.val(0);
      quote.$outbound_emails_price_display.text(0);
    }
  },


  calculateTotal: function() {
    quote.$total_price_display.text(((parseInt(quote.$plan_price_display.text().replace(/\D/g, ""))
                                      + parseInt(quote.$quarantine_users_price_display.text().replace(/\D/g, ""))
                                      + parseInt(quote.$inbound_emails_price_display.text().replace(/\D/g, ""))
                                      + parseInt(quote.$outbound_emails_price_display.text().replace(/\D/g, "")))
                                     * parseInt(quote.$domains_display.text().replace(/\D/g, ""))).toLocaleString());
    if (quote.$plan_renewal_price_container.hasClass('hidden')) {
      quote.$total_renewal_price_container.addClass('hidden');
    }
    else {
      quote.$total_renewal_price_display.text(((parseInt(quote.$plan_renewal_price_display.text().replace(/\D/g, ""))
                                                + parseInt(quote.$quarantine_users_price_display.text().replace(/\D/g, ""))
                                                + parseInt(quote.$inbound_emails_price_display.text().replace(/\D/g, ""))
                                                + parseInt(quote.$outbound_emails_price_display.text().replace(/\D/g, "")))
                                               * parseInt(quote.$domains_display.text().replace(/\D/g, ""))).toLocaleString());
      quote.$total_renewal_price_container.removeClass('hidden');
    }
  },

  initialize: function() {
    quote.$quote_container = $('#quote-container');
    if (quote.$quote_container.length >= 1) {

      quote.plan_details              = blade_layout['quote']['plan_details'];
      quote.important_feature_details = blade_layout['quote']['important_feature_details'];

      quote.$plan_select_box                = quote.$quote_container.find('#plan-select-box');
      quote.$billing_schedule               = quote.$quote_container.find('#billing-schedule');
      quote.$plan_price_display             = quote.$quote_container.find('#plan-price-display');
      quote.$plan_renewal_price_container   = quote.$quote_container.find('#plan-renewal-price-container');
      quote.$plan_renewal_price_display     = quote.$quote_container.find('#plan-renewal-price-display');
      quote.$quarantine_users               = quote.$quote_container.find('#quarantine-users');
      quote.$quarantine_users_price_display = quote.$quote_container.find('#quarantine-users-price-display');
      quote.$monthly_inbound_emails         = quote.$quote_container.find('#monthly-inbound-emails');
      quote.$inbound_emails_price_display   = quote.$quote_container.find('#inbound-emails-price-display');
      quote.$monthly_outbound_emails        = quote.$quote_container.find('#monthly-outbound-emails');
      quote.$outbound_emails_price_display  = quote.$quote_container.find('#outbound-emails-price-display');
      quote.$domains                        = quote.$quote_container.find('#domains');
      quote.$domains_display                = quote.$quote_container.find('#domains-display');
      quote.$total_price_display            = quote.$quote_container.find('#total-price-display');
      quote.$total_renewal_price_container  = quote.$quote_container.find('#total-renewal-price-container');
      quote.$total_renewal_price_display    = quote.$quote_container.find('#total-renewal-price-display');
      quote.$annual                         = quote.$quote_container.find('.annual');
      quote.$monthly                        = quote.$quote_container.find('.monthly');

      quote.$inputs = quote.$quote_container.find('input,select');

      quote.$inputs.on('change blur', function() {
        quote.debouncedQuoteRequest(50);
      });
      quote.$inputs.on('keydown keyup', function() {
        quote.debouncedQuoteRequest(300);
      });

      quote.$quote_container.find('#calculate-button').click(function() {
        quote.updateFields(false)
      });

      quote.$plan_select_box.on('input change blur keyup', function() {
        quote.updateFields(true);
      });
      quote.updateFields(true);
    }
  }

};


quote.initialize();

/* resources/assets/js/app/cookie_notice.js */
var cookie_notice = {
  $section: null,

  initialize: function() {
    cookie_notice.$section = $('#site-wide-cookie-notice');
    setTimeout(function() {
      cookie_notice.$section.removeClass('animate-notice');
      setTimeout(function() {
        cookie_notice.$section.addClass('animate-close');
      }, 1250);
    }, 750);
    if (cookie_notice.$section.length >= 1) {
      $("#dismiss-site-wide-cookie-notice-button").click(
        function() {
          $.ajax({
            url       : blade_layout['cookie_notice_url'],
            method    : "POST",
            async     : true,
            beforeSend: function(xhr) {
              return xhr.setRequestHeader('X-CSRF-TOKEN', siteGlobals.csrfToken)
            },
            success   : function(response) {
              cookie_notice.$section.css('bottom', '-50px');
              setTimeout(function() {
                cookie_notice.$section.remove();
              }, 350);
            }
          });
        }
      )
    }
  }
};
cookie_notice.initialize();
